import { Words } from './../interface/i18n.interface';

export const wordsList: Words = {
    'A new version of the appointments dashboard is available': {
        pt: 'Uma nova versão do dashboard de agendamentos está disponível',
        en: 'A new version of the appointments dashboard is available',
    },
    "The new dashboard counts only patients' scheduling requests, so its totals can be lower than this table: it leaves out tests made in the bot simulator, attempts the patient abandoned and restarted in the same conversation, and people who only opened the online scheduling link. Completed appointments are the same on both screens.": {
        pt: 'O novo dashboard conta só pedidos de agendamento de pacientes, por isso os totais podem ser menores que nesta tabela: ele deixa de fora testes feitos no simulador do bot, tentativas que o paciente abandonou e recomeçou na mesma conversa e quem só abriu o link do agendamento online. Os agendamentos realizados são os mesmos nas duas telas.',
        en: "The new dashboard counts only patients' scheduling requests, so its totals can be lower than this table: it leaves out tests made in the bot simulator, attempts the patient abandoned and restarted in the same conversation, and people who only opened the online scheduling link. Completed appointments are the same on both screens.",
    },
    'Back to the new version': {
        pt: 'Voltar para a nova versão',
        en: 'Back to the new version',
    },
    'Mobile Access': {
        pt: 'Acesso Mobile',
        en: 'Mobile Access',
    },
    'Create with assistant': {
        pt: 'Criar com assistente',
        en: 'Create with assistant',
    },
    'Create with AI': {
        pt: 'Criar com IA',
        en: 'Create with AI',
    },
    Generate: {
        pt: 'Gerar',
        en: 'Generate',
    },
    Examples: {
        pt: 'Exemplos',
        en: 'Examples',
    },
    'Edit in assistant': {
        pt: 'Editar no assistente',
        en: 'Edit in assistant',
    },
    'Approve and create': {
        pt: 'Aprovar e criar',
        en: 'Approve and create',
    },
    Confirm: {
        pt: 'Confirmar',
        en: 'Confirm',
    },
    'Fix before creating': {
        pt: 'Corrija antes de criar',
        en: 'Fix before creating',
    },
    'Select the matching entity': {
        pt: 'Selecione a entidade correspondente',
        en: 'Select the matching entity',
    },
    'Confirm the entities below before creating': {
        pt: 'Confirme as entidades abaixo antes de criar',
        en: 'Confirm the entities below before creating',
    },
    'Describe what you want and the assistant will draft the rule for you.': {
        pt: 'Descreva o que você quer e o assistente monta a regra para você.',
        en: 'Describe what you want and the assistant will draft the rule for you.',
    },
    'Could not generate a flow from this description. Try rephrasing it.': {
        pt: 'Não foi possível gerar um flow a partir desta descrição. Tente reformular.',
        en: 'Could not generate a flow from this description. Try rephrasing it.',
    },
    'This rule needs manual setup (destination/team). Open it in the assistant to finish.': {
        pt: 'Esta regra precisa de ajuste manual (destino/time). Abra no assistente para finalizar.',
        en: 'This rule needs manual setup (destination/team). Open it in the assistant to finish.',
    },
    'e.g. Cardiology appointments cost R$ 350 in the afternoon': {
        pt: 'ex.: Consultas de cardiologia custam R$ 350 à tarde',
        en: 'e.g. Cardiology appointments cost R$ 350 in the afternoon',
    },
    'Forward to a step': {
        pt: 'Encaminhar para uma etapa',
        en: 'Forward to a step',
    },
    'Send the conversation to another step of the bot for the selected appointments.': {
        pt: 'Envia a conversa para outra etapa do bot nos atendimentos selecionados.',
        en: 'Send the conversation to another step of the bot for the selected appointments.',
    },
    Forward: {
        pt: 'Encaminhamento',
        en: 'Forward',
    },
    'Select the destination of the conversation.': {
        pt: 'Selecione o destino da conversa.',
        en: 'Select the destination of the conversation.',
    },
    'Select a destination interaction': {
        pt: 'Selecione uma interação de destino',
        en: 'Select a destination interaction',
    },
    'Forwards the conversation to another step': {
        pt: 'Encaminha a conversa para outra etapa',
        en: 'Forwards the conversation to another step',
    },
    'Patient guidance': {
        pt: 'Orientações ao paciente',
        en: 'Patient guidance',
    },
    'Skip if only one option': {
        pt: 'Pular se houver apenas uma opção',
        en: 'Skip if only one option',
    },
    'Skip if there are no options': {
        pt: 'Pular se não houver opções',
        en: 'Skip if there are no options',
    },
    Guidance: {
        pt: 'Orientações',
        en: 'Guidance',
    },
    'Create rule': {
        pt: 'Criar regra',
        en: 'Create rule',
    },
    'Change objective': {
        pt: 'Trocar objetivo',
        en: 'Change objective',
    },
    'Change objectives': {
        pt: 'Trocar objetivos',
        en: 'Change objectives',
    },
    'What do you want to set up? Select one or more objectives and we will guide you.': {
        pt: 'O que você quer configurar? Selecione um ou mais objetivos e nós te guiamos.',
        en: 'What do you want to set up? Select one or more objectives and we will guide you.',
    },
    'Different objective types will be saved as separate flows.': {
        pt: 'Objetivos de tipos diferentes serão salvos como flows separados.',
        en: 'Different objective types will be saved as separate flows.',
    },
    Review: {
        pt: 'Revisão',
        en: 'Review',
    },
    Conditions: {
        pt: 'Condições',
        en: 'Conditions',
    },
    'What do you want to set up? Choose an objective and we will guide you.': {
        pt: 'O que você quer configurar? Escolha um objetivo e nós te guiamos.',
        en: 'What do you want to set up? Choose an objective and we will guide you.',
    },
    'Set a price': {
        pt: 'Definir um preço',
        en: 'Set a price',
    },
    'Define the value shown to the patient for the selected appointments.': {
        pt: 'Defina o valor exibido ao paciente para os atendimentos selecionados.',
        en: 'Define the value shown to the patient for the selected appointments.',
    },
    'Block appointments': {
        pt: 'Bloquear atendimentos',
        en: 'Block appointments',
    },
    'Prevent the selected appointments from being offered to the patient.': {
        pt: 'Impede que os atendimentos selecionados sejam oferecidos ao paciente.',
        en: 'Prevent the selected appointments from being offered to the patient.',
    },
    'Transfer to a team': {
        pt: 'Transferir para um time',
        en: 'Transfer to a team',
    },
    'Send the conversation to a specific team for the selected appointments.': {
        pt: 'Envia a conversa para um time específico nos atendimentos selecionados.',
        en: 'Send the conversation to a specific team for the selected appointments.',
    },
    Price: {
        pt: 'Preço',
        en: 'Price',
    },
    Block: {
        pt: 'Bloqueio',
        en: 'Block',
    },
    'The price will be shown to the patient when confirming the selected time for the appointments above.': {
        pt: 'O preço será exibido ao paciente ao confirmar o horário selecionado para os atendimentos acima.',
        en: 'The price will be shown to the patient when confirming the selected time for the appointments above.',
    },
    'e.g. R$ 200,00': {
        pt: 'ex: R$ 200,00',
        en: 'e.g. R$ 200.00',
    },
    'Address shown on confirmation (optional)': {
        pt: 'Endereço exibido na confirmação (opcional)',
        en: 'Address shown on confirmation (optional)',
    },
    'The appointments matching the filters in the previous steps will not be offered to the patient. There is no extra configuration for this objective.':
        {
            pt: 'Os atendimentos que casarem com os filtros das etapas anteriores não serão oferecidos ao paciente. Não há configuração extra para este objetivo.',
            en: 'The appointments matching the filters in the previous steps will not be offered to the patient. There is no extra configuration for this objective.',
        },
    'The conversation will be transferred to the selected team.': {
        pt: 'A conversa será transferida para o time selecionado.',
        en: 'The conversation will be transferred to the selected team.',
    },
    'Select for which appointments this rule applies. Leave empty to apply to all.': {
        pt: 'Selecione para quais atendimentos esta regra se aplica. Deixe vazio para aplicar a todos.',
        en: 'Select for which appointments this rule applies. Leave empty to apply to all.',
    },
    'All conditions are optional. They narrow down when the rule applies.': {
        pt: 'Todas as condições são opcionais. Elas restringem quando a regra se aplica.',
        en: 'All conditions are optional. They narrow down when the rule applies.',
    },
    'Advanced options': {
        pt: 'Opções avançadas',
        en: 'Advanced options',
    },
    'These appointments will not be offered': {
        pt: 'Estes atendimentos não serão oferecidos',
        en: 'These appointments will not be offered',
    },
    'Applies to all appointments (no filters)': {
        pt: 'Aplica-se a todos os atendimentos (sem filtros)',
        en: 'Applies to all appointments (no filters)',
    },
    'Select at least one appointment or condition for this rule.': {
        pt: 'Selecione ao menos um atendimento ou condição para esta regra.',
        en: 'Select at least one appointment or condition for this rule.',
    },
    'Flow created successfully': {
        pt: 'Fluxo criado com sucesso',
        en: 'Flow created successfully',
    },
    'Enter a price': {
        pt: 'Informe um preço',
        en: 'Enter a price',
    },
    'Include only these appointments': {
        pt: 'Incluir somente estes atendimentos',
        en: 'Include only these appointments',
    },
    Restrictions: {
        pt: 'Restrições',
        en: 'Restrictions',
    },
    'Transfers to a team': {
        pt: 'Transfere para um time',
        en: 'Transfers to a team',
    },
    'No extra configuration': {
        pt: 'Sem configuração adicional',
        en: 'No extra configuration',
    },
    'The message will be sent to the patient for the selected appointments.': {
        pt: 'A mensagem será enviada ao paciente para os atendimentos selecionados.',
        en: 'The message will be sent to the patient for the selected appointments.',
    },
    'Send a message': {
        pt: 'Enviar uma mensagem',
        en: 'Send a message',
    },
    'Send a custom message to the patient for the selected appointments.': {
        pt: 'Envie uma mensagem personalizada ao paciente para os atendimentos selecionados.',
        en: 'Send a custom message to the patient for the selected appointments.',
    },
    'Enter a message': {
        pt: 'Informe uma mensagem',
        en: 'Enter a message',
    },
    'Restrict scheduling by patient': {
        pt: 'Restringir agendamento por paciente',
        en: 'Restrict scheduling by patient',
    },
    'Age and gender are set in the Conditions step. Add blocked CPFs below. Matching patients will not be able to schedule the selected appointments.':
        {
            pt: 'Idade e sexo são definidos na etapa Condições. Adicione os CPFs bloqueados abaixo. Os pacientes correspondentes não poderão agendar os atendimentos selecionados.',
            en: 'Age and gender are set in the Conditions step. Add blocked CPFs below. Matching patients will not be able to schedule the selected appointments.',
        },
    'Restrict by patient': {
        pt: 'Restringir por paciente',
        en: 'Restrict by patient',
    },
    'Block scheduling for patients by age, gender or CPF.': {
        pt: 'Bloqueie o agendamento de pacientes por idade, sexo ou CPF.',
        en: 'Block scheduling for patients by age, gender or CPF.',
    },
    Restriction: {
        pt: 'Restrição',
        en: 'Restriction',
    },
    'Inform at least one patient restriction (CPF, age or gender)': {
        pt: 'Informe ao menos uma restrição de paciente (CPF, idade ou sexo)',
        en: 'Inform at least one patient restriction (CPF, age or gender)',
    },
    'Restricts scheduling for the configured patients': {
        pt: 'Restringe o agendamento para os pacientes configurados',
        en: 'Restricts scheduling for the configured patients',
    },
    'Edit rule': {
        pt: 'Editar regra',
        en: 'Edit rule',
    },
    'This flow is too complex for the assistant. Please edit it in advanced mode.': {
        pt: 'Este flow é complexo demais para o assistente. Edite-o no modo avançado.',
        en: 'This flow is too complex for the assistant. Please edit it in advanced mode.',
    },
    'Edit with assistant': {
        pt: 'Editar com assistente',
        en: 'Edit with assistant',
    },
    'When (If)': {
        pt: 'Quando (Se)',
        en: 'When (If)',
    },
    'Then do': {
        pt: 'Então faça',
        en: 'Then do',
    },
    'Pending before saving': {
        pt: 'Pendências antes de salvar',
        en: 'Pending before saving',
    },
    'Minimum age must be less than or equal to maximum age': {
        pt: 'A idade mínima deve ser menor ou igual à máxima',
        en: 'Minimum age must be less than or equal to maximum age',
    },
    'Step by step': {
        pt: 'Passo a passo',
        en: 'Step by step',
    },
    'Single screen': {
        pt: 'Tela única',
        en: 'Single screen',
    },
    'Rules by entity': {
        pt: 'Regras por entidade',
        en: 'Rules by entity',
    },
    'Group rules by': {
        pt: 'Agrupar regras por',
        en: 'Group rules by',
    },
    'Rules without this filter': {
        pt: 'Regras sem este filtro',
        en: 'Rules without this filter',
    },
    'No rules for this entity': {
        pt: 'Nenhuma regra para esta entidade',
        en: 'No rules for this entity',
    },
    'Rule simulator': {
        pt: 'Simulador de regra',
        en: 'Rule simulator',
    },
    'Fill in a scenario to see which rules match and the resulting price/action.': {
        pt: 'Preencha um cenário para ver quais regras casam e o preço/ação resultante.',
        en: 'Fill in a scenario to see which rules match and the resulting price/action.',
    },
    CPF: {
        pt: 'CPF',
        en: 'CPF',
    },
    'rule(s) match this scenario': {
        pt: 'regra(s) casam com este cenário',
        en: 'rule(s) match this scenario',
    },
    'No rules match this scenario': {
        pt: 'Nenhuma regra casa com este cenário',
        en: 'No rules match this scenario',
    },
    'Approximate simulation: the final resolution is done by the backend.': {
        pt: 'Simulação aproximada: a resolução final é feita pelo backend.',
        en: 'Approximate simulation: the final resolution is done by the backend.',
    },
    'overlapping rule(s) found': {
        pt: 'regra(s) sobreposta(s) encontrada(s)',
        en: 'overlapping rule(s) found',
    },
    'These rules cover the same scenario': {
        pt: 'Estas regras cobrem o mesmo cenário',
        en: 'These rules cover the same scenario',
    },
    'Resolution follows priority/order.': {
        pt: 'A resolução segue prioridade/ordem.',
        en: 'Resolution follows priority/order.',
    },
    'Validity (optional)': {
        pt: 'Vigência (opcional)',
        en: 'Validity (optional)',
    },
    'Run from date': {
        pt: 'Válido a partir de',
        en: 'Run from date',
    },
    'Run until date': {
        pt: 'Válido até',
        en: 'Run until date',
    },
    'Run from this time': {
        pt: 'A partir do horário',
        en: 'Run from this time',
    },
    'Run until time': {
        pt: 'Até o horário',
        en: 'Run until time',
    },
    'Time window': {
        pt: 'Janela de horário',
        en: 'Time window',
    },
    'Tag the conversation': {
        pt: 'Marcar conversa com tag',
        en: 'Tag the conversation',
    },
    'Add or remove a conversation tag for the selected appointments.': {
        pt: 'Adicione ou remova uma tag da conversa para os atendimentos selecionados.',
        en: 'Add or remove a conversation tag for the selected appointments.',
    },
    'The tag will be applied to the conversation when the rule matches.': {
        pt: 'A tag será aplicada à conversa quando a regra casar com o atendimento.',
        en: 'The tag will be applied to the conversation when the rule matches.',
    },
    'Tag action': {
        pt: 'Ação da tag',
        en: 'Tag action',
    },
    'Enter the tag name': {
        pt: 'Informe o nome da tag',
        en: 'Enter the tag name',
    },
    'e.g. VIP': {
        pt: 'ex.: VIP',
        en: 'e.g. VIP',
    },
    'Adds the tag': {
        pt: 'Adiciona a tag',
        en: 'Adds the tag',
    },
    'Removes the tag': {
        pt: 'Remove a tag',
        en: 'Removes the tag',
    },
    'Removes all tags': {
        pt: 'Remove todas as tags',
        en: 'Removes all tags',
    },
    'The rule only applies when the patient chooses this period (morning/afternoon) while scheduling. Leave empty to apply at any time.':
        {
            pt: 'A regra só é aplicada quando o paciente escolhe este período (manhã/tarde) ao agendar. Deixe vazio para valer em qualquer horário.',
            en: 'The rule only applies when the patient chooses this period (morning/afternoon) while scheduling. Leave empty to apply at any time.',
        },
    'Patient age at scheduling time. The rule only applies to patients at or above this age.': {
        pt: 'Idade do paciente no momento do agendamento. A regra só é aplicada a pacientes com esta idade ou mais.',
        en: 'Patient age at scheduling time. The rule only applies to patients at or above this age.',
    },
    'Patient age at scheduling time. The rule only applies to patients at or below this age.': {
        pt: 'Idade do paciente no momento do agendamento. A regra só é aplicada a pacientes com esta idade ou menos.',
        en: 'Patient age at scheduling time. The rule only applies to patients at or below this age.',
    },
    'The rule only applies to patients of this gender (M or F). Leave empty for both.': {
        pt: 'A regra só é aplicada a pacientes deste sexo (M ou F). Deixe vazio para ambos.',
        en: 'The rule only applies to patients of this gender (M or F). Leave empty for both.',
    },
    'Restricts the rule to specific stages of the bot conversation (e.g. while listing times, on cancellation). Leave empty to apply at every stage.':
        {
            pt: 'Restringe a regra a etapas específicas da conversa do bot (ex.: ao listar horários, no cancelamento). Deixe vazio para valer em todas as etapas.',
            en: 'Restricts the rule to specific stages of the bot conversation (e.g. while listing times, on cancellation). Leave empty to apply at every stage.',
        },
    'The bot only evaluates this rule within the configured dates; outside the validity it behaves as if the rule did not exist. Leave empty to always apply. Useful for campaigns and temporary prices.':
        {
            pt: 'O bot só avalia esta regra dentro das datas configuradas; fora da vigência é como se a regra não existisse. Deixe vazio para valer sempre. Útil para campanhas e preços temporários.',
            en: 'The bot only evaluates this rule within the configured dates; outside the validity it behaves as if the rule did not exist. Leave empty to always apply. Useful for campaigns and temporary prices.',
        },
    'The rule starts being applied on this date.': {
        pt: 'A regra começa a ser aplicada nesta data.',
        en: 'The rule starts being applied on this date.',
    },
    'After this date the bot stops applying the rule automatically.': {
        pt: 'Depois desta data o bot deixa de aplicar a regra automaticamente.',
        en: 'After this date the bot stops applying the rule automatically.',
    },
    'Daily time window: the rule only applies when the conversation happens between these times (every day, within the validity dates). E.g. a discount valid only from 08:00 to 12:00.':
        {
            pt: 'Janela diária de horário: a regra só é aplicada quando a conversa acontece entre estes horários (todos os dias, dentro da vigência). Ex.: um desconto válido só das 08:00 às 12:00.',
            en: 'Daily time window: the rule only applies when the conversation happens between these times (every day, within the validity dates). E.g. a discount valid only from 08:00 to 12:00.',
        },
    'End of the daily time window. After this time the rule is no longer applied on that day.': {
        pt: 'Fim da janela diária de horário. Depois deste horário a regra deixa de ser aplicada naquele dia.',
        en: 'End of the daily time window. After this time the rule is no longer applied on that day.',
    },
    'Fires the rule only on specific bot events (e.g. before ending the conversation, on active confirmation). Leave empty for the default behavior.':
        {
            pt: 'Dispara a regra apenas em eventos específicos do bot (ex.: antes de encerrar a conversa, na confirmação ativa). Deixe vazio para o comportamento padrão.',
            en: 'Fires the rule only on specific bot events (e.g. before ending the conversation, on active confirmation). Leave empty for the default behavior.',
        },
    'Multiple items in the same field work as OR (any of them matches); different fields combine as AND (all must match).':
        {
            pt: 'Vários itens no mesmo campo funcionam como OU (qualquer um casa); campos diferentes se combinam como E (todos precisam casar).',
            en: 'Multiple items in the same field work as OR (any of them matches); different fields combine as AND (all must match).',
        },
    'Shown to the patient together with the price when confirming the time.': {
        pt: 'Exibido ao paciente junto com o preço na confirmação do horário.',
        en: 'Shown to the patient together with the price when confirming the time.',
    },
    'When more than one rule matches the same appointment, the one with the highest priority wins; ties follow creation order.':
        {
            pt: 'Quando mais de uma regra casa com o mesmo atendimento, vence a de maior prioridade; empates seguem a ordem de criação.',
            en: 'When more than one rule matches the same appointment, the one with the highest priority wins; ties follow creation order.',
        },
    'Maximum number of time options the bot offers to the patient in the list.': {
        pt: 'Quantidade máxima de horários que o bot oferece ao paciente na listagem.',
        en: 'Maximum number of time options the bot offers to the patient in the list.',
    },
    'How the available times are ordered before being shown to the patient.': {
        pt: 'Como os horários disponíveis são ordenados antes de serem exibidos ao paciente.',
        en: 'How the available times are ordered before being shown to the patient.',
    },
    'Only offers times starting this many days from today (0 = today).': {
        pt: 'Só oferece horários a partir de tantos dias contados de hoje (0 = hoje).',
        en: 'Only offers times starting this many days from today (0 = today).',
    },
    'Only offers times up to this many days from today.': {
        pt: 'Só oferece horários até tantos dias contados de hoje.',
        en: 'Only offers times up to this many days from today.',
    },
    'Shuffles the order of the offered times to spread out the agenda.': {
        pt: 'Embaralha a ordem dos horários oferecidos para distribuir a agenda.',
        en: 'Shuffles the order of the offered times to spread out the agenda.',
    },
    'The bot skips the selection step and proceeds automatically, without asking the patient.': {
        pt: 'O bot pula a etapa de escolha e segue automaticamente, sem perguntar ao paciente.',
        en: 'The bot skips the selection step and proceeds automatically, without asking the patient.',
    },
    'If there is only one option available, the bot selects it automatically without asking.': {
        pt: 'Se houver apenas uma opção disponível, o bot a seleciona automaticamente sem perguntar.',
        en: 'If there is only one option available, the bot selects it automatically without asking.',
    },
    'If there are no options available, the bot skips this step instead of stopping.': {
        pt: 'Se não houver opções disponíveis, o bot pula esta etapa em vez de travar a conversa.',
        en: 'If there are no options available, the bot skips this step instead of stopping.',
    },
    'Sent to the patient when no available times are found for these appointments.': {
        pt: 'Enviada ao paciente quando não há horários disponíveis para estes atendimentos.',
        en: 'Sent to the patient when no available times are found for these appointments.',
    },
    'Guidance sent to the patient BEFORE the booking is completed (e.g. exam preparation).': {
        pt: 'Orientação enviada ao paciente ANTES de concluir o agendamento (ex.: preparo de exame).',
        en: 'Guidance sent to the patient BEFORE the booking is completed (e.g. exam preparation).',
    },
    'Guidance sent to the patient AFTER the booking is completed (e.g. arrival instructions).': {
        pt: 'Orientação enviada ao paciente DEPOIS que o agendamento é concluído (ex.: instruções de chegada).',
        en: 'Guidance sent to the patient AFTER the booking is completed (e.g. arrival instructions).',
    },
    'Sent to the patient when they confirm the appointment.': {
        pt: 'Enviada ao paciente quando ele confirma o agendamento.',
        en: 'Sent to the patient when they confirm the appointment.',
    },
    'Sent to the patient when the appointment is cancelled.': {
        pt: 'Enviada ao paciente quando o agendamento é cancelado.',
        en: 'Sent to the patient when the appointment is cancelled.',
    },
    'When the patient cancels, the bot offers to reschedule the appointment.': {
        pt: 'Quando o paciente cancela, o bot oferece reagendar o atendimento.',
        en: 'When the patient cancels, the bot offers to reschedule the appointment.',
    },
    'The bot reschedules automatically, without asking the patient.': {
        pt: 'O bot reagenda automaticamente, sem perguntar ao paciente.',
        en: 'The bot reschedules automatically, without asking the patient.',
    },
    'Cancels the original appointment when a reschedule happens.': {
        pt: 'Cancela o agendamento original quando houver reagendamento.',
        en: 'Cancels the original appointment when a reschedule happens.',
    },
    'Sends the configured guidance messages when the patient confirms the appointment.': {
        pt: 'Envia as orientações configuradas quando o paciente confirma o agendamento.',
        en: 'Sends the configured guidance messages when the patient confirms the appointment.',
    },
    'The patient cannot see these appointments in the bot.': {
        pt: 'O paciente não consegue visualizar estes agendamentos no bot.',
        en: 'The patient cannot see these appointments in the bot.',
    },
    'The patient cannot cancel these appointments through the bot.': {
        pt: 'O paciente não consegue cancelar estes agendamentos pelo bot.',
        en: 'The patient cannot cancel these appointments through the bot.',
    },
    'The patient cannot reschedule these appointments through the bot.': {
        pt: 'O paciente não consegue reagendar estes agendamentos pelo bot.',
        en: 'The patient cannot reschedule these appointments through the bot.',
    },
    'Blocks confirmation when the patient starts the conversation (passive confirmation).': {
        pt: 'Bloqueia a confirmação quando o paciente inicia a conversa (confirmação passiva).',
        en: 'Blocks confirmation when the patient starts the conversation (passive confirmation).',
    },
    'Blocks confirmation in campaigns started by the clinic (active confirmation).': {
        pt: 'Bloqueia a confirmação nas campanhas iniciadas pela clínica (confirmação ativa).',
        en: 'Blocks confirmation in campaigns started by the clinic (active confirmation).',
    },
    '"add" applies the tag to the conversation; "remove" takes a specific tag off; "remove all" clears every tag from the conversation.':
        {
            pt: '"adicionar" aplica a tag à conversa; "remover" tira uma tag específica; "remover todas" limpa todas as tags da conversa.',
            en: '"add" applies the tag to the conversation; "remove" takes a specific tag off; "remove all" clears every tag from the conversation.',
        },
    'Instead of one rule covering all selected items, creates a separate copy of the rule for each item — easier to edit or remove individually later.':
        {
            pt: 'Em vez de uma regra cobrindo todos os itens selecionados, cria uma cópia da regra para cada item — mais fácil de editar ou remover individualmente depois.',
            en: 'Instead of one rule covering all selected items, creates a separate copy of the rule for each item — easier to edit or remove individually later.',
        },
    'Publishes the rule to the homologation environment right after saving, so it can be tested before going to production. Without this, the rule stays saved but unpublished.':
        {
            pt: 'Publica a regra no ambiente de homologação logo após salvar, para testar antes de ir a produção. Sem isso, a regra fica salva porém não publicada.',
            en: 'Publishes the rule to the homologation environment right after saving, so it can be tested before going to production. Without this, the rule stays saved but unpublished.',
        },
    'Explain rule': {
        pt: 'Explicar regra',
        en: 'Explain rule',
    },
    'What this rule will do in the bot': {
        pt: 'O que esta regra vai fazer no bot',
        en: 'What this rule will do in the bot',
    },
    'Could not generate an explanation. Try again.': {
        pt: 'Não foi possível gerar a explicação. Tente novamente.',
        en: 'Could not generate an explanation. Try again.',
    },
    'Additional actions (optional)': {
        pt: 'Ações adicionais (opcional)',
        en: 'Additional actions (optional)',
    },
    Also: {
        pt: 'Também',
        en: 'Also',
    },
    'Confirmation / cancellation rules': {
        pt: 'Regras de confirmação/cancelamento',
        en: 'Confirmation / cancellation rules',
    },
    'Set messages and behavior for appointment confirmation and cancellation.': {
        pt: 'Defina mensagens e comportamento na confirmação e cancelamento do agendamento.',
        en: 'Set messages and behavior for appointment confirmation and cancellation.',
    },
    'Messages and behavior on appointment confirmation/cancellation.': {
        pt: 'Mensagens e comportamento na confirmação/cancelamento do agendamento.',
        en: 'Messages and behavior on appointment confirmation/cancellation.',
    },
    'Confirmation message': {
        pt: 'Mensagem de confirmação',
        en: 'Confirmation message',
    },
    'Cancellation message': {
        pt: 'Mensagem de cancelamento',
        en: 'Cancellation message',
    },
    'Ask to reschedule': {
        pt: 'Perguntar se deseja remarcar',
        en: 'Ask to reschedule',
    },
    'Reschedule automatically': {
        pt: 'Remarcar automaticamente',
        en: 'Reschedule automatically',
    },
    'Cancel on reschedule': {
        pt: 'Cancelar ao remarcar',
        en: 'Cancel on reschedule',
    },
    'Send guidance on confirmation': {
        pt: 'Enviar orientação na confirmação',
        en: 'Send guidance on confirmation',
    },
    'Configure at least one confirmation/cancellation option': {
        pt: 'Configure ao menos uma opção de confirmação/cancelamento',
        en: 'Configure at least one confirmation/cancellation option',
    },
    Configured: {
        pt: 'Configurado',
        en: 'Configured',
    },
    'Priority (optional)': {
        pt: 'Prioridade (opcional)',
        en: 'Priority (optional)',
    },
    'Control how available times are listed to the patient.': {
        pt: 'Controle como os horários disponíveis são listados ao paciente.',
        en: 'Control how available times are listed to the patient.',
    },
    'Limit of times': {
        pt: 'Limite de horários',
        en: 'Limit of times',
    },
    'Sort method': {
        pt: 'Método de ordenação',
        en: 'Sort method',
    },
    'Days from now': {
        pt: 'A partir de (dias)',
        en: 'Days from now',
    },
    'Days until': {
        pt: 'Até (dias)',
        en: 'Days until',
    },
    'Randomize order': {
        pt: 'Embaralhar a ordem',
        en: 'Randomize order',
    },
    'Skip time selection': {
        pt: 'Pular seleção de horário',
        en: 'Skip time selection',
    },
    'Message when no dates available': {
        pt: 'Mensagem quando não houver datas disponíveis',
        en: 'Message when no dates available',
    },
    'Block specific operations for the selected appointments.': {
        pt: 'Bloqueie operações específicas para os atendimentos selecionados.',
        en: 'Block specific operations for the selected appointments.',
    },
    'Cannot view': {
        pt: 'Não pode visualizar',
        en: 'Cannot view',
    },
    'Cannot cancel': {
        pt: 'Não pode cancelar',
        en: 'Cannot cancel',
    },
    'Cannot reschedule': {
        pt: 'Não pode remarcar',
        en: 'Cannot reschedule',
    },
    'Cannot confirm (passive)': {
        pt: 'Não pode confirmar (passivo)',
        en: 'Cannot confirm (passive)',
    },
    'Cannot confirm (active)': {
        pt: 'Não pode confirmar (ativo)',
        en: 'Cannot confirm (active)',
    },
    'Time availability': {
        pt: 'Disponibilidade de horários',
        en: 'Time availability',
    },
    'Control how available times are listed (limit, order, day window).': {
        pt: 'Controle como os horários disponíveis são listados (limite, ordem, janela de dias).',
        en: 'Control how available times are listed (limit, order, day window).',
    },
    Availability: {
        pt: 'Disponibilidade',
        en: 'Availability',
    },
    'Configure at least one availability option': {
        pt: 'Configure ao menos uma opção de disponibilidade',
        en: 'Configure at least one availability option',
    },
    'Restrict operations': {
        pt: 'Restringir operações',
        en: 'Restrict operations',
    },
    'Select at least one operation to block': {
        pt: 'Selecione ao menos uma operação para bloquear',
        en: 'Select at least one operation to block',
    },
    'Offer only these': {
        pt: 'Oferecer somente estes',
        en: 'Offer only these',
    },
    'Offer only the selected appointments to the patient.': {
        pt: 'Oferecer somente os atendimentos selecionados ao paciente.',
        en: 'Offer only the selected appointments to the patient.',
    },
    'Include only': {
        pt: 'Incluir somente',
        en: 'Include only',
    },
    'Clone with assistant': {
        pt: 'Clonar com assistente',
        en: 'Clone with assistant',
    },
    'Publish to homologation after saving': {
        pt: 'Publicar para homologação após salvar',
        en: 'Publish to homologation after saving',
    },
    'Save price': {
        pt: 'Salvar preço',
        en: 'Save price',
    },
    'Filter by objective': {
        pt: 'Filtrar por objetivo',
        en: 'Filter by objective',
    },
    'Filters the rules loaded on the current page': {
        pt: 'Filtra as regras carregadas na página atual',
        en: 'Filters the rules loaded on the current page',
    },
    'rules created': {
        pt: 'regras criadas',
        en: 'rules created',
    },
    'Create one rule per selected': {
        pt: 'Criar uma regra por',
        en: 'Create one rule per selected',
    },
    'A single rule': {
        pt: 'Uma única regra',
        en: 'A single rule',
    },
    'Template saved': {
        pt: 'Modelo salvo',
        en: 'Template saved',
    },
    'Save as template': {
        pt: 'Salvar como modelo',
        en: 'Save as template',
    },
    'Discard changes?': {
        pt: 'Descartar alterações?',
        en: 'Discard changes?',
    },
    Discard: {
        pt: 'Descartar',
        en: 'Discard',
    },
    Visualizations: {
        pt: 'Visualizações',
        en: 'Visualizations',
    },
    'Price matrix': {
        pt: 'Matriz de preços',
        en: 'Price matrix',
    },
    'Tree by entity': {
        pt: 'Árvore por entidade',
        en: 'Tree by entity',
    },
    'Validity timeline': {
        pt: 'Linha do tempo de vigências',
        en: 'Validity timeline',
    },
    'No data': {
        pt: 'Sem dados',
        en: 'No data',
    },
    'Showing up to 15 items per axis.': {
        pt: 'Exibindo até 15 itens por eixo.',
        en: 'Showing up to 15 items per axis.',
    },
    'No rules with validity period': {
        pt: 'Nenhuma regra com vigência',
        en: 'No rules with validity period',
    },
    Scheduled: {
        pt: 'Agendada',
        en: 'Scheduled',
    },
    Expired: {
        pt: 'Expirada',
        en: 'Expired',
    },
    'disabled entity(ies) selected': {
        pt: 'entidade(s) desativada(s) selecionada(s)',
        en: 'disabled entity(ies) selected',
    },
    'Only the appointments matching the filters in the previous steps will be offered to the patient.': {
        pt: 'Somente os atendimentos que casarem com os filtros das etapas anteriores serão oferecidos ao paciente.',
        en: 'Only the appointments matching the filters in the previous steps will be offered to the patient.',
    },
    'Primary actions': {
        pt: 'Ações principais',
        en: 'Primary actions',
    },
    'The dot shows whether the attendance is open, suspended or closed.': {
        pt: 'A bolinha mostra se o atendimento está aberto, suspenso ou finalizado.',
        en: 'The dot shows whether the attendance is open, suspended or closed.',
    },
    'Open attendance status': {
        pt: 'Aberto',
        en: 'Open',
    },
    'Suspended attendance status': {
        pt: 'Suspenso',
        en: 'Suspended',
    },
    'Finalized attendance status': {
        pt: 'Finalizado',
        en: 'Finalized',
    },
    'The most used buttons stay fixed here to preserve the current workflow.': {
        pt: 'Os botões mais usados ficam fixos aqui para preservar o fluxo atual.',
        en: 'The most used buttons stay fixed here to preserve the current workflow.',
    },
    'Transfers, copy and download are grouped in this menu.': {
        pt: 'Transferências, cópia e download ficaram agrupados neste menu.',
        en: 'Transfers, copy and download are grouped in this menu.',
    },
    'Reorganized menu': {
        pt: 'Menu reorganizado',
        en: 'Reorganized menu',
    },
    'Items like resume, details and other information are now organized in this collapsible menu for better organization.':
        {
            pt: 'Itens como resumo, detalhes e outras informações agora estão organizados neste menu colapsável para melhor organização.',
            en: 'Items like resume, details and other information are now organized in this collapsible menu for better organization.',
        },
    'REMI, Summary and other details are now organized in collapsible sections for better navigation.': {
        pt: 'REMI, Resumo e outros detalhes agora estão organizados em seções colapsáveis para melhor navegação.',
        en: 'REMI, Summary and other details are now organized in collapsible sections for better navigation.',
    },
    'Conversation attributes are now organized in this collapsible section.': {
        pt: 'Os atributos da conversa agora estão organizados nesta seção colapsável.',
        en: 'Conversation attributes are now organized in this collapsible section.',
    },
    'Attribute captured by AI': {
        pt: 'Atributo captado pela IA',
        en: 'Attribute captured by AI',
    },
    Deactivated: {
        pt: 'Desativado',
        en: 'Deactivated',
    },
    'Not enabled': {
        pt: 'Não habilitado',
        en: 'Not enabled',
    },
    Integrations: {
        pt: 'Integrações',
        en: 'Integrations',
    },
    'More actions': {
        pt: 'Mais ações',
        en: 'More actions',
    },
    'Copy conversation link': {
        pt: 'Copiar link da conversa',
        en: 'Copy conversation link',
    },
    'View conversation': {
        pt: 'Visualizar conversa',
        en: 'View conversation',
    },
    'Conversation preview': {
        pt: 'Visualização da conversa',
        en: 'Conversation preview',
    },
    'Conversation link copied': {
        pt: 'Link da conversa copiado',
        en: 'Conversation link copied',
    },
    'Start attendance': {
        pt: 'Iniciar atendimento',
        en: 'Start attendance',
    },
    hasRelationshipWithDoctors: {
        pt: 'Tem relação com médicos',
        en: 'Has relationship with doctors',
    },
    'Run first schedule rule': {
        pt: 'Executar regra de primeiro agendamento',
        en: 'Run first schedule rule',
    },
    'Api username': {
        pt: 'Usuário da api',
        en: 'Api username',
    },
    'Api password': {
        pt: 'Senha da api',
        en: 'Api password',
    },
    Specialities: {
        pt: 'Especialidades',
        en: 'Specialities',
    },
    'Agendamento Web': {
        pt: 'Agendamento Web',
        en: 'Web Scheduling',
    },
    'Tooltip Agendamento Web': {
        pt: 'Quando desmarcado, esta entidade não aparece no agendamento web. Continua disponível no WhatsApp.',
        en: 'When unchecked, this entity is hidden from web scheduling. It remains available on WhatsApp.',
    },
    includeOnly: {
        pt: 'Incluir apenas',
        en: 'Include only',
    },
    laterality: {
        pt: 'Lateralidade',
        en: 'laterality',
    },
    Weight: {
        pt: 'Peso',
        en: 'Weight',
    },
    'Uses correlation': {
        pt: 'Usa correlação',
        en: 'Uses correlation',
    },
    'Split Insurance Into Insurance Plans': {
        en: 'Split Insurance Into Insurance Plans',
        pt: 'Dividir convênios em planos',
    },
    'Occupation area': {
        en: 'Occupation area',
        pt: 'Area de atuação',
    },
    Location: {
        en: 'Location',
        pt: 'Localização',
    },
    occupationArea: {
        en: 'Occupation area',
        pt: 'Area de atuação',
    },
    insurance_suggestion: {
        en: 'Suggested insurance',
        pt: 'Sugestão de convênio',
    },
    doctor_suggestion: {
        en: 'Suggested doctor',
        pt: 'Sugestão de médico',
    },
    schedule_suggestion: {
        en: 'Schedule Suggestion',
        pt: 'Sugestão de horário',
    },
    wait_list: {
        en: 'Wait list',
        pt: 'Lista de espera',
    },
    occupationArea_search: {
        en: 'Occupation area search',
        pt: 'Busca da area de atuação',
    },
    organizationUnitLocation: {
        en: 'Location',
        pt: 'Localização',
    },
    organizationUnitLocation_search: {
        en: 'Location search',
        pt: 'Busca da localização',
    },
    typeOfService: {
        en: 'Type of service',
        pt: 'Tipo de serviço',
    },
    typeOfService_search: {
        en: 'Type of service search',
        pt: 'Busca do tipo de serviço',
    },
    confirmPassive: {
        pt: 'Confirmação pelo bot',
        en: 'Bot confirmation',
    },
    weekly: {
        pt: 'Semanal',
        en: 'weekly',
    },
    'Sync type': {
        pt: 'Tipo de sincronização',
        en: 'Sync type',
    },
    since: {
        pt: 'desde',
        en: 'since',
    },
    daily: {
        pt: 'Diário',
        en: 'daily',
    },
    export: {
        pt: 'Exportar',
        en: 'Export',
    },
    'Open all options': {
        pt: 'Abrir todas as opções',
        en: 'Open all options',
    },
    confirmAppointment: {
        pt: 'Confirmar horário',
        en: 'Confirm appointment',
    },
    'Send instructions to the patient after scheduling': {
        pt: 'Enviar instruções para o paciente após agendamento',
        en: 'Send instructions to the patient after scheduling',
    },
    'Uses composite code in procedures': {
        pt: 'Usa código composto em procedimentos',
        en: 'Uses composite code in procedures',
    },
    'Update patient gender when scheduling': {
        pt: 'Atualizar sexo do paciente ao agendar',
        en: 'Update patient gender when scheduling',
    },
    'Update patient email when scheduling': {
        pt: 'Atualizar email do paciente ao agendar',
        en: 'Update patient email when scheduling',
    },
    'Update patient phone when scheduling': {
        pt: 'Atualizar telefone do paciente ao agendar',
        en: 'Update patient phone when scheduling',
    },
    useWaitingList: {
        pt: 'Usar step de lista de espera',
        en: 'Use wait list step',
    },
    'There was an error starting the attendance. Check that the contact or phone number is correct': {
        en: 'There was an error starting the attendance. Check that the contact or phone number is correct',
        pt: 'Ocorreu um erro ao iniciar o atendimento. Verifique se o contato ou número de telefone estão corretos',
    },
    'An error occurred when starting the service. Try again later': {
        pt: 'Ocorreu um erro ao iniciar o atendimento. Tente novamente mais tarde',
        en: 'There was an error starting the attendance. Try again later',
    },
    'Unable to start the session because the contact is blocked and has contact restrictions.': {
        pt: 'Não é possível iniciar o atendimento, porque o contato está bloqueado e possui restrição de contato.',
        en: 'Unable to start the session because the contact is blocked and has contact restrictions.',
    },
    'Error. Try again in a few minutes': {
        pt: 'Erro. Tente novamente em alguns minutos',
        en: 'Error. Try again in a few minutes',
    },
    'Verify if the fields are correct': {
        pt: 'Verificar se os campos estão corretos',
        en: 'Verify if the fields are correct',
    },
    'Your password has expired. Define a new one below': {
        en: 'Your password has expired. Define a new one below',
        pt: 'A sua senha está expirada. Defina uma nova abaixo',
    },
    'Use procedure instead of specialty in inter appointment validation': {
        en: 'Use procedure instead of specialty in inter appointment validation',
        pt: 'Utilizar procedimento ao invés de especialidade na validação de interconsulta',
    },
    'Does not allow patient scheduling for the same day': {
        en: 'Does not allow patient scheduling for the same day',
        pt: 'Não permite agendamento do paciente para um mesmo dia',
    },
    'Does not allow patient scheduling for the same day/doctor': {
        en: 'Does not allow patient scheduling for the same day/doctor',
        pt: 'Não permite agendamento do paciente para um mesmo dia/médico',
    },
    'The password was entered incorrectly 5 times. try again in 10 minutes': {
        en: 'The password was entered incorrectly 5 times. try again in 10 minutes',
        pt: 'A senha foi digitada incorretamente 5 vezes. Tente novamente em 10 minutos',
    },
    'No attendance so far': {
        en: 'No attendance so far',
        pt: 'Nenhum atendimento até o momento',
    },
    'Set a new permanent password': {
        pt: 'Defina uma nova senha definitiva',
        en: 'Set a new permanent password',
    },
    'Unable to display contact information': {
        en: 'Unable to display contact information',
        pt: 'Não foi possível exibir informações do contato',
    },
    'This file type may be unsafe. Download only if you trust the source.': {
        en: 'This file type may be unsafe. Download only if you trust the source.',
        pt: 'Este tipo de arquivo pode ser inseguro. Baixe apenas se confiar na origem.',
    },
    'Download anyway': {
        en: 'Download anyway',
        pt: 'Baixar mesmo assim',
    },
    'Contact blocked successfully!': {
        en: 'Contact blocked successfully!',
        pt: 'Contato bloqueado com sucesso!',
    },
    'Contact unlocked successfully!': {
        en: 'Contact unlocked successfully!',
        pt: 'Contato desbloqueado com sucesso!',
    },
    "We didn't find any blocked contacts!": {
        en: "We didn't find any blocked contacts!",
        pt: 'Não encontramos nenhum contato bloqueado!',
    },
    'Filter blocked contacts': {
        en: 'Filter blocked contacts',
        pt: 'Filtrar contatos bloqueados',
    },
    'Template is being used for active messages': {
        en: 'Template is being used for active messages',
        pt: 'O Template está sendo usado para mensagens ativas',
    },
    'Remove filter': {
        en: 'Remove filter',
        pt: 'Remover filtro',
    },
    'Blocked contact': {
        en: 'Blocked contact',
        pt: 'Contato bloqueado',
    },
    Blocked: {
        en: 'Blocked',
        pt: 'Bloqueados',
    },
    'Type at least 4 characters to search by contact or click blocked!': {
        en: 'Type at least 4 characters to search by contact or click blocked!',
        pt: 'Digite pelo menos 4 caracteres para efetuar a busca por contato ou clique em bloqueados!',
    },
    'Are you sure you want to unblock this contact?': {
        en: 'Are you sure you want to unblock this contact?',
        pt: 'Tem certeza que deseja desbloquear este contato?',
    },
    'Are you sure you want to block this contact?': {
        en: 'Are you sure you want to block this contact?',
        pt: 'Tem certeza que deseja bloquear este contato?',
    },
    'Block contact': {
        en: 'Block contact',
        pt: 'Bloquear contato',
    },
    'Unblock contact': {
        en: 'Unblock contact',
        pt: 'Desbloquear contato',
    },
    'This contact is blocked!': {
        en: 'This contact is blocked.',
        pt: 'Este contato está bloqueado.',
    },
    'Send type of service on schedule': {
        en: 'Send type of service on schedule',
        pt: 'Enviar tipo de atendimento no agendamento',
    },
    'Use procedure without speciality relation': {
        en: 'Use procedure without speciality relation',
        pt: 'Usar procedimento sem relação de especialidade',
    },
    morning: {
        pt: 'Manhã',
        en: 'Morning',
    },
    afternoon: {
        pt: 'Tarde',
        en: 'Afternoon',
    },
    indifferent: {
        pt: 'Indiferente',
        en: 'Indifferent',
    },
    'Period of day': {
        pt: 'Período do dia',
        en: 'Period of day',
    },
    'Select period': {
        pt: 'Selecione um período',
        en: 'Select period',
    },
    'Maximum age': {
        en: 'Maximum age',
        pt: 'Idade máxima',
    },
    'Minimum age': {
        en: 'Minimum age',
        pt: 'Idade mínima',
    },
    Speciality: {
        pt: 'Especialidade',
        en: 'Speciality',
    },
    'Email not exists': {
        en: 'Email not exists',
        pt: 'Email inexistente',
    },
    'Workspaces you have access to. Click to browse': {
        pt: 'Clique para navegar',
        en: 'Click to browse',
    },
    Workspaces: {
        pt: 'Áreas de trabalho',
        en: 'Workspaces',
    },
    Procedures: {
        pt: 'Procedimentos',
        en: 'Procedures',
    },
    'You do not have access to this page on your': {
        en: 'You do not have access to this page on your',
        pt: 'Você não tem acesso a esta página em sua',
    },
    'current location': {
        en: 'current location',
        pt: 'localização atual',
    },
    'Go to': {
        en: 'Go to',
        pt: 'Ir para',
    },
    Next: {
        en: 'Next',
        pt: 'Próximo',
    },
    "You don't have access to any workspace": {
        en: "You don't have access to any workspace",
        pt: 'Você não tem acesso a nenhum workspace',
    },
    'Organization units': {
        pt: 'Unidades',
        en: 'Organization units',
    },
    'Error. Please try again later or talk to your supervisor': {
        en: 'Error. Please try again later or talk to your supervisor',
        pt: 'Erro. Tente novamente mais tarde ou fale com seu supervisor',
    },
    'Try again in a few minutes': {
        en: 'Try again in a few minutes',
        pt: 'Tente novamente em alguns minutos',
    },
    'This field must contain only letters (A-Z), numbers (0-9), underscores (_), and dashes (-). Special characters are not permitted.':
        {
            en: 'This field must contain only letters (A-Z), numbers (0-9), underscores (_), and dashes (-). Special characters are not permitted.',
            pt: 'Este campo deve conter apenas letras (A-Z), números (0-9), sublinhados (_) e travessões (-). Caracteres especiais não são permitidos.',
        },
    'This field must contain only letters (A-Z), numbers (0-9), and underscores (_). It cannot start with a number. Special characters are not permitted.':
        {
            en: 'This field must contain only letters (A-Z), numbers (0-9), and underscores (_). It cannot start with a number. Special characters are not permitted.',
            pt: 'Este campo deve conter apenas letras (A-Z), números (0-9) e sublinhados (_). Não pode começar com um número. Caracteres especiais não são permitidos.',
        },
    'Used to trigger this interaction by an action in another interaction': {
        en: 'Used to trigger this interaction by an action in another interaction',
        pt: 'Usado para desencadear esta interação por uma ação em outra interação',
    },
    'Add to campaign': {
        en: 'Add to campaign',
        pt: 'Adicionar a campanha',
    },
    'interactions found pending publication': {
        en: 'interactions found pending publication',
        pt: 'interações encontradas pendente de publicação',
    },
    'Enter the trigger action': {
        en: 'Enter the trigger action',
        pt: 'Digite a ação da trigger',
    },
    'Action Name': {
        en: 'Action Name',
        pt: 'Nome da Ação',
    },
    'The action field is required': {
        en: 'The action field is required',
        pt: 'O campo ação é obrigatório',
    },
    'Spaces are not allowed': {
        en: 'Spaces are not allowed',
        pt: 'Não são permitidos espaços',
    },
    'Error saving file!': {
        en: 'Error saving file!',
        pt: 'Erro ao salvar o arquivo!',
    },
    'Select file': {
        en: 'Select file',
        pt: 'Selecione um arquivo',
    },
    'This message contains file': {
        en: 'This message contains file',
        pt: 'Esta mensagem contém arquivo',
    },
    'Template is inactive': {
        en: 'Template is inactive',
        pt: 'Template inativo',
    },
    'Template sent successfully': {
        en: 'Template sent successfully',
        pt: 'Template enviado com sucesso',
    },
    'Add quick reply button': {
        en: 'Add quick reply button',
        pt: 'Adicionar botão de resposta rápida',
    },
    'Add URL button': {
        en: 'Add URL button',
        pt: 'Adicionar botão de URL',
    },
    'Add web flow button': {
        en: 'Add web flow button',
        pt: 'Adicionar botão de Fluxo web',
    },
    'Link generated by the system at send time': {
        en: 'Link generated by the system at send time',
        pt: 'Link gerado pelo sistema no envio',
    },
    'Add URL': {
        en: 'Add URL',
        pt: 'Adicione a URL',
    },
    'Quick reply': {
        en: 'Quick reply',
        pt: 'Resposta rápida',
    },
    Buttons: {
        en: 'Buttons',
        pt: 'Botões',
    },
    'Show message preview': {
        en: 'Show message preview',
        pt: 'Mostrar visualização da mensagem',
    },
    'Channel not found, contact your supervisor': {
        en: 'Channel not found, contact your supervisor',
        pt: 'Canal não encontrado, entre em contato com seu supervisor',
    },
    'Message can only be sent with a file of this type (image) or without any file!': {
        en: 'Message can only be sent with a file of this type (image) or without any file!',
        pt: 'Mensagem só poderá ser enviada com arquivo do tipo (imagem) ou sem nenhum arquivo!',
    },
    'Understand more about the templates': {
        en: 'Understand more about the templates',
        pt: 'Entenda mais sobre os templates',
    },
    'Select a status': {
        en: 'Select a status',
        pt: 'Selecione um status',
    },
    'Select a template type': {
        en: 'Select a template type',
        pt: 'Selecione um tipo de template',
    },
    'Understand more about permissions': {
        en: 'Understand more about permissions',
        pt: 'Entenda mais sobre as permissões',
    },
    Id: {
        pt: 'Id',
        en: 'Id',
    },
    reason: {
        pt: 'Motivos não agendamento',
        en: 'Reason',
    },
    'Error on delete entity': {
        pt: 'Erro ao deletar entidade',
        en: 'Error on delete entity',
    },
    'Error on delete agent': {
        pt: 'Erro ao deletar agente',
        en: 'Error on delete agent',
    },
    Insurances: {
        pt: 'Convênios',
        en: 'Insurances',
    },
    Doctors: {
        pt: 'Médicos',
        en: 'Doctors',
    },
    'Choose doctor': {
        pt: 'Escolher médico',
        en: 'Choose doctor',
    },
    'Appointment types': {
        pt: 'Tipos de agendamento',
        en: 'Appointment types',
    },
    'No integration available.': {
        pt: 'Nenhuma integração disponível.',
        en: 'No integration available.',
    },
    Save: {
        pt: 'Salvar',
        en: 'Save',
    },
    'Edit profile informations': {
        pt: 'Editar informações do perfil',
        en: 'Edit profile informations',
    },
    New: {
        pt: 'Novo',
        en: 'New',
    },
    new: {
        pt: 'Novo',
        en: 'New',
    },
    'New entity': {
        pt: 'Nova entidade',
        en: 'New entity',
    },
    'Edit entity': {
        pt: 'Editar entidade',
        en: 'Edit entity',
    },
    'Edit actions': {
        pt: 'Editar ações',
        en: 'Edit actions',
    },
    Name: {
        pt: 'Nome',
        en: 'Name',
    },
    'Friendly name': {
        pt: 'Nome de exibição',
        en: 'Display name',
    },
    'Health integration created': {
        pt: 'Integração de saúde criada',
        en: 'Health integration created',
    },
    'We get an error, try again': {
        pt: 'Houve um erro, tente novamente',
        en: 'We get an error, try again',
    },
    'Health integration updated': {
        pt: 'Integração de saúde atualizada',
        en: 'Health integration updated',
    },
    'Code integration': {
        pt: 'Código da integração',
        en: 'Code integration',
    },
    Environment: {
        pt: 'Ambiente',
        en: 'Environment',
    },
    production: {
        pt: 'Produção',
        en: 'Production',
    },
    test: {
        pt: 'Teste',
        en: 'Test',
    },
    Slug: {
        pt: 'Slug',
        en: 'Slug',
    },
    Avatar: {
        pt: 'Avatar',
        en: 'Avatar',
    },
    'Remove photo': {
        pt: 'Remover foto',
        en: 'Remove photo',
    },
    'Add photo': {
        pt: 'Adicionar foto',
        en: 'Add photo',
    },
    'Change photo': {
        pt: 'Alterar foto',
        en: 'Change photo',
    },
    'Edit profile': {
        pt: 'Editar perfil',
        en: 'Edit profile',
    },
    Language: {
        pt: 'Idioma',
        en: 'Language',
    },
    'Expand all': {
        pt: 'Expandir',
        en: 'Expand all',
    },
    'Collapse all': {
        pt: 'Recolher',
        en: 'Collapse all',
    },
    'Go back workspaces': {
        pt: 'Voltar para workspaces',
        en: 'Go back workspaces',
    },
    'Create bot': {
        pt: 'Criar bot',
        en: 'Create bot',
    },
    requestAcceptance: {
        pt: 'Solicitar aceite',
        en: 'Request acceptance',
    },
    preload: {
        pt: 'Carregar dados do paciente',
        en: 'Preload patient data',
    },
    removeAcceptance: {
        pt: 'Remover vínculo',
        en: 'Remove vincule',
    },
    Loadmore: {
        pt: 'Carregar mais...',
        en: 'Load more...',
    },
    'New bot': {
        pt: 'Novo bot',
        en: 'New bot',
    },
    'Clone bot': {
        pt: 'Clonar bot',
        en: 'Clone bot',
    },
    Back: {
        pt: 'Voltar',
        en: 'Back',
    },
    Entities: {
        pt: 'Entidades',
        en: 'Entities',
    },
    Users: {
        pt: 'Usuários',
        en: 'Users',
    },
    Profile: {
        pt: 'Perfil',
        en: 'Profile',
    },
    Logout: {
        pt: 'Sair',
        en: 'Logout',
    },
    Search: {
        pt: 'Buscar',
        en: 'Search',
    },
    characters: {
        pt: 'caracteres',
        en: 'characters',
    },
    Label: {
        pt: 'Rótulo',
        en: 'Label',
    },
    'Enter at least 4 characters to search.': {
        pt: 'Digite ao menos 4 caracteres para efetuar a busca.',
        en: 'Enter at least 4 characters to search.',
    },
    'Only messages typed by the attendant or patient will be searched.': {
        pt: 'Apenas mensagens digitados pelo atendente ou paciente serão buscados.',
        en: 'Only messages typed by the attendant or patient will be searched.',
    },
    'Search by conversation ID. Ex: #22554.': {
        pt: 'Pesquise pelo ID da conversa. Ex: #22554.',
        en: 'Search by conversation ID. Ex: #22554.',
    },
    'Create new channel': {
        pt: 'Criar novo canal',
        en: 'Create new channel',
    },
    Channels: {
        pt: 'Canais',
        en: 'Channels',
    },
    Others: {
        pt: 'Outros',
        en: 'Others',
    },
    Cancel: {
        pt: 'Cancelar',
        en: 'Cancel',
    },
    'Delete bot': {
        pt: 'Deletar bot',
        en: 'Delete bot',
    },
    'Bot deleted': {
        pt: 'Bot deletado',
        en: 'Bot deleted',
    },
    'Error. Try again': {
        pt: 'Erro. Tente novamente',
        en: 'Error. Try again',
    },
    'Confirm delete': {
        pt: 'Confirmar exclusão',
        en: 'Confirm delete',
    },
    'Are you sure you want to delete the bot?': {
        pt: 'Tem certeza de que deseja excluir o bot?',
        en: 'Are you sure you want to delete the bot?',
    },
    'Go back bot': {
        pt: 'Voltar para o bot',
        en: 'Go back bot',
    },
    Interaction: {
        pt: 'Interação',
        en: 'Interaction',
    },
    Reference: {
        pt: 'Referência',
        en: 'Reference',
    },
    Container: {
        pt: 'Container',
        en: 'Container',
    },
    'Fallback context': {
        pt: 'Fallback',
        en: 'Fallback context',
    },
    'Select a interaction to reference': {
        pt: 'Selecione uma interação para referenciar',
        en: 'Select a interaction to reference',
    },
    'Interaction name': {
        pt: 'Nome da interação',
        en: 'Interaction name',
    },
    'New container': {
        pt: 'Novo container',
        en: 'New container',
    },
    'New integration': {
        pt: 'Nova integração',
        en: 'New integration',
    },
    'Published to the bot': {
        pt: 'Publicada para o bot',
        en: 'Published to the bot',
    },
    'Published successfully': {
        pt: 'Publicada com sucesso',
        en: 'Published successfully',
    },
    'Are you sure you want to publish the interaction?': {
        pt: 'Tem certeza que quer publicar a interação',
        en: 'Are you sure you want to publish the interaction?',
    },
    'Post interaction': {
        pt: 'Publicar interação',
        en: 'Post interaction',
    },
    'New interaction': {
        pt: 'Nova interação',
        en: 'New interaction',
    },
    'This field is required': {
        pt: 'Campo obrigatório',
        en: 'This field is required',
    },
    'Bot responses': {
        pt: 'Resposta do bot',
        en: 'Bot responses',
    },
    'User says': {
        pt: 'Usuário diz',
        en: 'User says',
    },
    'Save input to attribute': {
        pt: 'Salvar entrada no atributo',
        en: 'Save input to attribute',
    },
    'Validation entity': {
        pt: 'Entidade de validação',
        en: 'Validation entity',
    },
    Entity: {
        pt: 'Entidade',
        en: 'Entity',
    },
    'User field says it is invalid!': {
        pt: 'O campo do usuário diz que está inválido!',
        en: 'User field says it is invalid!',
    },
    'Some bot responses are invalid!': {
        pt: 'Algumas respostas do bot são inválidas!',
        en: 'Some bot responses are invalid!',
    },
    'The "parameter" naming is not allowed.': {
        pt: 'A  nomenclatura "parameter" não é permitido.',
        en: 'The "parameter" naming is not allowed.',
    },
    'The selected entity type "Any" is not allowed.': {
        pt: 'O tipo de entidade selecionado "Qualquer" não é permitido.',
        en: 'The selected entity type "Any" is not allowed.',
    },
    'Some response filter is invalid!': {
        pt: 'Algum filtro de resposta é inválido!',
        en: 'Some response filter is invalid!',
    },
    'Close the interaction and open it again': {
        pt: 'Feche a interaction e abra novamente',
        en: 'Close the interaction and open it again',
    },
    'An error occurred while loading the interaction': {
        pt: 'Ocorreu um erro ao carregar a interaction',
        en: 'An error occurred while loading the interaction',
    },
    Advanced: {
        pt: 'Avançado',
        en: 'Advanced',
    },
    Comments: {
        pt: 'Comentários',
        en: 'Comments',
    },
    Tree: {
        pt: 'Árvore',
        en: 'Tree',
    },
    'Drop above': {
        pt: 'Soltar acima de',
        en: 'Drop above',
    },
    'Drop as last child': {
        pt: 'Soltar como último filho de',
        en: 'Drop as last child',
    },
    'Are you sure you want to delete interaction': {
        pt: 'Tem certeza de que deseja excluir a interação',
        en: 'Are you sure you want to delete interaction',
    },
    'Are you sure you want to delete health entity': {
        pt: 'Tem certeza de que deseja excluir a entidade',
        en: 'Are you sure you want to delete health entity',
    },
    Delete: {
        pt: 'Excluir',
        en: 'Delete',
    },
    or: {
        pt: 'ou',
        en: 'or',
    },
    Order: {
        pt: 'Ordem',
        en: 'Order',
    },
    'Bot name': {
        pt: 'Nome do bot',
        en: 'Bot name',
    },
    'Edit bot name': {
        pt: 'Editar nome do bot',
        en: 'Edit bot name',
    },
    'Bot name cannot be empty': {
        pt: 'O nome do bot nao pode ficar vazio',
        en: 'Bot name cannot be empty',
    },
    'Bot name updated successfully': {
        pt: 'Nome do bot atualizado com sucesso',
        en: 'Bot name updated successfully',
    },
    'Are you sure you want to delete the fallback': {
        pt: 'Tem certeza de que deseja excluir o fallback',
        en: 'Are you sure you want to delete the fallback',
    },
    'Unsaved changes': {
        pt: 'Alterações não salvas',
        en: 'Unsaved changes',
    },
    'without saving': {
        pt: 'sem salvar',
        en: 'without saving',
    },
    'You have unsaved changes. Are you sure you want to leave': {
        pt: 'Você tem alterações não salvas. Você tem certeza de que quer sair',
        en: 'You have unsaved changes. Are you sure you want to leave',
    },
    Yes: {
        pt: 'Sim',
        en: 'Yes',
    },
    No: {
        pt: 'Não',
        en: 'No',
    },
    'Bot settings': {
        pt: 'Configurações do bot',
        en: 'Bot settings',
    },
    'Channel token': {
        pt: 'Token do canal',
        en: 'Channel token',
    },
    'Hexadecimal color': {
        pt: 'Cor hexadecimal',
        en: 'Hexadecimal color',
    },
    Channel: {
        pt: 'Canal',
        en: 'Channel',
    },
    channelText: {
        pt: 'Canal',
        en: 'Channel',
    },
    chatbot: {
        pt: 'Chatbot',
        en: 'Chatbot',
    },
    web: {
        pt: 'Agendamento web',
        en: 'Web scheduling',
    },
    'Message type': {
        pt: 'Tipo da mensagem',
        en: 'Message type',
    },
    'Add message': {
        pt: 'Adicionar mensagem',
        en: 'Add message',
    },
    'Add block': {
        pt: 'Adicionar bloqueio',
        en: 'Add block',
    },
    'Blocks the patient from continuing the web scheduling when this flow applies. Requires a non-empty message.': {
        pt: 'Impede o paciente de continuar o agendamento web quando este fluxo se aplica. Exige uma mensagem não vazia.',
        en: 'Blocks the patient from continuing the web scheduling when this flow applies. Requires a non-empty message.',
    },
    'A block action requires at least one non-empty message in the same flow': {
        pt: 'Uma ação de bloqueio exige ao menos uma mensagem não vazia no mesmo fluxo',
        en: 'A block action requires at least one non-empty message in the same flow',
    },
    'Web scheduling flows are always of the Action type': {
        pt: 'Fluxos de agendamento web são sempre do tipo Ação',
        en: 'Web scheduling flows are always of the Action type',
    },
    'Expires at': {
        pt: 'Expira ás',
        en: 'Expires at',
    },
    Minutes: {
        pt: 'Minutos',
        en: 'Minutes',
    },
    Hours: {
        pt: 'Horas',
        en: 'Hours',
    },
    Days: {
        pt: 'Dias',
        en: 'Days',
    },
    'do not expire': {
        pt: 'Não expirar',
        en: 'do not expire',
    },
    'do not suspend': {
        pt: 'Não suspender',
        en: 'do not suspend',
    },
    'Expiration time': {
        pt: 'Tempo de expiração',
        en: 'Expiration time',
    },
    'Suspend conversation until': {
        pt: 'Suspender conversa até',
        en: 'Suspend conversation until',
    },
    'Send message to open conversation': {
        pt: 'Enviar mensagem para conversa aberta',
        en: 'Send message to open conversation',
    },
    Equals: {
        pt: 'Igual á',
        en: 'Equal to',
    },
    'Not equals': {
        pt: 'Diferente de',
        en: 'Different from',
    },
    Empty: {
        pt: 'Vazio',
        en: 'Empty',
    },
    'Not contains': {
        pt: 'Não contém o texto',
        en: 'Does not contain text',
    },
    Contains: {
        pt: 'Contém o texto',
        en: 'Contains the text',
    },
    "It's on the list": {
        pt: 'Está dentro da lista',
        en: "It's on the list",
    },
    'Not on the list': {
        pt: 'Não está dentro da lista',
        en: 'Not on the list',
    },
    Observations: {
        pt: 'Observações',
        en: 'Observations',
    },
    Notes: {
        pt: 'Notas',
        en: 'Notes',
    },
    'Notes (Optional)': {
        pt: 'Notas (Opcional)',
        en: 'Notes (Optional)',
    },
    'Greater than': {
        pt: 'Maior que',
        en: 'Greater than',
    },
    'Less than': {
        pt: 'Menor que',
        en: 'Less than',
    },
    'Greater or equal': {
        pt: 'Maior ou igual',
        en: 'Greater or equal',
    },
    Operator: {
        pt: 'Operador',
        en: 'Operator',
    },
    Attribute: {
        pt: 'Atributo',
        en: 'Attribute',
    },
    Value: {
        pt: 'Valor',
        en: 'Value',
    },
    Type: {
        pt: 'Tipo',
        en: 'Type',
    },
    'Content is not json format': {
        pt: 'O conteúdo não possui formato JSON',
        en: 'Content is not JSON format',
    },
    'No selected interaction': {
        pt: 'Nenhuma interação selecionada',
        en: 'No selected interaction',
    },
    Filters: {
        pt: 'Filtros',
        en: 'Filters',
    },
    'Copy to interaction': {
        pt: 'Copiar para interação',
        en: 'Copy to interaction',
    },
    Entries: {
        pt: 'Entradas',
        en: 'Entries',
    },
    'Show attributes': {
        pt: 'Exibir atributos',
        en: 'Show attributes',
    },
    'Filter entries': {
        pt: 'Filtrar entradas',
        en: 'Filter entries',
    },
    'Filter attribute': {
        pt: 'Filtrar atributo',
        en: 'Filter attribute',
    },
    Synonyms: {
        pt: 'Sinônimos',
        en: 'Synonyms',
    },
    'Attribute name': {
        pt: 'Nome do atributo',
        en: 'Attribute name',
    },
    'Attribute value': {
        pt: 'Valor do atributo',
        en: 'Attribute value',
    },
    'Add Entry': {
        pt: 'Adicionar entrada',
        en: 'Add Entry',
    },
    'Show Attributes': {
        pt: 'Mostrar atributos',
        en: 'Show Attributes',
    },
    'My filters': {
        pt: 'Meus filtros',
        en: 'My filters',
    },
    'Go to Demo': {
        pt: 'Ir para Demo',
        en: 'Go to Demo',
    },
    'Go to WhatsApp': {
        pt: 'Ir para o WhatsApp',
        en: 'Go to WhatsApp',
    },
    'Copy whatsapp link': {
        pt: 'Copiar link do whatsapp',
        en: 'Copy whatsapp link',
    },
    Entry: {
        pt: 'Entrada',
        en: 'Entry',
    },
    'Fill synonym and press enter to add': {
        pt: 'Insira um sinônimo e pressione Enter para adicionar',
        en: 'Fill synonym and press enter to add',
    },
    'Entity attributes': {
        pt: 'Atributos da entidade',
        en: 'Entity attributes',
    },
    'Attribute type': {
        pt: 'Tipo do atributo',
        en: 'Attribute type',
    },
    'Entry reference value': {
        pt: 'Insira um valor de referência',
        en: 'Entry reference value',
    },
    'Image url': {
        pt: 'Link da imagem',
        en: 'Image url',
    },
    'This field must be a valid URL': {
        pt: 'Este campo deve ter um link válido',
        en: 'This field must be a valid URL',
    },
    'Video url': {
        pt: 'Link do vídeo',
        en: 'Video url',
    },
    'File url': {
        pt: 'Link do arquivo',
        en: 'File url',
    },
    Title: {
        pt: 'Título',
        en: 'Title',
    },
    'Sub title': {
        pt: 'Subtítulo',
        en: 'Sub title',
    },
    Text: {
        pt: 'Texto',
        en: 'Text',
    },
    'Add button': {
        pt: 'Add botão',
        en: 'Add button',
    },
    Height: {
        pt: 'Altura',
        en: 'Height',
    },
    'Import several': {
        pt: 'Importar vários',
        en: 'Import several',
    },
    Image: {
        pt: 'Imagem',
        en: 'Image',
    },
    Video: {
        pt: 'Vídeo',
        en: 'Video',
    },
    'Button title': {
        pt: 'Título do botão',
        en: 'Button title',
    },
    'Button title that will appear on bot attendance card': {
        pt: 'Título do botão que aparecerá no cartão de atendimento do bot',
        en: 'Button title that will appear on bot attendance card',
    },
    'Goto interaction': {
        pt: 'Ir para interação',
        en: 'Goto interaction',
    },
    Button: {
        pt: 'Botão',
        en: 'Button',
    },
    'Send typing': {
        pt: 'Enviar digitação',
        en: 'Send typing',
    },
    'Send an activity simulating bot typing': {
        pt: 'Envia uma atividade simulando a digitação do bot',
        en: 'Send an activity simulating bot typing',
    },
    'Not implemented yet': {
        pt: 'Ainda não implementado',
        en: 'Not implemented yet',
    },
    'Click a bot answers and actions here to make your chatbot responsive': {
        pt: 'Clique nas responses ou actions para tornar seu chatbot responsivo',
        en: 'Click a bot answers and actions here to make your chatbot responsive',
    },
    'Clone configuration': {
        pt: 'Clonar configuração',
        en: 'Clone configuration',
    },
    'Clone automatic send configuration': {
        pt: 'Clonar configuração de envio automático',
        en: 'Clone automatic send configuration',
    },
    'You are copying the configuration list:': {
        pt: 'Você está copiando a configuração da lista:',
        en: 'You are copying the configuration list:',
    },
    'Name of the new configuration clone:': {
        pt: 'Nome da nova configuração clonada:',
        en: 'Name of the new configuration clone:',
    },
    'Enter a name for the new configuration': {
        pt: 'Digite um nome para a nova configuração',
        en: 'Enter a name for the new configuration',
    },
    'Error cloning configuration': {
        pt: 'Erro ao clonar configuração',
        en: 'Error cloning configuration',
    },
    'Configuration cloned successfully': {
        pt: 'Configuração clonada com sucesso',
        en: 'Configuration cloned successfully',
    },
    ' Attention': {
        pt: 'Atenção',
        en: 'Attention',
    },
    'Please provide a name for the cloned configuration': {
        pt: 'Por favor, informe um nome para a configuração clonada',
        en: 'Please provide a name for the cloned configuration',
    },
    'The cloned configuration will be created inactivated. Review and adjust the settings, then activate it to start using!':
        {
            pt: 'A configuração clonada será criada inativada. Revise e ajuste as definições e ative-a para começar a usar!',
            en: 'The cloned configuration will be created inactivated. Review and adjust the settings, then activate it to start using!',
        },
    Important: {
        pt: 'Importante',
        en: 'Important',
    },
    Clone: {
        pt: 'Clonar',
        en: 'Clone',
    },
    Copy: {
        pt: 'Copiar',
        en: 'Copy',
    },
    'Successfully copied': {
        pt: 'Copiado com sucesso',
        en: 'successfully copied',
    },
    'Copy to another bot': {
        pt: 'Copiar para outro bot',
        en: 'Copy to another bot',
    },
    'Go to the bot where the change was made?': {
        pt: 'Ir para o bot onde a alteração foi feita?',
        en: 'Go to the bot where the change was made?',
    },
    'Add new question': {
        pt: 'Adicionar nova questão',
        en: 'Add new question',
    },
    'Error messages': {
        pt: 'Mensagens de erro',
        en: 'Error messages',
    },
    'go to fallback': {
        pt: 'ir para fallback',
        en: 'go to fallback',
    },
    'Show next messages': {
        pt: 'Mostrar próximas mensagens',
        en: 'Show next messages',
    },
    times: {
        pt: 'vezes',
        en: 'times',
    },
    Once: {
        pt: 'Uma vez',
        en: 'Once',
    },
    'Select option': {
        pt: 'Selecione uma opção',
        en: 'Select option',
    },
    'Ask again': {
        pt: 'Perguntar novamente',
        en: 'Ask again',
    },
    time: {
        pt: 'vez',
        en: 'time',
    },
    "Don't ask": {
        pt: 'Não perguntar',
        en: "Don't ask",
    },
    'Type your question': {
        pt: 'Digite sua pergunta',
        en: 'Type your question',
    },
    'show next messages': {
        pt: 'exibir próximas mensagens',
        en: 'show next messages',
    },
    'Save answer to attribute': {
        pt: 'Salvar pergunta no atributo',
        en: 'Save answer to attribute',
    },
    'If attribute exists': {
        pt: 'Se atributo existir',
        en: 'If attribute exists',
    },
    'Required answer': {
        pt: 'Pergunta obrigatória',
        en: 'Required answer',
    },
    'Action on failure': {
        pt: 'Ação em caso de falha',
        en: 'Action on failure',
    },
    'Ask user': {
        pt: 'Perguntar ao usuário',
        en: 'Ask user',
    },
    'Validation type': {
        pt: 'Tipo de validação',
        en: 'Validation type',
    },
    Case: {
        pt: 'Caso',
        en: 'Case',
    },
    Default: {
        pt: 'Padrão',
        en: 'Default',
    },
    Random: {
        pt: 'Aleatório',
        en: 'Random',
    },
    'Add case': {
        pt: 'Adicionar caso',
        en: 'Add case',
    },
    'Random text': {
        pt: 'Texto aleatório',
        en: 'Random text',
    },
    'Value of attribute': {
        pt: 'Valor do atributo',
        en: 'Value of attribute',
    },
    'Random text to show to user when case condition is satisfied': {
        pt: 'Texto aleatório exibido ao usuário quando a condição do caso for atendida',
        en: 'Random text to show to user when case condition is satisfied',
    },
    'Default text to send to user when no cases satisfy your condition': {
        pt: 'Texto padrão enviado ao usuário quando nenhum caso atender a condição',
        en: 'Default text to send to user when no cases satisfy your condition',
    },
    'End conversation is used to close a conversation': {
        pt: 'É utilizada para encerrar um atendimento',
        en: 'End attendance is used to close a attendance',
    },
    'When used, ends the ongoing conversation': {
        pt: 'Quando usado, finaliza a conversa em andamento',
        en: 'When used, ends the ongoing attendance',
    },
    'Show rating after close attendance': {
        pt: 'Exibe uma avaliação de satisfação ao encerrar',
        en: 'Show rating after close attendance',
    },
    'Text displayed on service satisfaction survey card': {
        pt: 'Texto exibido na avaliação de satisfação',
        en: 'Text displayed on service satisfaction survey card',
    },
    'Rating title': {
        pt: 'Título da avaliação',
        en: 'Rating title',
    },
    'Rating description': {
        pt: 'Descrição da avaliação',
        en: 'Rating description',
    },
    'Confirmation description': {
        pt: 'Descrição de confirmação após avaliação',
        en: 'Confirmation description',
    },
    'Confirmation title': {
        pt: 'Título de confirmação após avaliação',
        en: 'Confirmation title',
    },
    'Thank you text displayed after review': {
        pt: 'Texto de agradecimento após conclusão da avaliação',
        en: 'Thank you text displayed after review',
    },
    'Select scope': {
        pt: 'Selecionar escopo',
        en: 'Select scope',
    },
    Scope: {
        pt: 'Escopo',
        en: 'Scope',
    },
    'Define conversation scope': {
        pt: 'Define o escopo do atendimento',
        en: 'Define attendance scope',
    },
    'Message to the user': {
        pt: 'Mensagem para o usuário',
        en: 'Message to the user',
    },
    'Send random text to user (Optional)': {
        pt: 'Envia uma mensagem aleatória para o usuário (opcional)',
        en: 'Send random text to user (Optional)',
    },
    'Take a print of the screen of the website where webchat is on': {
        pt: 'Tira um print da tela em que o webchat está',
        en: 'Take a print of the screen of the website where webchat is on',
    },
    Action: {
        pt: 'Ação',
        en: 'Action',
    },
    remove: {
        pt: 'remover',
        en: 'remove',
    },
    'remove all': {
        pt: 'remover todos',
        en: 'remove all',
    },
    add: {
        pt: 'adicionar',
        en: 'add',
    },
    'Goback responses are used to return to interaction that called it': {
        pt: 'As respostas do Goback são usadas para retornar à interação que á chamou ',
        en: 'Goback responses are used to return to interaction that called it',
    },
    'When go back response is executed, the subsequent responses will be ignored': {
        pt: 'Quando a resposta de retorno é executada, as respostas subsequentes serão ignoradas',
        en: 'When go back response is executed, the subsequent responses will be ignored',
    },
    'Select one of the options': {
        pt: 'Selecione uma das opções',
        en: 'Select one of the options',
    },
    'just this interaction': {
        pt: 'Apenas esta interação',
        en: 'just this interaction',
    },
    'Selection of an existing interaction in this workspace is required': {
        pt: 'Obrigatório seleção de interação existente neste workspace',
        en: 'Selection of an existing interaction in this workspace is required',
    },
    'Navigate to the selected interaction': {
        pt: 'Navegar até a interação selecionada',
        en: 'Navigate to the selected interaction',
    },
    'Invalid file format': {
        pt: 'Formato de arquivo inválido',
        en: 'Invalid file format',
    },
    'No file was selected.': {
        pt: 'Nenhum arquivo foi selecionado.',
        en: 'No file was selected.',
    },
    'The file is empty. Please select a valid file.': {
        pt: 'O arquivo está vazio. Por favor, selecione um arquivo válido.',
        en: 'The file is empty. Please select a valid file.',
    },
    'is not supported on WhatsApp.': {
        pt: 'não é suportado no WhatsApp.',
        en: 'is not supported on WhatsApp.',
    },
    'Accepted types:': {
        pt: 'Tipos aceitos:',
        en: 'Accepted types:',
    },
    'Image: JPEG, PNG (max. 5MB)': {
        pt: 'Imagem: JPEG, PNG (máx. 5MB)',
        en: 'Image: JPEG, PNG (max. 5MB)',
    },
    'Audio: AAC, MP4, MPEG, AMR, OGG (max. 16MB)': {
        pt: 'Áudio: AAC, MP4, MPEG, AMR, OGG (máx. 16MB)',
        en: 'Audio: AAC, MP4, MPEG, AMR, OGG (max. 16MB)',
    },
    'Video: MP4, 3GPP (max. 16MB)': {
        pt: 'Vídeo: MP4, 3GPP (máx. 16MB)',
        en: 'Video: MP4, 3GPP (max. 16MB)',
    },
    'Document: PDF, DOC, XLS, PPT, TXT, ZIP, CSV (max. 100MB)': {
        pt: 'Documento: PDF, DOC, XLS, PPT, TXT, ZIP, CSV (máx. 100MB)',
        en: 'Document: PDF, DOC, XLS, PPT, TXT, ZIP, CSV (max. 100MB)',
    },
    'Sticker: WEBP (max. 100KB)': {
        pt: 'Figurinha: WEBP (máx. 100KB)',
        en: 'Sticker: WEBP (max. 100KB)',
    },
    Audio: {
        pt: 'Áudio',
        en: 'Audio',
    },
    Document: {
        pt: 'Documento',
        en: 'Document',
    },
    Sticker: {
        pt: 'Figurinha',
        en: 'Sticker',
    },
    'is too large.': {
        pt: 'está muito grande.',
        en: 'is too large.',
    },
    'Current size:': {
        pt: 'Tamanho atual:',
        en: 'Current size:',
    },
    'Maximum size:': {
        pt: 'Tamanho máximo:',
        en: 'Maximum size:',
    },
    'Please choose a smaller file.': {
        pt: 'Por favor, escolha um arquivo.',
        en: 'Please choose a smaller file.',
    },
    'File type could not be identified.': {
        pt: 'Tipo de arquivo não pode ser identificado.',
        en: 'File type could not be identified.',
    },
    'Invalid file': {
        pt: 'Arquivo inválido',
        en: 'Invalid file',
    },
    'Maximum reached': {
        pt: 'Limite máximo atingido',
        en: 'Maximum reached',
    },
    'You can select up to 5 files at once. Please select fewer files.': {
        pt: 'Você pode selecionar até 5 arquivos de uma vez. Selecione menos arquivos.',
        en: 'You can select up to 5 files at once. Please select fewer files.',
    },
    'You already have': {
        pt: 'Você já tem',
        en: 'You already have',
    },
    'file(s). You can only add': {
        pt: 'arquivo(s). Você só pode adicionar',
        en: 'file(s). You can only add',
    },
    'more.': {
        pt: 'mais.',
        en: 'more.',
    },
    'File too large': {
        pt: 'Arquivo muito grande',
        en: 'File too large',
    },
    'Each file must be at most 100MB. Remove oversized files to send.': {
        pt: 'Cada arquivo pode ter no máximo 100MB (limite por arquivo). Remova os arquivos acima desse limite para enviar.',
        en: 'Each file must be at most 100MB. Remove oversized files to send.',
    },
    'Some selected files exceed the allowed size for their type. Remove invalid files to send.': {
        pt: 'Alguns arquivos selecionados excedem o tamanho permitido para seu tipo. Remova os arquivos inválidos para enviar.',
        en: 'Some selected files exceed the allowed size for their type. Remove invalid files to send.',
    },
    'Please try again by selecting a file with one of the following extensions:': {
        pt: 'Por favor, tente novamente escolhendo um arquivo com uma das seguintes extensões:',
        en: 'Please try again by selecting a file with one of the following extensions:',
    },
    'Hide inactive': {
        pt: 'Ocultar inativos',
        en: 'Hide inactive',
    },
    'Pending only': {
        pt: 'Só pendentes',
        en: 'Pending only',
    },
    'Could not load the pending count.': {
        pt: 'Não foi possível carregar a contagem de pendentes.',
        en: 'Could not load the pending count.',
    },
    'Nothing was published': {
        pt: 'Nada foi publicado',
        en: 'Nothing was published',
    },
    'Part of the records could not be published and remain pending.': {
        pt: 'Parte dos registros não pôde ser publicada e continua pendente.',
        en: 'Part of the records could not be published and remain pending.',
    },
    'The publication data expired before it was applied. Try publishing again.': {
        pt: 'Os dados da publicação expiraram antes de serem aplicados. Publique novamente.',
        en: 'The publication data expired before it was applied. Try publishing again.',
    },
    'The scheduling side rejected part of the data. Try again in a few minutes.': {
        pt: 'O lado do agendamento recusou parte dos dados. Tente de novo em alguns minutos.',
        en: 'The scheduling side rejected part of the data. Try again in a few minutes.',
    },
    'This integration does not exist on the scheduling side (integrations). Save it in the integration settings first.':
        {
            pt: 'Esta integração não existe do lado do agendamento (integrations). Salve-a primeiro na tela de configurações da integração.',
            en: 'This integration does not exist on the scheduling side (integrations). Save it in the integration settings first.',
        },
    'This integration is disabled on the scheduling side (integrations).': {
        pt: 'Esta integração está desabilitada do lado do agendamento (integrations).',
        en: 'This integration is disabled on the scheduling side (integrations).',
    },
    'The scheduling side (integrations) does not accept this integration type.': {
        pt: 'O lado do agendamento (integrations) não aceita este tipo de integração.',
        en: 'The scheduling side (integrations) does not accept this integration type.',
    },
    'The scheduling side reported': {
        pt: 'O lado do agendamento informou',
        en: 'The scheduling side reported',
    },
    'The scheduling side did not recognize this integration. It may not be configured there yet.': {
        pt: 'O lado do agendamento não reconheceu esta integração. Pode ser que ela ainda não esteja configurada lá.',
        en: 'The scheduling side did not recognize this integration. It may not be configured there yet.',
    },
    'New / Modified / Deleted': {
        pt: 'Novos / Alterados / Excluídos',
        en: 'New / Modified / Deleted',
    },
    'In progress': {
        pt: 'Em andamento',
        en: 'In progress',
    },
    Published: {
        pt: 'Publicada',
        en: 'Published',
    },
    'Partially published': {
        pt: 'Publicada em parte',
        en: 'Partially published',
    },
    Failed: {
        pt: 'Falhou',
        en: 'Failed',
    },
    'Internal synonyms': {
        pt: 'Sinônimos internos',
        en: 'Internal synonyms',
    },
    'Active in ERP': {
        pt: 'Ativo no ERP',
        en: 'Active in ERP',
    },
    'Show on web': {
        pt: 'Exibir na web',
        en: 'Show on web',
    },
    'Actively confirm': {
        pt: 'Confirmar ativo',
        en: 'Actively confirm',
    },
    'Confirm passively': {
        pt: 'Confirmar passivo',
        en: 'Confirm passively',
    },
    'Speciality code': {
        pt: 'Código da especialidade',
        en: 'Speciality code',
    },
    'Speciality type': {
        pt: 'Tipo da especialidade',
        en: 'Speciality type',
    },
    'Insurance code': {
        pt: 'Código do convênio',
        en: 'Insurance code',
    },
    'Insurance plan code': {
        pt: 'Código do plano',
        en: 'Insurance plan code',
    },
    References: {
        pt: 'Referências',
        en: 'References',
    },
    Parameters: {
        pt: 'Parâmetros',
        en: 'Parameters',
    },
    Data: {
        pt: 'Dados',
        en: 'Data',
    },
    'Entity type': {
        pt: 'Tipo de entidade',
        en: 'Entity type',
    },
    'Whole integration': {
        pt: 'Integração inteira',
        en: 'Whole integration',
    },
    'General publication': {
        pt: 'Publicação geral',
        en: 'General publication',
    },
    'Unit publication': {
        pt: 'Publicação unitária',
        en: 'Unit publication',
    },
    'record(s) could not be restored because their previous state is unknown.': {
        pt: 'registro(s) não puderam ser restaurados porque o estado anterior é desconhecido.',
        en: 'record(s) could not be restored because their previous state is unknown.',
    },
    'record(s) were kept because they still have published dependents.': {
        pt: 'registro(s) mantido(s) porque ainda têm dependentes publicados.',
        en: 'record(s) were kept because they still have published dependents.',
    },
    'Deleted only': {
        pt: 'Só exclusões',
        en: 'Deleted only',
    },
    'Pending deletion': {
        pt: 'Exclusão pendente',
        en: 'Pending deletion',
    },
    'Undo delete': {
        pt: 'Desfazer exclusão',
        en: 'Undo delete',
    },
    'Deletion undone': {
        pt: 'Exclusão desfeita',
        en: 'Deletion undone',
    },
    'Error on undo delete': {
        pt: 'Erro ao desfazer a exclusão',
        en: 'Error on undo delete',
    },
    'Deletions that affect published records': {
        pt: 'Exclusões que afetam registros publicados',
        en: 'Deletions that affect published records',
    },
    Deleting: {
        pt: 'Excluir',
        en: 'Deleting',
    },
    leaves: {
        pt: 'deixa',
        en: 'leaves',
    },
    'published record(s) without their link': {
        pt: 'registro(s) publicado(s) sem vínculo',
        en: 'published record(s) without their link',
    },
    Showing: {
        pt: 'Exibindo',
        en: 'Showing',
    },
    'Publication started and not finished yet.': {
        pt: 'Publicação iniciada e ainda não concluída.',
        en: 'Publication started and not finished yet.',
    },
    'Part of the types was applied; the rest is still pending.': {
        pt: 'Parte dos tipos foi aplicada; o resto continua pendente.',
        en: 'Part of the types was applied; the rest is still pending.',
    },
    'Nothing was applied on the published side.': {
        pt: 'Nada foi aplicado do lado publicado.',
        en: 'Nothing was applied on the published side.',
    },
    'Whole type': {
        pt: 'Tipo inteiro',
        en: 'Whole type',
    },
    Selection: {
        pt: 'Seleção',
        en: 'Selection',
    },
    'Publication failed': {
        pt: 'Falha na publicação',
        en: 'Publication failed',
    },
    'Nothing was published. Check the integration.': {
        pt: 'Nada foi publicado. Verifique a integração.',
        en: 'Nothing was published. Check the integration.',
    },
    'Part of the records could not be published.': {
        pt: 'Parte dos registros não pôde ser publicada.',
        en: 'Part of the records could not be published.',
    },
    'This is the current publication.': {
        pt: 'Esta é a publicação atual.',
        en: 'This is the current publication.',
    },
    'The published state goes back to this publication.': {
        pt: 'O estado publicado volta ao desta publicação.',
        en: 'The published state goes back to this publication.',
    },
    'Nothing to restore: this is already the current state.': {
        pt: 'Nada a restaurar: este já é o estado atual.',
        en: 'Nothing to restore: this is already the current state.',
    },
    'This is already the current state': {
        pt: 'Este já é o estado atual',
        en: 'This is already the current state',
    },
    'No details recorded for this publication.': {
        pt: 'Sem detalhes registrados para esta publicação.',
        en: 'No details recorded for this publication.',
    },
    'Restore publication': {
        pt: 'Restaurar publicação',
        en: 'Restore publication',
    },
    'Records created after this publication will be removed from the online schedule.': {
        pt: 'Registros criados depois desta publicação serão removidos da agenda online.',
        en: 'Records created after this publication will be removed from the online schedule.',
    },
    'Unpublished edits on the affected records will be lost.': {
        pt: 'Edições não publicadas dos registros afetados serão perdidas.',
        en: 'Unpublished edits on the affected records will be lost.',
    },
    'Records that come from the ERP may come back on the next import.': {
        pt: 'Registros vindos do ERP podem voltar na próxima importação.',
        en: 'Records that come from the ERP may come back on the next import.',
    },
    'Could not restore this publication.': {
        pt: 'Não foi possível restaurar esta publicação.',
        en: 'Could not restore this publication.',
    },
    'Publication restored': {
        pt: 'Publicação restaurada',
        en: 'Publication restored',
    },
    Types: {
        pt: 'Tipos',
        en: 'Types',
    },
    'All types': {
        pt: 'Todos os tipos',
        en: 'All types',
    },
    'A publication that pulled a dependency shows up under both types.': {
        pt: 'Uma publicação que puxou dependência aparece nos dois tipos.',
        en: 'A publication that pulled a dependency shows up under both types.',
    },
    'Publish selected': {
        pt: 'Publicar selecionados',
        en: 'Publish selected',
    },
    'record(s) will be published': {
        pt: 'registro(s) serão publicados',
        en: 'record(s) will be published',
    },
    'All pending changes of this type will be included.': {
        pt: 'Todas as alterações pendentes deste tipo serão incluídas.',
        en: 'All pending changes of this type will be included.',
    },
    'There is already a publication in progress for this integration.': {
        pt: 'Já existe uma publicação em andamento nesta integração.',
        en: 'There is already a publication in progress for this integration.',
    },
    'An import is running. Wait for it to finish before publishing.': {
        pt: 'Há uma importação rodando. Espere ela terminar antes de publicar.',
        en: 'An import is running. Wait for it to finish before publishing.',
    },
    'selected record(s) have no changes and will not be published.': {
        pt: 'registro(s) selecionados não têm alteração e não serão publicados.',
        en: 'selected record(s) have no changes and will not be published.',
    },
    'Showing the first records only. The counts above cover everything.': {
        pt: 'Mostrando apenas os primeiros registros. As contagens acima cobrem tudo.',
        en: 'Showing the first records only. The counts above cover everything.',
    },
    'dependency(ies) included automatically': {
        pt: 'dependência(s) incluída(s) automaticamente',
        en: 'dependency(ies) included automatically',
    },
    'These records go up together because the selected ones depend on them.': {
        pt: 'Estes registros sobem junto porque os selecionados dependem deles.',
        en: 'These records go up together because the selected ones depend on them.',
    },
    'This interaction and your children': {
        pt: 'Esta interação e seus filhos',
        en: 'This interaction and your children',
    },
    'Copy interaction to another bot': {
        pt: 'Copiar interação para outro bot',
        en: 'Copy interaction to another bot',
    },
    'Interaction successfully copied!': {
        pt: 'Interação copiada com sucesso!',
        en: 'Interaction successfully copied!',
    },
    'There was an error copying this interaction, please try again!': {
        pt: 'Ocorreu algum erro ao copiar esta interação, por favor tente novamente!',
        en: 'There was an error copying this interaction, please try again!',
    },
    'Choose a bot': {
        pt: 'Escolha um bot',
        en: 'Choose a bot',
    },
    'Choose an trigger': {
        pt: 'Escolha uma trigger',
        en: 'Choose an trigger',
    },
    'Choose an interaction': {
        pt: 'Selecione uma interação',
        en: 'Choose an interaction',
    },
    'If you choose other bot the conversation will be redirected to interaction of this bot!': {
        pt: 'Se você escolher outro bot, o atendimento será redirecionada para a interação desse bot!',
        en: 'If you choose other bot the attendance will be redirected to interaction of this bot!',
    },
    set: {
        pt: 'setar',
        en: 'set',
    },
    value: {
        pt: 'valor',
        en: 'value',
    },
    Method: {
        pt: 'Método',
        en: 'Method',
    },
    'Header name': {
        pt: 'Nome do header',
        en: 'Header name',
    },
    'Header value': {
        pt: 'Valor do header',
        en: 'Header value',
    },
    'Enter url': {
        pt: 'Digite a url',
        en: 'Enter url',
    },
    'Type of attribute': {
        pt: 'Tipo do atributo',
        en: 'Type of attribute',
    },
    'Save http response to attribute': {
        pt: 'Salvar resposta no atributo',
        en: 'Save http response to attribute',
    },
    Number: {
        pt: 'Número',
        en: 'Number',
    },
    Date: {
        pt: 'Data',
        en: 'Date',
    },
    'Start date': {
        pt: 'Data de inicio',
        en: 'Start date',
    },
    'End date': {
        pt: 'Data final',
        en: 'End date',
    },
    Any: {
        pt: 'Qualquer',
        en: 'Any',
    },
    Custom: {
        pt: 'Customizado',
        en: 'Custom',
    },
    System: {
        pt: 'Sistema',
        en: 'System',
    },
    'All agents': {
        pt: 'Todos os agentes',
        en: 'All agents',
    },
    Genre: {
        pt: 'Gênero',
        en: 'Genre',
    },
    'Bot attributes': {
        pt: 'Atributos do bot',
        en: 'Bot attributes',
    },
    'Default attributes': {
        pt: 'Atributos padrão',
        en: 'Default attributes',
    },
    'Enable channel': {
        pt: 'Ativar canal',
        en: 'Enable channel',
    },
    'Enable animation on avatar image': {
        pt: 'Habilitar animação na imagem do avatar',
        en: 'Enable animation on avatar image',
    },
    'enable or disable webchat': {
        pt: 'ativa ou desativa o webchat',
        en: 'enable or disable webchat',
    },
    'After open chat, a chat initiation confirmation will appear': {
        pt: 'Após o bate-papo aberto, uma confirmação de iniciação será exibida',
        en: 'After open chat, a chat initiation confirmation will appear',
    },
    'Start with confirm': {
        pt: 'Inicia com confirmação',
        en: 'Start with confirm',
    },
    'Keep alive': {
        pt: 'Sempre vivo',
        en: 'Keep alive',
    },
    'restore conversation even after chat is closed': {
        pt: 'restaura o atendimento mesmo após o encerramento do bate-papo',
        en: 'restore attendance even after chat is closed',
    },
    'Display a speech bubble in webchat': {
        pt: 'Exibe um balão de fala no webchat',
        en: 'Display a speech bubble in webchat',
    },
    'Show Tooltip': {
        pt: 'Exibir tooltip',
        en: 'Show Tooltip',
    },
    'Select value': {
        pt: 'Selecione um valor',
        en: 'Select value',
    },
    'Required field': {
        pt: 'Campo obrigatório',
        en: 'Required field',
    },
    'Service username': {
        pt: 'Usuário do serviço',
        en: 'Service username',
    },
    'Service password': {
        pt: 'Senha do serviço',
        en: 'Service password',
    },
    'Birth date': {
        pt: 'Data de nascimento',
        en: 'Birth date',
    },
    'Procedure name': {
        pt: 'Nome do procedimento',
        en: 'Procedure name',
    },
    'Medical covenant': {
        pt: 'Convênio médico',
        en: 'Medical insurance',
    },
    Telephone: {
        pt: 'Telefone',
        en: 'Telephone',
    },
    'Service endpoint': {
        pt: 'Endpoint do serviço',
        en: 'Service endpoint',
    },
    Specialty: {
        pt: 'Especialidade',
        en: 'Specialty',
    },
    Resource: {
        pt: 'Recurso',
        en: 'Resource',
    },
    'Fill in with equivalent attributes': {
        pt: 'Preencha com os atributos equivalentes',
        en: 'Fill in with equivalent attributes',
    },
    'Fill in with equivalent attributes for rescheduling': {
        pt: 'Preencha com os atributos equivalentes para reagendamento',
        en: 'Fill in with equivalent attributes for rescheduling',
    },
    'According to the answer, redirect to': {
        pt: 'De acordo com a resposta, redirecionar para',
        en: 'According to the answer, redirect to',
    },
    'Empty result': {
        pt: 'Resultado vazio',
        en: 'Empty result',
    },
    'Blocked patient cpfs': {
        pt: 'CPFs de pacientes bloqueados',
        en: 'Blocked patient cpfs',
    },
    'If the received result is empty': {
        pt: 'Se o resultado recebido for vazio',
        en: 'If the received result is empty',
    },
    'Select a interaction': {
        pt: 'Selecione uma interação',
        en: 'Select a interaction',
    },
    'In case of error redirect to': {
        pt: 'Em caso de erro redirecionar para',
        en: 'In case of error redirect to',
    },
    'Invalid JSON format': {
        pt: 'Formato JSON inválido',
        en: 'Invalid JSON format',
    },
    'Invalid JSON': {
        pt: 'JSON inválido',
        en: 'Invalid JSON',
    },
    'Error processing JSON': {
        pt: 'Erro ao processar JSON',
        en: 'Error processing JSON',
    },
    'Invalid scheduling link configuration format': {
        pt: 'Formato de configuração de link do agendamento inválido.',
        en: 'Invalid scheduling link configuration format',
    },
    'Error saving configuration': {
        pt: 'Erro ao salvar a configuração',
        en: 'Error saving configuration',
    },
    'Configuration saved successfully': {
        pt: 'Configuração salva com sucesso',
        en: 'Configuration saved successfully',
    },
    'Scheduling link settings': {
        pt: 'Configurações do link de agendamento',
        en: 'Scheduling link settings',
    },
    'Custom integration rules configuration via JSON': {
        pt: 'Configurações customizadas regras de integração via JSON',
        en: 'Custom integration rules configuration via JSON',
    },
    'Appointment parameters to be filled in:': {
        pt: 'Dados de parâmetros a ser preenchido do agendamento:',
        en: 'Appointment parameters to be filled in:',
    },
    Error: {
        pt: 'Erro',
        en: 'Error',
    },
    Correlate: {
        pt: 'Correlacionar',
        en: 'Correlate',
    },
    Synchronize: {
        pt: 'Sincronizar',
        en: 'Synchronize',
    },
    'Synchronize request sended': {
        pt: 'Requisição de sincronização enviada',
        en: 'Synchronize request sended',
    },
    Transboard: {
        pt: 'Transbordar',
        en: 'Transboard',
    },
    'Transfer to an transboard interaction': {
        pt: 'Transferir para uma interação com transbordo',
        en: 'Transfer to an transboard interaction',
    },
    Carousel: {
        pt: 'Carrossel',
        en: 'Carousel',
    },
    Question: {
        pt: 'Pergunta',
        en: 'Question',
    },
    'Quick Reply': {
        pt: 'Resposta rápida',
        en: 'Quick Reply',
    },
    Goto: {
        pt: 'Ir para',
        en: 'Goto',
    },
    'Go back': {
        pt: 'Voltar para',
        en: 'Go back',
    },
    'End conversation': {
        pt: 'Finalizar atendimento',
        en: 'End attendance',
    },
    'Suspend attendance': {
        pt: 'Suspender atendimento',
        en: 'Suspend attendance',
    },
    'Service suspended': {
        pt: 'Atendimento suspenso',
        en: 'Service suspended',
    },
    Per: {
        pt: 'Por',
        en: 'Per',
    },
    'Choose date and time': {
        pt: 'Escolher data e hora',
        en: 'Choose date and time',
    },
    'Guide status': {
        pt: 'Status da guia',
        en: 'Guide status',
    },
    'Medical guide': {
        pt: 'Guia médico',
        en: 'Medical guide',
    },
    'Beneficiary Guide': {
        pt: 'Guia Beneficiário',
        en: 'Beneficiary Guide',
    },
    'Medical appointment': {
        pt: 'Consulta médica',
        en: 'Medical appointment',
    },
    'Recognizer scope': {
        pt: 'Escopo de reconhecimento',
        en: 'Recognizer scope',
    },
    'Phone number attribute': {
        pt: 'Atributo do número de telefone',
        en: 'Phone number attribute',
    },
    'Purchase requisition attribute': {
        pt: 'Atributo da requisição de compra',
        en: 'Purchase requisition attribute',
    },
    'Switch text': {
        pt: 'Mudar texto',
        en: 'Switch text',
    },
    'Search supplier': {
        pt: 'Busca fornecedor',
        en: 'Search supplier',
    },
    'Search id': {
        pt: 'Buscar id',
        en: 'Search id',
    },
    'Driver started': {
        pt: 'Driver iniciado',
        en: 'Driver started',
    },
    'Wait a moment': {
        pt: 'Aguarde alguns instantes',
        en: 'Wait a moment',
    },
    'Driver started. Request a Qr code as soon as you want': {
        pt: 'Driver iniciado. Solicite um Qr code assim que quiser',
        en: 'Driver started. Request a Qr code as soon as you want',
    },
    'Your whatsApp driver is starting': {
        pt: 'Seu driver do whatsApp está sendo iniciado',
        en: 'Your whatsApp driver is starting',
    },
    'This operation may take more than 1 minute': {
        pt: 'Esta operação pode levar mais de 1 minuto',
        en: 'This operation may take more than 1 minute',
    },
    'The operation timed out. Try again later': {
        pt: 'A operação atingiu tempo limite. Tente novamente mais tarde',
        en: 'The operation timed out. Try again later',
    },
    'Request qr code': {
        pt: 'Solicitar qr code',
        en: 'Request qr code',
    },
    Battery: {
        pt: 'Bateria',
        en: 'Battery',
    },
    'User found': {
        pt: 'Usuário encontrado',
        en: 'User found',
    },
    'No entities found': {
        pt: 'Nenhuma entidade encontrada',
        en: 'No entities found',
    },
    'Error publishing to entities': {
        pt: 'Erro ao publicar às entidades',
        en: 'Error publishing to entities',
    },
    'Last entities sync': {
        pt: 'Última sincronização de entidades',
        en: 'Last entities sync',
    },
    'Error clearing integration cache': {
        pt: 'Erro ao limpar o cache de integração',
        en: 'Error clearing integration cache',
    },
    'Successfully cleared integration cache': {
        pt: 'Cache de integração limpo com sucesso',
        en: 'Successfully cleared integration cache',
    },
    'Failed to update integration rules.': {
        pt: 'Falha ao atualizar as regras de integração.',
        en: 'Failed to update integration rules.',
    },
    'Error on load entities': {
        pt: 'Erro ao carregar entidades',
        en: 'Error on load entities',
    },
    'Error on update entity': {
        pt: 'Erro ao atualizar entidade',
        en: 'Error on update entity',
    },
    'Error on create entity': {
        pt: 'Erro ao criar entidade',
        en: 'Error on create entity',
    },
    'Error on create attribute': {
        pt: 'Erro ao criar atributo',
        en: 'Error on create attribute',
    },
    'Create entities': {
        pt: 'Criar entidades',
        en: 'Create entities',
    },
    'Entity creation': {
        pt: 'Criação de entidades',
        en: 'Entity creation',
    },
    'Paste the name of the entities to be created, or enter manually.': {
        pt: 'Cole o nome das entidades a serem criadas, ou insira manualmente.',
        en: 'Paste the name of the entities to be created, or enter manually.',
    },
    correlation: {
        pt: 'Correlação',
        en: 'Correlation',
    },
    'Import exams for confirmation': {
        pt: 'Importar exames para confirmação',
        en: 'Import exams for confirmation',
    },
    'Enable scheduled sending routine': {
        pt: 'Ativar rotina de envio programado',
        en: 'Enable scheduled sending routine',
    },
    'Use the agreement suggestion step': {
        pt: 'Utilizar etapa de sugestão de convênio',
        en: 'Use the agreement suggestion step',
    },
    'Offer doctor replacement when no slots found': {
        pt: 'Oferecer troca de médico quando não há horários disponíveis',
        en: 'Offer doctor replacement when no slots found',
    },
    'Entity saved': {
        pt: 'Entidade salva',
        en: 'Entity saved',
    },
    'Entities in the flow': {
        pt: 'Entidades no fluxo',
        en: 'Entities in the flow',
    },
    'Maximum value': {
        pt: 'Valor máximo ',
        en: 'Maximum value',
    },
    'Minimum value': {
        pt: 'Valor mínimo',
        en: 'Minimum value',
    },
    'Disabled in ERP': {
        pt: 'Desativada no ERP',
        en: 'Disabled in ERP',
    },
    'Changes made must be published to be updated in the online schedule': {
        pt: 'As alterações feitas devem ser publicadas para serem atualizadas no agendamento online',
        en: 'Changes made must be published to be updated in the online schedule',
    },
    'Unpublished change': {
        pt: 'Alteração não publicada',
        en: 'Unpublished change',
    },
    'Publish flow': {
        pt: 'Publicar fluxo',
        en: 'Publish flow',
    },
    'Publish flow production': {
        pt: 'Publicar fluxo para produção',
        en: 'Publish flow production',
    },
    'Pending homologation publication': {
        pt: 'Alteração pendente em homologação',
        en: 'Pending publication to homologation',
    },
    'Pending production publication': {
        pt: 'Alteração pendente em produção',
        en: 'Pending publication to production',
    },
    'Publish to homologation first': {
        pt: 'Publique em homologação antes da produção',
        en: 'Publish to homologation before production',
    },
    'Open online booking': {
        pt: 'Abrir agendamento online',
        en: 'Open online booking',
    },
    Messaging: {
        pt: 'Mensagens',
        en: 'Messaging',
    },
    'Click here to edit': {
        pt: 'Clique aqui para editar',
        en: 'Click here to edit',
    },
    'At half of the configured time, the "before_end_conversation" interaction is triggered. Its purpose is to re-engage the patient who became inactive in the flow.':
        {
            pt: 'Na metade do tempo configurado, é enviada a interação "before_end_conversation", que tem o objetivo de retomar o contato com o paciente inativo no fluxo.',
            en: 'At half of the configured time, the "before_end_conversation" interaction is triggered. Its purpose is to re-engage the patient who became inactive in the flow.',
        },
    'Ex: If the total time is 1 hour, this interaction will be triggered at 30 minutes; when the full hour is reached, the session will be automatically finalized by the bot.':
        {
            pt: 'Ex: Se o tempo total for de 1 hora, essa interação será disparada aos 30 minutos; quando completar às 1 hora, o atendimento será finalizado automaticamente pelo bot.',
            en: 'Ex: If the total time is 1 hour, this interaction will be triggered at 30 minutes; when the full hour is reached, the session will be automatically finalized by the bot.',
        },
    'Block incoming interactions': {
        pt: 'Bloquear atendimentos receptivos',
        en: 'Block incoming interactions',
    },
    'Do not include in billing': {
        pt: 'Não incluir na fatura',
        en: 'Do not include in billing',
    },
    'Go to conversation': {
        pt: 'Ir para conversa',
        en: 'Go to conversation',
    },
    'Show only with calls': {
        pt: 'Mostrar apenas com atendimentos',
        en: 'Show only with calls',
    },
    'show selected': {
        pt: 'Mostrar selecionados',
        en: 'Show selected',
    },
    'invert selection': {
        pt: 'Inverter seleção',
        en: 'Invert selection',
    },
    'Clear Selection': {
        pt: 'Limpar seleção',
        en: 'Clear Selection',
    },
    'Select a category': {
        pt: 'Selecione uma categoria',
        en: 'Select a category',
    },
    'View calls from this agent': {
        pt: 'Ver atendimentos deste agente',
        en: 'View calls from this agent',
    },
    Awaiting: {
        en: 'Awaiting',
        pt: 'Aguardando',
    },

    'Finished on the day': {
        pt: 'Finalizados no dia',
        en: 'Finished on the day',
    },
    'Revert changes': {
        pt: 'Reverter alterações',
        en: 'Revert changes',
    },
    'Publish changes': {
        pt: 'Publicar alterações',
        en: 'Publish changes',
    },
    'Flow inactive.': {
        pt: 'Fluxo inativo.',
        en: 'Flow inactive.',
    },
    'Clone flow': {
        pt: 'Clonar fluxo',
        en: 'Clone flow',
    },
    Permissions: {
        pt: 'Permissões',
        en: 'Permissions',
    },
    Permission: {
        pt: 'Permissão',
        en: 'Permission',
    },
    'registered users, being': {
        pt: 'usuários cadastrados, sendo',
        en: 'registered users, being',
    },
    inactive: {
        pt: 'inativo',
        en: 'inactive',
    },
    inactives: {
        pt: 'inativos',
        en: 'inactives',
    },
    Inactives: {
        pt: 'Inativos',
        en: 'Inactives',
    },
    'Inactivate flow': {
        pt: 'Inativar fluxo',
        en: 'Inactivate flow',
    },
    'Active flow': {
        pt: 'Ativar fluxo',
        en: 'Active flow',
    },
    'Are you sure you want to delete the flow?': {
        pt: 'Tem certeza que deseja excluir o fluxo?',
        en: 'Are you sure you want to delete the flow?',
    },
    'Find users in workspace': {
        pt: 'Encontrar usuários no workspace',
        en: 'Find users in workspace',
    },
    'There are no users to display here': {
        pt: 'Não há nenhum usuário para exibir aqui',
        en: 'There are no users to display here',
    },
    'Attach file': {
        pt: 'Anexar arquivo',
        en: 'Attach file',
    },
    View: {
        pt: 'Visualizar',
        en: 'View',
    },
    Visible: {
        pt: 'Visível',
        en: 'Visible',
    },
    Preview: {
        en: 'Preview',
        pt: 'Pré-visualização',
    },
    Extract: {
        pt: 'Extrair',
        en: 'Extract',
    },
    'Extracting...': {
        pt: 'Extraindo...',
        en: 'Extracting...',
    },
    'Error on extract': {
        pt: 'Erro ao extrair',
        en: 'Error on extract',
    },
    'UNREAD MESSAGES': {
        pt: 'MENSAGENS NÃO LIDAS',
        en: 'UNREAD MESSAGES',
    },
    'Assume conversation': {
        pt: 'Assumir atendimento',
        en: 'Assume attendance',
    },
    'Assume conversation and summarize': {
        pt: 'Assumir atendimento e resumir',
        en: 'Assume attendance and summarize',
    },
    'Error when assuming the service': {
        pt: 'Erro ao assumir o atendimento',
        en: 'Error when assuming the service',
    },
    'You are not part of the team which this service was assigned. Contact your supervisor': {
        pt: 'Você não faz parte do time ao qual este atendimento foi atribuído. Entre em contato com seu supervisor',
        en: 'You are not part of the team which this service was assigned. Contact your supervisor',
    },
    'You do not have permission in the team to which this service has been assigned. Please contact your supervisor': {
        pt: 'Você não possui permissão no time ao qual este atendimento foi atribuído. Entre em contato com seu supervisor',
        en: 'You do not have permission in the team to which this service has been assigned. Please contact your supervisor',
    },
    'You do not have permission to take over this service.': {
        pt: 'Você não possui permissão para assumir este atendimento.',
        en: 'You do not have permission to take over this service.',
    },
    Assume: {
        pt: 'Assumir',
        en: 'Assume',
    },
    Send: {
        pt: 'Enviar',
        en: 'Send',
    },
    'Select a conversation': {
        pt: 'Selecione um atendimento',
        en: 'Select a attendance',
    },
    'Select a contact': {
        pt: 'Selecione um contato',
        en: 'Select a contact',
    },
    'joined the conversation': {
        pt: 'entrou no atendimento',
        en: 'joined the attendance',
    },
    'assigned conversation to team': {
        en: 'assigned conversation to team',
        pt: 'atribuiu a conversa para o time',
    },
    Status: {
        en: 'Status',
        pt: 'Status',
    },
    'Conversation total': {
        en: 'Conversation total',
        pt: 'Total de conversas',
    },
    'Messages total': {
        en: 'Messages total',
        pt: 'Total de mensagens',
    },
    'Your browser do not support audio recording': {
        en: 'Your browser do not support audio recording',
        pt: 'Seu navegador não suporta gravação de áudio',
    },
    Workspace: {
        en: 'Workspace',
        pt: 'Área de trabalho',
    },
    'Tracking send settings for CustomerX integration': {
        en: 'Tracking send settings for CustomerX integration',
        pt: 'Configurações de envio Tracking para integração CustomerX',
    },
    'You cannot edit profile information.': {
        en: 'You cannot edit profile information.',
        pt: 'Você não pode editar as informações do perfil.',
    },
    'Minimum time': {
        en: 'Minimum time',
        pt: 'Tempo mínimo',
    },
    'Maximum time': {
        en: 'Maximum time',
        pt: 'Tempo máximo',
    },
    'Average agent first response time': {
        en: 'Average agent first response time',
        pt: 'Tempo Médio da Primeira Resposta do Agente',
    },
    'Average waiting time for service during active hours': {
        en: 'Average waiting time for service during active hours',
        pt: 'Tempo Médio de Espera para Atendimento em Horário Ativo',
    },
    'Average wait time in active hours': {
        en: 'Average wait time in active hours',
        pt: 'Tempo Médio em Horário Ativo',
    },
    'Median time for user reply': {
        en: 'Median time for user reply',
        pt: 'Tempo Médio para Resposta do Usuário',
    },
    'Median time for agent reply': {
        en: 'Median time for agent reply',
        pt: 'Tempo Médio para Resposta do Agente',
    },
    'Average waiting time for service in active hours of teams': {
        en: 'Average waiting time for service in active hours of teams',
        pt: 'Tempo Médio de Espera para Atendimento em Horário Ativo dos Times',
    },
    'This app need your permission to audio record': {
        en: 'This app need your permission to audio record. Enable it in the browser settings',
        pt: 'Este app precisa de sua permissão para gravar áudio. Habilite nas configurações do navegador',
    },
    'App name': {
        en: 'App name',
        pt: 'Nome do app',
    },
    'returned to the conversation': {
        pt: 'voltou para o atendimento',
        en: 'returned to the attendance',
    },
    'left the conversation': {
        pt: 'saiu do atendimento',
        en: 'left the attendance',
    },
    'assumed the conversation': {
        pt: 'assumiu o atendimento',
        en: 'assumed the attendance',
    },
    'ended the conversation': {
        pt: 'finalizou o atendimento',
        en: 'ended the attendance',
    },
    'Create Contact': {
        pt: 'Criar contato',
        en: 'Create Contact',
    },
    'Search contacts': {
        pt: 'Encontrar contatos',
        en: 'Search contacts',
    },
    'No contacts around here': {
        pt: 'Nenhum contato por aqui',
        en: 'No contacts around here',
    },
    'Create contact': {
        pt: 'Criar contato',
        en: 'Create contact',
    },
    'Conversation details': {
        pt: 'Detalhes do atendimento',
        en: 'Attendance details',
    },
    'Contact details': {
        pt: 'Detalhes do contato',
        en: 'Contact details',
    },
    'Contact history': {
        pt: 'Histórico do contato',
        en: 'Contact history',
    },
    'Invalid contact': {
        pt: 'Contato inválido',
        en: 'Invalid contact',
    },
    Warning: {
        pt: 'Aviso',
        en: 'Warning',
    },
    'There is already an open service for this contact on this channel': {
        pt: 'Já existe um atendimento aberto para este contato neste canal',
        en: 'There is already an open service for this contact on this channel',
    },
    'Upload successful.': {
        pt: 'Carregamento bem sucedido.',
        en: 'Upload successful.',
    },
    'Click to upload.': {
        pt: 'Clique para carregar.',
        en: 'Click to upload.',
    },
    'File uploaded successfully.': {
        pt: 'Arquivo enviado com sucesso.',
        en: 'File uploaded successfully.',
    },
    'File upload failed.': {
        pt: 'Falha no upload do arquivo.',
        en: 'File upload failed.',
    },
    'Accepted extensions: jpeg, png, 3gpp, mp4, pdf, txt, xls, xlsx, doc, docx, ppt, and pptx': {
        pt: 'Extensões aceitas: jpeg, png, 3gpp,mp4, pdf, txt, xls, xlsx, doc, docx, ppt, e pptx',
        en: 'Accepted extensions: jpeg, png, 3gpp, mp4, pdf, txt, xls, xlsx, doc, docx, ppt, and pptx',
    },
    Success: {
        pt: 'Sucesso',
        en: 'Success',
    },
    Ignored: {
        pt: 'Ignorado',
        en: 'Ignored',
    },
    ignored: {
        pt: 'Ignorado',
        en: 'Ignored',
    },
    Solved: {
        pt: 'Resolvido',
        en: 'Solved',
    },
    solved: {
        pt: 'Resolvido',
        en: 'Solved',
    },
    'Conversation created': {
        pt: 'Atendimento criado',
        en: 'Attendance created',
    },
    Details: {
        pt: 'Detalhes',
        en: 'Details',
    },
    'Select a channel': {
        pt: 'Selecione um canal',
        en: 'Select a channel',
    },
    'You need a channel like': {
        pt: 'Você precisa de um canal do tipo',
        en: 'You need a channel like',
    },
    'to start a conversation': {
        pt: 'para iniciar um atendimento',
        en: 'to start a attendance',
    },
    'Cell phone': {
        pt: 'Telefone',
        en: 'Cell phone',
    },
    'Identity number': {
        pt: 'Número da identidade',
        en: 'Identity number',
    },
    'No contact conversation history': {
        pt: 'Nenhum histórico de atendimento do contato',
        en: 'No contact attendance history',
    },
    participated: {
        pt: 'participou',
        en: 'participated',
    },
    'Conversations that': {
        pt: 'Atendimentos que',
        en: 'Attendances that',
    },
    Edit: {
        pt: 'Editar',
        en: 'Edit',
    },
    'Start conversation': {
        pt: 'Iniciar atendimento',
        en: 'Start attendance',
    },
    'Phone number required to start a conversation on this channel': {
        pt: 'Necessário número de telefone para iniciar um atendimento neste canal',
        en: 'Phone number required to start a attendance on this channel',
    },
    'New conversation': {
        pt: 'Novo Atendimento',
        en: 'New attendance',
    },
    'No contact information': {
        pt: 'Nenhuma informação do contato',
        en: 'No contact information',
    },
    'Participated in': {
        pt: 'Participou de',
        en: 'Participated in',
    },
    'conversation(s)': {
        pt: 'Atendimentos(s)',
        en: 'Attendance(s)',
    },
    Rating: {
        pt: 'Avaliação',
        en: 'Rating',
    },
    Ratings: {
        pt: 'Avaliações',
        en: 'Ratings',
    },
    stars: {
        pt: 'estrelas',
        en: 'stars',
    },
    star: {
        pt: 'estrela',
        en: 'star',
    },
    'Average between': {
        pt: 'Média entre',
        en: 'Average between',
    },
    'Number of ratings:': {
        pt: 'Número de avaliações:',
        en: 'Number of ratings:',
    },
    'With feedback': {
        pt: 'Com feedback',
        en: 'With feedback',
    },
    'No feedback': {
        pt: 'Sem feedback',
        en: 'No feedback',
    },
    None: {
        pt: 'Nenhuma',
        en: 'None',
    },
    'We identified agents in the table who are no longer on this team.': {
        pt: 'Identificamos agentes na tabela que não estão mais neste time.',
        en: 'We identified agents in the table who are no longer on this team.',
    },
    'Only show agents who are active on this team.': {
        pt: 'Mostrar apenas agentes que estão ativos neste time.',
        en: 'Only show agents who are active on this team.',
    },
    'Started in': {
        pt: 'Iniciado em',
        en: 'Started in',
    },
    Files: {
        pt: 'Arquivos',
        en: 'Files',
    },
    'Members in conversation': {
        pt: 'Membros no atendimento',
        en: 'Members in attendance',
    },
    'Reopen conversation': {
        pt: 'Reabrir atendimento',
        en: 'Reopen attendance',
    },
    'Conversation id': {
        pt: 'Identificação do atendimento',
        en: 'Attendance id',
    },
    conversation: {
        pt: 'atendimento',
        en: 'attendance',
    },
    'Mark as unread': {
        pt: 'Marcar como não lida',
        en: 'Mark as unread',
    },
    'Clear filters': {
        pt: 'Limpar filtros',
        en: 'Clear filters',
    },
    'Clear filter': {
        pt: 'Limpar filtro',
        en: 'Clear filter',
    },
    Clear: {
        pt: 'Limpar',
        en: 'Clear',
    },
    Filter: {
        pt: 'Filtrar',
        en: 'Filter',
    },
    'Value Filter': {
        pt: 'Filtro de Valores',
        en: 'Value Filter',
    },
    'applied filters': {
        pt: 'filtros aplicados',
        en: 'applied filters',
    },
    'applied filter': {
        pt: 'filtro aplicado',
        en: 'applied filter',
    },
    Reset: {
        pt: 'Limpar',
        en: 'Reset',
    },
    open: {
        pt: 'aberta',
        en: 'open',
    },
    closed: {
        pt: 'finalizada',
        en: 'closed',
    },
    'Filter conversations': {
        pt: 'Filtrar atendimentos',
        en: 'Filter attendances',
    },
    'Assumed by': {
        pt: 'Assumida por',
        en: 'Assumed by',
    },
    'Closed by': {
        pt: 'Finalizada por',
        en: 'Closed by',
    },
    unfinished: {
        pt: 'Não finalizadas',
        en: 'unfinished',
    },
    Apply: {
        pt: 'Aplicar',
        en: 'Apply',
    },
    Me: {
        pt: 'Mim',
        en: 'Me',
    },
    'An error has occurred. Try again': {
        pt: 'Ocorreu um erro. Tente novamente',
        en: 'An error has occurred. Try again',
    },
    'Files sent successfully': {
        pt: 'Arquivos enviados com sucesso',
        en: 'Files sent successfully',
    },
    'Annotations saved successfully': {
        pt: 'Anotações salvas com sucesso',
        en: 'Annotations saved successfully',
    },
    'Remove files above 100MB to enable sending.': {
        pt: 'Remova arquivos com mais de 100MB (limite por arquivo) para habilitar o envio.',
        en: 'Remove files above 100MB to enable sending.',
    },
    'Remove files that exceed the allowed size to enable sending.': {
        pt: 'Remova os arquivos que excedem o tamanho permitido para habilitar o envio.',
        en: 'Remove files that exceed the allowed size to enable sending.',
    },
    'There are files above 100MB. Remove them to enable sending.': {
        pt: 'Há arquivos acima de 100MB. Remova-os para habilitar o envio.',
        en: 'There are files above 100MB. Remove them to enable sending.',
    },
    'There are files that exceed the allowed size. Remove them to enable sending.': {
        pt: 'Há arquivos que excedem o tamanho permitido. Remova-os para habilitar o envio.',
        en: 'There are files that exceed the allowed size. Remove them to enable sending.',
    },
    'This file exceeds 100MB and needs to be removed.': {
        pt: 'Este arquivo ultrapassa 100MB e precisa ser removido.',
        en: 'This file exceeds 100MB and needs to be removed.',
    },
    'This file exceeds the allowed size for its type and needs to be removed.': {
        pt: 'Este arquivo excede o tamanho permitido para seu tipo e precisa ser removido.',
        en: 'This file exceeds the allowed size for its type and needs to be removed.',
    },
    'Maximum total size reached': {
        pt: 'Limite total do envio atingido',
        en: 'Maximum total size reached',
    },
    'The total size of selected files exceeds 100MB per upload.': {
        pt: 'A soma dos arquivos neste envio não pode ultrapassar 100MB.',
        en: 'The total size of selected files exceeds 100MB per upload.',
    },
    'Current total:': {
        pt: 'Total atual:',
        en: 'Current total:',
    },
    'Remove some files or send in smaller batches.': {
        pt: 'Remova alguns arquivos para ficar dentro do limite total de 100MB por envio.',
        en: 'Remove some files or send in smaller batches.',
    },
    'Upload too large': {
        pt: 'Envio muito grande',
        en: 'Upload too large',
    },
    'The upload was rejected because the request is too large (413). Send fewer files or smaller files.': {
        pt: 'Não foi possível enviar os arquivos porque o tamanho total ultrapassou o limite permitido. Remova alguns arquivos e tente novamente.',
        en: 'Could not send files because the total size exceeded the allowed limit. Remove some files and try again.',
    },
    'Total limit per upload': {
        pt: 'Limite total por envio',
        en: 'Total limit per upload',
    },
    'Limit per file': {
        pt: 'Limite por arquivo',
        en: 'Limit per file',
    },
    'Up to': {
        pt: 'Até',
        en: 'Up to',
    },
    'Add more files': {
        pt: 'Adicionar mais arquivos',
        en: 'Add more files',
    },
    file: {
        pt: 'arquivo',
        en: 'file',
    },
    files: {
        pt: 'arquivos',
        en: 'files',
    },
    'New contact': {
        pt: 'Novo contato',
        en: 'New contact',
    },
    'All users': {
        pt: 'Todos os usuários',
        en: 'All users',
    },
    Unreads: {
        pt: 'Não lidas',
        en: 'Unreads',
    },
    All: {
        pt: 'Todas',
        en: 'All',
    },
    'All of': {
        pt: 'Todos',
        en: 'All of',
    },
    Admin: {
        pt: 'Administrador',
        en: 'Administrator',
    },
    Agent: {
        pt: 'Agente',
        en: 'Agent',
    },
    Agents: {
        pt: 'Agentes',
        en: 'Agents',
    },
    'Contexto do Agente': {
        pt: 'Contexto do Agente',
        en: 'Agent Context',
    },
    'Selecionar Contexto': {
        pt: 'Selecionar Contexto',
        en: 'Select Context',
    },
    FAQ: {
        pt: 'FAQ',
        en: 'FAQ',
    },
    Geral: {
        pt: 'Geral',
        en: 'General',
    },
    Inactive: {
        pt: 'Inativo',
        en: 'Inactive',
    },
    'Conversation members': {
        pt: 'Membros da conversa',
        en: 'Conversation members',
    },
    'Search conversations': {
        pt: 'Encontrar atendimentos e contatos',
        en: 'Search attendances and contacts',
    },
    'Search message': {
        pt: 'Buscar mensagem',
        en: 'Search message',
    },
    "We didn't find any results, please try again": {
        pt: 'Não encontramos nenhum resultado, tente novamente',
        en: "We didn't find any results, please try again",
    },
    Contacts: {
        pt: 'Contatos',
        en: 'Contacts',
    },
    Conversations: {
        pt: 'Atendimentos',
        en: 'Attendances',
    },
    'Leave conversation': {
        pt: 'Sair do atendimento',
        en: 'Leave attendance',
    },
    'Conversation Ended': {
        pt: 'Atendimento finalizado',
        en: 'Attendance Ended',
    },
    'Conversation cannot be terminated': {
        pt: 'Atendimento não pode ser finalizado',
        en: 'Attendance cannot be terminated',
    },
    'You cannot leave this conversation': {
        pt: 'Você não pode sair deste atendimento',
        en: 'You cannot leave this attendance',
    },
    'You left the conversation': {
        pt: 'Você saiu do atendimento',
        en: 'You left the attendance',
    },
    'is no longer part of the conversation': {
        pt: 'não faz mais parte do atendimento',
        en: 'is no longer part of the attendance',
    },
    'is a active member in conversation': {
        pt: 'é um membro ativo no atendimento',
        en: 'is a active member in conversation',
    },

    'Edit tag': {
        pt: 'Editar etiqueta',
        en: 'Edit tag',
    },
    Color: {
        pt: 'Cor',
        en: 'Color',
    },
    Tags: {
        pt: 'Etiquetas',
        en: 'Tags',
    },
    Tag: {
        pt: 'Etiqueta',
        en: 'Tag',
    },
    'Create tag': {
        pt: 'Criar etiqueta',
        en: 'Create tag',
    },
    'Has integration': {
        pt: 'Contém integração',
        en: 'Has integration',
    },
    'Should bill whatsapp': {
        pt: 'Deve cobrar whatsapp',
        en: 'Should bill whatsapp',
    },
    'Integration active message': {
        pt: 'Integração mensagem ativa',
        en: 'Integration active message',
    },
    'Active message': {
        pt: 'Mensagem ativa',
        en: 'Active message',
    },
    'Are you sure you want to delete the integration active message?': {
        pt: 'Tem certeza de que deseja excluir a integração de mensagem ativa?',
        en: 'Are you sure you want to delete the integration active message?',
    },
    'Active message successfully created': {
        pt: 'Mensagem ativa criado com sucesso',
        en: 'Active message successfully created',
    },
    'No active message integration found': {
        pt: 'Nenhuma integração de mensagem ativa encontrada',
        en: 'No active message integration found',
    },
    confirmSchedule: {
        pt: 'Confirmação de Agendamento',
        en: 'confirmSchedule',
    },
    avaliableScheduleInList: {
        pt: 'Horário Disponível na Lista',
        en: 'avaliableScheduleInList',
    },
    confirmScheduleWithLinkButtonTitle: {
        pt: 'Botão Confirmação de Agendamentos com Link',
        en: 'confirmScheduleWithLinkButtonTitle',
    },
    Identifier: {
        pt: 'Identificador',
        en: 'Identifier',
    },
    'Custom integration messages configuration via JSON': {
        pt: 'Configurações customizadas das mensagens da integração via JSON',
        en: 'Custom integration messages configuration via JSON',
    },
    'This JSON will be merged with the current integration messages configuration': {
        pt: 'Este JSON será mesclado com a configuração atual de mensagens da integração',
        en: 'This JSON will be merged with the current integration messages configuration',
    },
    'Active message status': {
        pt: 'Status Mensagem ativa',
        en: 'Active message status',
    },
    'Are you sure you want to delete the status?': {
        pt: 'Tem certeza que deseja excluir o status?',
        en: 'Are you sure you want to delete the status?',
    },
    'Are you sure you want to delete the custom flow? It might be in use in the tree or broadcast list.': {
        pt: 'Tem certeza de que deseja excluir o fluxo personalizado? Pode estar em uso na árvore ou na lista de transmissão.',
        en: 'Are you sure you want to delete the custom flow? It might be in use in the tree or broadcast list.',
    },
    'The custom flow is being used in some integration.': {
        pt: 'O fluxo personalizado esta sendo utilizado em alguma integração.',
        en: 'The custom flow is being used in some integration.',
    },
    'Integration updated successfully': {
        pt: 'Integração atualizada com sucesso',
        en: 'Integration updated successfully',
    },
    'View screenshot': {
        pt: 'Ver screenshot',
        en: 'View screenshot',
    },
    'Duplicated tag': {
        pt: 'Tag duplicada',
        en: 'Duplicated tag',
    },
    'Something went wrong': {
        pt: 'Algo deu errado',
        en: 'Something went wrong',
    },
    'Reassume conversation': {
        pt: 'Reassumir atendimento',
        en: 'Reassume attendance',
    },
    'A contact already exists with the phone number you entered': {
        pt: 'Já existe um contato com o número de telefone que você digitou',
        en: 'A contact already exists with the phone number you entered',
    },
    'The data previously entered will be lost and the conversation linked to this contact': {
        pt: 'Os dados digitados anteriormente serão perdidos e o atendimento vinculado a este contato',
        en: 'The data previously entered will be lost and the attendance linked to this contact',
    },
    Associate: {
        pt: 'Associar',
        en: 'Associate',
    },
    'Back and edit': {
        pt: 'Voltar e editar',
        en: 'Back and edit',
    },
    'This conversation did not generate a contact': {
        pt: 'Este atendimento não gerou um contato',
        en: 'This attendance did not generate a contact',
    },
    'Contact info': {
        pt: 'Informações do contato',
        en: 'Contact info',
    },
    Participants: {
        pt: 'Participantes',
        en: 'Participants',
    },
    'is an active member of the conversation': {
        pt: 'é um membro ativo no atendimento',
        en: 'is an active member of the attendance',
    },
    Example: {
        pt: 'Exemplo',
        en: 'Example',
    },
    'Enter a email': {
        pt: 'Insira um email',
        en: 'Enter a email',
    },
    'Enter a phone number': {
        pt: 'Insira um telefone',
        en: 'Enter a phone number',
    },
    'Enter a name': {
        pt: 'Insira um nome',
        en: 'Enter a name',
    },
    'Contact created': {
        pt: 'O contato foi criado',
        en: 'Contact create',
    },
    'Yes, update': {
        pt: 'Sim, atualizar',
        en: 'Yes, update',
    },
    'A contact already exists with the data entered. Do you want to update with the information already entered?': {
        pt: 'Já existe um contato criado com os dados informados. Deseja atualizar com as informações já digitadas?',
        en: 'A contact already exists with the data entered. Do you want to update with the information already entered?',
    },
    'To create a conversation, you need to select the channel it will be linked to': {
        pt: 'Para criar um atendimento, você precisa selecionar o canal que ela ficará vinculada',
        en: 'To create a attendance, you need to select the channel it will be linked to',
    },
    Contact: {
        pt: 'Contato',
        en: 'Contact',
    },
    'Comercial account': {
        pt: 'Conta comercial',
        en: 'Comercial account',
    },
    in: {
        pt: 'em',
        en: 'in',
    },
    'Create conversation': {
        pt: 'Iniciar atendimento',
        en: 'Start attendance',
    },
    Loading: {
        pt: 'Carregando',
        en: 'Loading',
    },
    'Loading more': {
        pt: 'Carregando mais',
        en: 'Loading more',
    },
    'Enter your message here': {
        pt: 'Insira sua mensagem aqui',
        en: 'Enter your message here',
    },
    'Enter your message here or type "/" to select a template': {
        pt: 'Insira sua mensagem aqui ou digite "/" para selecionar um template',
        en: 'Enter your message here or type "/" to select a template',
    },
    'Type "/" to select a template': {
        pt: 'Digite "/" para selecionar um template',
        en: 'Type "/" to select a template',
    },
    Close: {
        pt: 'Finalizar',
        en: 'Close',
    },
    'Show suspended conversations': {
        pt: 'Mostrar conversas suspensas',
        en: 'Show suspended conversations',
    },
    'suspended conversation until': {
        pt: 'suspendeu a conversa até',
        en: 'suspended conversation until',
    },
    Suspend: {
        pt: 'Suspender',
        en: 'Suspend',
    },
    'Suspend until': {
        pt: 'Suspender até',
        en: 'Suspend until',
    },
    suspended: {
        pt: 'suspensa',
        en: 'suspended',
    },
    Leave: {
        pt: 'Sair',
        en: 'Leave',
    },
    'More options': {
        pt: 'Mais opções',
        en: 'More options',
    },
    'Attribute with name': {
        pt: 'Atributo com nome',
        en: 'Attribute with name',
    },
    'Save token in attribute': {
        pt: 'Salvar token no atributo',
        en: 'Save token in attribute',
    },
    'sex attribute of the person': {
        pt: 'Atributo com sexo da pessoa',
        en: 'sex attribute of the person',
    },
    'No account': {
        pt: 'Sem conta',
        en: 'No account',
    },
    'Friendly name to be displayed in a tag': {
        pt: 'Nome amigável para ser exibido em uma tag',
        en: 'Friendly name to be displayed in a tag',
    },
    'Confirm attendance exit?': {
        pt: 'Confirma saída do atendimento?',
        en: 'Confirm attendance exit?',
    },
    'Confirm attendance end?': {
        pt: 'Confirma encerramento do atendimento?',
        en: 'Confirm attendance end?',
    },
    'Updated workspace': {
        pt: 'Workspace atualizado',
        en: 'Updated workspace',
    },
    'Error creating user. Try again.': {
        pt: 'Erro ao criar o usuário. Tente novamente',
        en: 'Error creating user. Try again',
    },
    'Select a agent': {
        en: 'Select a agent',
        pt: 'Selecione um agente',
    },
    'Assessment date': {
        en: 'Assessment date',
        pt: 'Data de avaliação',
    },
    'End date of service': {
        en: 'End date of service',
        pt: 'Data finalização do atendimento',
    },
    'Select or type a tag': {
        en: 'Select or type a tag',
        pt: 'Selecione ou digite uma etiqueta',
    },
    'Filter tags': {
        en: 'Filter tags',
        pt: 'Filtrar etiquetas',
    },
    'Filter channels': {
        en: 'Filter channels',
        pt: 'Filtrar canais',
    },
    User: {
        pt: 'Usuário',
        en: 'User',
    },
    'Show messages': {
        pt: 'Mostrar mensagens',
        en: 'Show messages',
    },
    'Show rating after close conversation': {
        pt: 'Mandar avaliação após finalizar atendimento',
        en: 'Show rating after close conversation',
    },
    'Is closed by user': {
        pt: 'É finalizado pelo usuário',
        en: 'Is closed by user',
    },
    'Error updating user data. Try again': {
        pt: 'Erro ao atualizar os dados do usuário. Tente novamente',
        en: 'Error updating user data. Try again',
    },
    'If the account was created, go to the interaction': {
        pt: 'Se a conta foi criada, ir até a interação',
        en: 'If the account was created, go to the interaction',
    },
    'if the account does not exist, go to the interaction': {
        pt: 'se a conta não existir, ir até a interação',
        en: 'if the account does not exist, go to the interaction',
    },
    'if the account exists, go to the interaction': {
        pt: 'se a conta existir, ir até a interação',
        en: 'if the account exists, go to the interaction',
    },
    'if an error occurs, go to the interaction': {
        pt: 'se ocorrer um erro, ir até a interação',
        en: 'if an error occurs, go to the interaction',
    },
    'Account does not exist': {
        pt: 'Conta não existe',
        en: 'Account does not exist',
    },
    'Account exists': {
        pt: 'Conta existe',
        en: 'Account exists',
    },
    'Phone battery low': {
        pt: 'Telefone com bateria fraca',
        en: 'Phone battery low',
    },
    'Charge your phone to keep using WhatsApp.': {
        pt: 'Carregue seu telefone para continuar usando o WhatsApp.',
        en: 'Charge your phone to keep using WhatsApp.',
    },
    'Phone without connection.': {
        pt: 'Telefone sem conexão.',
        en: 'Phone without connection.',
    },
    'Make sure your phone has an active Internet connection.': {
        pt: 'Verifique se o telefone possui uma conexão ativa com a Internet.',
        en: 'Make sure your phone has an active Internet connection.',
    },
    Unconnected: {
        pt: 'Não conectado',
        en: 'Unconnected',
    },
    Unauthenticated: {
        pt: 'Não autenticado',
        en: 'Unauthenticated',
    },
    "You're not online": {
        pt: 'Você não está online',
        en: "You're not online",
    },
    "This computer's internet connection appears to be offline.": {
        pt: 'A conexão com a internet deste computador parece estar offline.',
        en: "This computer's internet connection appears to be offline.",
    },
    'Criteria used to find the correct faq value by a value in the bot context': {
        pt: 'Criteria é usado para encontrar o valor correto de faq em um valor no contexto do bot',
        en: 'Criteria used to find the correct faq value by a value in the bot context',
    },
    'Faq value saved': {
        pt: 'Faq value salvo',
        en: 'Faq value saved',
    },
    'Rating settings': {
        pt: 'Configurações da avaliação',
        en: 'Rating settings',
    },
    'Fill in a message that motivates the patient to rate the service': {
        pt: 'Preencha com uma mensagem que motive o paciente a dar uma nota para o atendimento',
        en: 'Fill in a message that motivates the patient to rate the service',
    },
    'How was your service with us?': {
        pt: 'Como foi seu atendimento conosco?',
        en: 'How was your service with us?',
    },
    'Fill in with a message that motivates the patient to give feedback on the service': {
        pt: 'Preencha com uma mensagem que motive o paciente a dar um feedback do atendimento',
        en: 'Fill in with a message that motivates the patient to give feedback on the service',
    },
    'Leave a message for us:': {
        pt: 'Deixe uma mensagem para nós:',
        en: 'Leave a message for us:',
    },
    'Message that will be sent along with the evaluation link for the patient at the end of the service': {
        pt: 'Mensagem que será enviada junto com o link de avaliação para o paciente no fim do atendimento',
        en: 'Message that will be sent along with the evaluation link for the patient at the end of the service',
    },
    'Rate your service on the link below': {
        pt: 'Avalie o seu atendimento no link abaixo',
        en: 'Rate your service on the link below',
    },
    'Link message': {
        pt: 'Mensagem do link',
        en: 'Link message',
    },
    'Send evaluation for all calls from any team': {
        pt: 'Enviar avaliação para todos os atendimentos de qualquer time',
        en: 'Send evaluation for all calls from any team',
    },
    'You can send evaluation at the end of the service for all teams or select the teams that will be sent': {
        pt: 'Pode enviar avaliação no final do atendimento para todos os times ou selecione os times que serão enviados',
        en: 'You can send evaluation at the end of the service for all teams or select the teams that will be sent',
    },
    'Send rating for all calls from any channel': {
        pt: 'Enviar avaliação para todos os atendimentos de qualquer canal',
        en: 'Send rating for all calls from any channel',
    },
    'You can send evaluation at the end of the service for all channels or select the channels that will be sent': {
        pt: 'Pode enviar avaliação no final do atendimento para todos os canais ou selecione os canais que serão enviados',
        en: 'You can send evaluation at the end of the service for all channels or select the channels that will be sent',
    },
    'Select the faq to use': {
        pt: 'Selecione o faq value',
        en: 'Select the faq to use',
    },
    'Select one': {
        pt: 'Selecione um',
        en: 'Select one',
    },
    'Bundled CSV download': {
        pt: 'Download CSV agrupado',
        en: 'Bundled CSV download',
    },
    'Download all received files (except audio)': {
        pt: 'Baixar todos arquivos recebidos (exceto aúdio)',
        en: 'Download all received files (except audio)',
    },
    'Download files as ZIP': {
        pt: 'Baixar arquivos (.zip)',
        en: 'Download files (.zip)',
    },
    'Sorry we get an error, verify fields and try again': {
        pt: 'Desculpe, ocorreu um erro, verifique os campos e tente novamente',
        en: 'Sorry we get an error, verify fields and try again',
    },
    'Sorry we get an error, verify interaction and try again! ': {
        pt: 'Desculpe, recebemos um erro, verifique a interação e tente novamente! ',
        en: 'Sorry we get an error, verify interaction and try again! ',
    },
    'Item deleted successfully': {
        pt: 'Item deletado com sucesso',
        en: 'Item deleted successfully',
    },
    'Are you sure you want to delete faq': {
        pt: 'Tem certeza de que deseja excluir o faq value',
        en: 'Are you sure you want to delete faq',
    },
    'List Faq empty': {
        pt: 'Lista vazia',
        en: 'List Faq empty',
    },
    'Delete selected': {
        pt: 'Excluir selecionados',
        en: 'Delete selected',
    },
    Required: {
        pt: 'Obrigatório',
        en: 'Required',
    },
    Roles: {
        pt: 'Permissões',
        en: 'Roles',
    },
    Segment: {
        pt: 'Segmento',
        en: 'Segment',
    },
    Category: {
        pt: 'Categoria',
        en: 'Category',
    },
    Categories: {
        pt: 'Categorias',
        en: 'Categories',
    },
    'Successfully edited': {
        pt: 'Editado com sucesso',
        en: 'Successfully edited',
    },
    'Saved successfully': {
        pt: 'Salvo com sucesso',
        en: 'Saved successfully',
    },
    'Action performed successfully': {
        pt: 'Ação realizada com sucesso',
        en: 'Action performed successfully',
    },
    'Clear integration cache': {
        pt: 'Limpar cache da integração',
        en: 'Clear integration cache',
    },
    Sample: {
        pt: 'Exemplo',
        en: 'Sample',
    },
    Description: {
        pt: 'Descrição',
        en: 'Description',
    },
    'No faq registered': {
        pt: 'Nenhuma pergunta frequente cadastrada',
        en: 'No faq registered',
    },
    'No category selected': {
        pt: 'Nenhuma categoria selecionada',
        en: 'No faq selected',
    },
    'Save all and Continue': {
        pt: 'Salvar tudo e continuar',
        en: 'Save all and Continue',
    },
    'Save all': {
        pt: 'Salvar tudo',
        en: 'Save all',
    },
    'Nothing to show here': {
        pt: 'Entrada',
        en: 'Nothing to show here',
    },
    'No category registered': {
        pt: 'Nenhuma categoria cadastrada',
        en: 'No category registered',
    },
    'Add response': {
        pt: 'Adicionar resposta',
        en: 'Add response',
    },
    Responses: {
        pt: 'Respostas',
        en: 'Responses',
    },
    'Type a number to contact': {
        pt: 'Digite o número do contato',
        en: 'Type a number to contact',
    },
    'Avaliable on whatsapp': {
        pt: 'Disponível para whatsapp',
        en: 'Avaliable on whatsapp',
    },
    'Whatsapp number': {
        pt: 'Número Whatsapp',
        en: 'Whatsapp number',
    },
    'Click here': {
        pt: 'Clique aqui',
        en: 'Click here',
    },
    'to start a conversation.': {
        pt: 'para iniciar um atendimento.',
        en: 'to start a attendance.',
    },
    'Not avaliable on whatsapp': {
        pt: 'Não disponível para whatsapp',
        en: 'Not avaliable on whatsapp',
    },
    'This number is not avaliable to use on whatsapp, try other number.': {
        pt: 'Este número não é disponível para usar whatsapp, tente outro número.',
        en: 'This number is not avaliable to use on whatsapp, try other number.',
    },
    'Could not validate': {
        pt: 'Não foi possível validar',
        en: 'Could not validate',
    },
    'Could not validate this number, try later.': {
        pt: 'Não foi possível validar este número, tente mais tarde.',
        en: 'Could not validate this number, try later.',
    },
    'Have an open conversation': {
        pt: 'Possui atendimento aberto',
        en: 'Has open service',
    },
    'Attribute copied successfully!': {
        pt: 'Atributo copiado com sucesso!',
        en: 'Attribute copied successfully!',
    },
    'Error copying attribute!': {
        pt: 'Erro ao copiar o atributo!',
        en: 'Error copying attribute!',
    },
    'Token copied successfully!': {
        pt: 'Token copiado com sucesso!',
        en: 'Token copied successfully!',
    },
    'Error copying token!': {
        pt: 'Erro ao copiar o token!',
        en: 'Error copying token!',
    },
    'Message copied successfully!': {
        pt: 'Mensagem copiada com sucesso!',
        en: 'Message copied successfully!',
    },
    'Copy message': {
        pt: 'Copiar mensagem',
        en: 'Copy message',
    },
    'Error copying message!': {
        pt: 'Erro ao copiar mensagem!',
        en: 'Error copying message!',
    },
    'No content to copy': {
        pt: 'Nenhum conteúdo para copiar',
        en: 'No content to copy',
    },
    'Omitir conteúdo': {
        pt: 'Omitir conteúdo',
        en: 'Omit content',
    },
    'This action will remove the message content. This action cannot be undone.': {
        pt: 'Esta ação irá remover o conteúdo da mensagem. Ação não pode ser desfeita.',
        en: 'This action will remove the message content. This action cannot be undone.',
    },
    'Error omitting message content': {
        pt: 'Erro ao omitir conteúdo da mensagem',
        en: 'Error omitting message content',
    },
    'Message content omitted successfully': {
        pt: 'Conteúdo da mensagem omitido com sucesso',
        en: 'Message content omitted successfully',
    },
    '[Conteudo omitido]': {
        pt: 'Conteúdo omitido',
        en: 'Content omitted',
    },
    React: {
        pt: 'Reagir',
        en: 'React',
    },
    'This number have an opened conversation.': {
        pt: 'Este número possui um atendimento em aberto',
        en: 'This number have an opened attendance.',
    },
    'to open a conversation.': {
        pt: 'para abrir um atendimento.',
        en: 'to open a attendance.',
    },
    'You are not authenticated.': {
        pt: 'Você não está autenticado.',
        en: 'You are not authenticated.',
    },
    'You are authenticated in other device.': {
        pt: 'Você está conectado em outro dispositivo.',
        en: 'You are authenticated in other device.',
    },
    'to scan QR Code.': {
        pt: 'para ler o QR Code.',
        en: 'to scan QR Code.',
    },
    'try again': {
        pt: 'tentar novamente.',
        en: 'try again',
    },
    'to use this device.': {
        pt: 'para usar esse dispositivo.',
        en: 'to use this device.',
    },
    'Successfully deleted': {
        pt: 'Excluído com sucesso',
        en: 'Successfully deleted',
    },
    'It is not possible to remove an attribute in use': {
        pt: 'Não é possivel remover um atributo em uso',
        en: 'It is not possible to remove an attribute in use',
    },
    'You have exceeded the maximum integrated messages': {
        pt: 'Você excedeu o máximo de mensagens integradas',
        en: 'You have exceeded the maximum integrated messages',
    },
    'Invalid channel': {
        pt: 'Canal inválido',
        en: 'Invalid channel',
    },
    'If the channel is outside office hours, the bot will continue from an interaction.': {
        pt: 'Se o canal estiver fora do horário de atendimento, o bot continuará a partir de uma interação.',
        en: 'If the channel is outside office hours, the bot will continue from an interaction.',
    },
    'Transfer destination channel Id': {
        pt: 'Id do Canal destino da transferência',
        en: 'Transfer destination channel Id',
    },
    'Transfer destination channel': {
        pt: 'Canal destino da transferência',
        en: 'Transfer destination channel',
    },
    'Channel Id': {
        pt: 'Id do canal',
        en: 'Channel Id',
    },
    'Create channel': {
        pt: 'Criar canal',
        en: 'Create channel',
    },
    'Select a color': {
        pt: 'Selecione uma cor',
        en: 'Select a color',
    },
    'Invalid color': {
        pt: 'Cor inválida',
        en: 'Invalid color',
    },
    'Show QRCode': {
        pt: 'Mostrar QRCode',
        en: 'Show QRCode',
    },
    and: {
        pt: 'e',
        en: 'and',
    },
    Configurations: {
        pt: 'Configurações',
        en: 'Configurations',
    },
    Attributes: {
        pt: 'Atributos',
        en: 'Attributes',
    },
    'AI Summary Attributes': {
        pt: 'Atributos do Resumo da IA',
        en: 'AI Summary Attributes',
    },
    'Recently accessed': {
        pt: 'Acessado recentemente',
        en: 'Recently accessed',
    },
    'Channel updated successfully': {
        pt: 'Canal atualizado com sucesso',
        en: 'Channel updated successfully',
    },
    General: {
        pt: 'Geral',
        en: 'General',
    },
    Attendance: {
        pt: 'Atendimento',
        en: 'Attendance',
    },
    Attendances: {
        pt: 'Atendimentos',
        en: 'Attendances',
    },
    'General settings': {
        pt: 'Configurações gerais',
        en: 'General settings',
    },
    Settings: {
        pt: 'Configurações',
        en: 'Settings',
    },
    'SSO Settings': {
        pt: 'Configurações SSO',
        en: 'SSO Settings',
    },
    'SSO Name': {
        pt: 'Nome SSO',
        en: 'SSO Name',
    },
    'SSO ID': {
        pt: 'ID SSO',
        en: 'SSO ID',
    },
    plan: {
        pt: 'Plano',
        en: 'Plan',
    },
    planPrice: {
        pt: 'Preço do plano',
        en: 'Plan price',
    },
    planMessageLimit: {
        pt: 'Limite de mensagens do plano',
        en: 'Plan message limit',
    },
    planExceededMessagePrice: {
        pt: 'Preço por mensagem excedida',
        en: 'Exceeded message price',
    },
    planHsmMessageLimit: {
        pt: 'Limite de mensagens Hsm do plano',
        en: 'Exceeded message Hsm',
    },
    planHsmExceedMessagePrice: {
        pt: 'Preço por mensagem Hsm excedida',
        en: 'Hsm exceeded message price',
    },
    planUserLimit: {
        pt: 'Limite de usuários do plano',
        en: 'Plan user limit',
    },
    planUserExceedPrice: {
        pt: 'Preço por usuário excedido',
        en: 'User exceeded price',
    },
    planConversationLimit: {
        pt: 'Limite de atendimentos do plano',
        en: 'Plan conversation limit',
    },
    planConversationExceedPrice: {
        pt: 'Preço por atendimento excedido',
        en: 'Plan conversation exceeded price',
    },
    startAt: {
        pt: 'Data de inicio',
        en: 'Start at',
    },
    accountId: {
        pt: 'Conta',
        en: 'Account',
    },
    dueDate: {
        pt: 'Data de vencimento',
        en: 'Due date',
    },
    'Workspace billing specification': {
        pt: 'Especificações de cobrança',
        en: 'Workspace billing specification',
    },
    'Workspace phone numbers': {
        pt: 'Números do workspace',
        en: 'Workspace phone numbers',
    },
    'Includes active, inactive and removed workspace numbers': {
        pt: 'Inclui números ativos, inativos e removidos do workspace',
        en: 'Includes active, inactive and removed workspace numbers',
    },
    'No workspace phone numbers registered': {
        pt: 'Nenhum número do workspace cadastrado',
        en: 'No workspace phone numbers registered',
    },
    'Channel name': {
        pt: 'Nome do canal',
        en: 'Channel name',
    },
    Provider: {
        pt: 'Provedor',
        en: 'Provider',
    },
    'Last update': {
        pt: 'Última atualização',
        en: 'Last update',
    },
    'Updated by': {
        pt: 'Atualizado por',
        en: 'Updated by',
    },
    Removed: {
        pt: 'Removido',
        en: 'Removed',
    },
    Timezone: {
        pt: 'Fuso horário',
        en: 'Timezone',
    },
    'Select timezone': {
        pt: 'Selecione o fuso horário',
        en: 'Select timezone',
    },
    'Enter custom timezone (e.g., America/Sao_Paulo)': {
        pt: 'Digite um fuso horário personalizado (ex: America/Sao_Paulo)',
        en: 'Enter custom timezone (e.g., America/Sao_Paulo)',
    },
    'Expiration of attendance': {
        pt: 'Expiração do atendimento',
        en: 'Expiration of attendance',
    },
    'Notice: At half of the configured time, the "before_end_conversation" interaction is triggered. Its purpose is to re-engage the patient who became inactive in the flow.':
        {
            pt: 'Aviso: Na metade do tempo configurado, é enviada a interação "before_end_conversation", que tem o objetivo de retomar o contato com o paciente inativo no fluxo.',
            en: 'Notice: At half of the configured time, the "before_end_conversation" interaction is triggered. Its purpose is to re-engage the patient who became inactive in the flow.',
        },
    'Example: If the total time is 1 hour, this interaction will be triggered at 30 minutes; when the full hour is reached, the session will be automatically finalized by the bot.':
        {
            pt: ' Ex: Se o tempo total for de 1 hora, essa interação será disparada aos 30 minutos; quando completar às 1 hora, o atendimento será finalizado automaticamente pelo bot.',
            en: 'Example: If the total time is 1 hour, this interaction will be triggered at 30 minutes; when the full hour is reached, the session will be automatically finalized by the bot.',
        },
    Actions: {
        pt: 'Ações',
        en: 'Actions',
    },
    Definitions: {
        pt: 'Definições',
        en: 'Definitions',
    },
    'Chat title': {
        pt: 'Título do chat',
        en: 'Chat title',
    },
    'Chat color': {
        pt: 'Cor do chat',
        en: 'Chat color',
    },
    'Avatar link': {
        pt: 'Link do avatar',
        en: 'Avatar link',
    },
    'Enable tooltip above the chat start button': {
        pt: 'Habilitar tooltip acima do botão de inicio de chat',
        en: 'Enable tooltip above the chat start button',
    },
    'Text that will be displayed in the tooltip': {
        pt: 'Texto que será exibido no tooltip',
        en: 'Text that will be displayed in the tooltip',
    },
    Behavior: {
        pt: 'Comportamento',
        en: 'Behavior',
    },
    'Start chat as soon as the page loads': {
        pt: 'Iniciar o chat assim que a página for carregada',
        en: 'Start chat as soon as the page loads',
    },
    'Show action for the user to confirm whether to initiate a chat': {
        pt: 'Exibir ação para o usuário confirmar se deseja iniciar um chat',
        en: 'Show action for the user to confirm whether to initiate a chat',
    },
    "Load the user's last conversation if it can be restored": {
        pt: 'Carregar a última conversa do usuário caso seja possível restaurá-la',
        en: "Load the user's last conversation if it can be restored",
    },
    'Create now': {
        pt: 'Criar agora',
        en: 'Create now',
    },
    'No channels registered': {
        pt: 'Nenhum canal cadastrado',
        en: 'No channels registered',
    },
    'Code to place the bot on your website': {
        pt: 'Código para colocar o bot em seu site',
        en: 'Code to place the bot on your website',
    },
    "Copy the snippet and paste it into your site's <head> tag": {
        pt: 'Copie o snippet e cole-o dentro da tag <head> de seu site',
        en: "Copy the snippet and paste it into your site's <head> tag",
    },
    Appearance: {
        pt: 'Aparência',
        en: 'Appearance',
    },
    Code: {
        pt: 'Código',
        en: 'Code',
    },
    Informations: {
        pt: 'Informações',
        en: 'Informations',
    },
    pages: {
        pt: 'páginas',
        en: 'pages',
    },
    Events: {
        pt: 'Eventos',
        en: 'Events',
    },
    'These are the events available for interaction with the whatsApp session': {
        pt: 'Estes são os eventos disponíveis para interação com a sessão do whatsApp',
        en: 'These are the events available for interaction with the whatsApp session',
    },
    'There is no session started, so there is no data on it': {
        pt: 'Não existe nenhum sessão iniciada, logo não existem dados sobre a mesma',
        en: 'There is no session started, so there is no data on it',
    },
    'Last message': {
        pt: 'Última mensagem',
        en: 'Last message',
    },
    Closed: {
        pt: 'Fechado',
        en: 'Closed',
    },
    Sex: {
        pt: 'Sexo',
        en: 'Sex',
    },
    'Select a interval': {
        pt: 'Selecione um intervalo',
        en: 'Select a interval',
    },
    'Select a team': {
        pt: 'Selecione um time',
        en: 'Select a team',
    },
    'Select a user': {
        pt: 'Selecione um usuário',
        en: 'Select a user',
    },
    Saturday: {
        pt: 'Sábado',
        en: 'Saturday',
    },
    'Remove period': {
        pt: 'Remover período',
        en: 'Remove period',
    },
    LoggedIn: {
        pt: 'Logado',
        en: 'Logged In',
    },
    notLoggedIn: {
        pt: 'Não logado',
        en: 'Not Logged In',
    },
    'Init session': {
        pt: 'Iniciar sessão',
        en: 'Init session',
    },
    Refresh: {
        pt: 'Atualizar',
        en: 'Refresh',
    },
    'No attributes created': {
        pt: 'Nenhum atributo criado',
        en: 'No attributes created',
    },
    'This attribute is being used in the following interactions': {
        pt: 'Este atributo está sendo utilizado nas seguintes interações',
        en: 'This attribute is being used in the following interactions',
    },
    'Click to view': {
        pt: 'Clique para ver',
        en: 'Click to view',
    },
    'Expiring attendance': {
        pt: 'Expirar atendimento',
        en: 'Expiring attendance',
    },
    'Multiple expiration warnings': {
        pt: 'Avisos múltiplos de expiração',
        en: 'Multiple expiration warnings',
    },
    'Warnings after the last message': {
        pt: 'Avisos após a última mensagem do paciente',
        en: "Warnings after the patient's last message",
    },
    'Add warning': {
        pt: 'Adicionar aviso',
        en: 'Add warning',
    },
    'The warning time must be shorter than the expiration time of the channel.': {
        pt: 'O tempo do aviso deve ser menor que o tempo de expiração do canal.',
        en: 'The warning time must be shorter than the expiration time of the channel.',
    },
    'Each warning triggers the interaction with the trigger "expiracao_N" after the patient stays silent for the configured time, counted from the patient\'s last message (e.g. 20 min expiration with 5, 10 and 15 min warnings fires expiracao_1 at 5 min of silence, expiracao_2 at 10 and expiracao_3 at 15). The warning at half of the time ("before_end_conversation") keeps working alongside. Applies to conversations started from now on.':
        {
            pt: 'Cada aviso dispara a interação com o trigger "expiracao_N" quando o paciente fica o tempo indicado sem mandar mensagem, contado da última mensagem dele (ex.: expiração de 20 min com avisos de 5, 10 e 15 min dispara expiracao_1 aos 5 min de silêncio, expiracao_2 aos 10 e expiracao_3 aos 15). O aviso da metade do tempo ("before_end_conversation") continua funcionando junto. Vale para as conversas iniciadas a partir de agora.',
            en: 'Each warning triggers the interaction with the trigger "expiracao_N" after the patient stays silent for the configured time, counted from the patient\'s last message (e.g. 20 min expiration with 5, 10 and 15 min warnings fires expiracao_1 at 5 min of silence, expiracao_2 at 10 and expiracao_3 at 15). The warning at half of the time ("before_end_conversation") keeps working alongside. Applies to conversations started from now on.',
        },
    RulesPrice: {
        pt: 'Preço do procedimento / Consulta',
        en: 'Procedure price / Consultation',
    },
    RulesLimit: {
        pt: 'Limite de itens a serem exibidos',
        en: 'Time limit to be displayed',
    },
    RulesAddress: {
        pt: 'Endereço da unidade',
        en: 'Unit address',
    },
    RulesSkipIfOneItem: {
        pt: 'Pular seleção se tiver apenas um item',
        en: 'Skip entity selection if only one item',
    },
    Sequential: {
        pt: 'Sequencial',
        en: 'Sequential',
    },
    RulesSortMethod: {
        pt: 'Forma de apresentação de horários',
        en: 'How to present timetables',
    },
    RulesCanNotCancel: {
        pt: 'Não pode cancelar',
        en: 'cannot cancel',
    },
    RulesCanNotConfirm: {
        pt: 'Não pode confirmar',
        en: 'cannot confirm',
    },
    RulesCanNotView: {
        pt: 'Não pode visualizar',
        en: 'cannot view',
    },
    RulesCanNotReschedule: {
        pt: 'Não pode reagendar',
        en: 'cannot reschedule',
    },
    RulesGuidanceBeforeScheduled: {
        pt: 'Orientação antes do agendamento',
        en: 'Guidance before scheduled',
    },
    RulesGuidanceAfterScheduled: {
        pt: 'Orientação após o agendamento',
        en: 'Guidance after scheduled',
    },
    RulesSkipSelection: {
        pt: 'Pular seleção da entidade atual',
        en: 'Skip current entity selection',
    },
    RulesIfEmptyDataGoto: {
        pt: 'Ir para interação, caso não retorne nenhum resultado',
        en: 'Go to interaction if no result is returned',
    },
    firstEachPeriodDay: {
        pt: 'Primeiros do período',
        en: 'First period',
    },
    firstEachDoctorBalanced: {
        pt: 'Primeiros de cada Médico',
        en: 'First of Each Doctor',
    },
    firstEachDoctorFullyBalanced: {
        pt: 'Primeiros de cada Médico Balanceados',
        en: 'First of Each Doctor Balanced',
    },
    firstEachHourDay: {
        pt: 'Primeiro de cada hora',
        en: 'First hour',
    },
    firstEachAnyPeriodDay: {
        pt: 'Primeiros do dia',
        en: 'First of day',
    },
    firstEachDay: {
        pt: 'Primeiro de cada dia',
        en: 'First of each day',
    },
    combineDatePeriodByOrganization: {
        pt: 'Alternado entre unidades por período',
        en: 'Alternate between units per period',
    },
    default: {
        pt: 'Padrão',
        en: 'Default',
    },
    RulesnoAvailableDatesMessage: {
        pt: 'Mensagem que será enviada ao paciente quando não tiver horários disponíveis',
        en: 'Message that will be sent to the patient when there are no available times',
    },
    RulesSkipIfNoItem: {
        pt: 'Pular seleção se não tiver itens',
        en: 'Skip entity selection if there are no items',
    },
    rulesConfirmationConfirmationGoto: {
        pt: 'Ir para interação, caso confirme',
        en: 'Go to interaction, if confirmed',
    },
    rulesConfirmationConfirmationMessage: {
        pt: 'Mensagem caso confirme',
        en: 'Message if confirmed',
    },
    rulesConfirmationCancelGoto: {
        pt: 'Ir para interação, caso não confirme',
        en: 'Go to interaction, if not confirm',
    },
    rulesConfirmationCancelMessage: {
        pt: 'Mensagem caso não confirme',
        en: 'Message if not confirmed',
    },
    rulesConfirmationRescheduleGoto: {
        pt: 'Ir para interação, caso reagendar',
        en: 'Go to interaction if reschedule',
    },
    rulesConfirmatioSendGuidanceOnConfirmSchedule: {
        pt: 'Enviar orientação ao confirmar agendamento',
        en: 'Send guidance when confirming appointment',
    },
    rulesConfirmationNotActionGoto: {
        pt: 'Ir para interação, caso não possua nenhuma ação',
        en: 'Go to interaction, if you do not have any action',
    },
    rulesConfirmationCancelWithGoto: {
        pt: 'Cancelar e ir para interação',
        en: 'Cancel with go to interaction',
    },
    rulesConfirmationCancelReasonList: {
        pt: 'Selecione os motivos de cancelamento',
        en: 'Select cancel reasons',
    },
    Rescheduling: {
        pt: 'Reagendamento',
        en: 'rescheduling',
    },
    Confirmation: {
        pt: 'Confirmação',
        en: 'Confirmation',
    },
    'Automatically reschedule': {
        pt: 'Reagendamento automático',
        en: 'Automatically reschedule',
    },
    'Go to interaction if any error occurs': {
        pt: 'Ir para interação, caso ocorra algum erro',
        en: 'Go to interaction if any error occurs',
    },
    'Ask if you want to reschedule': {
        pt: 'Perguntar se quer reagendar',
        en: 'Ask if you want to reschedule',
    },
    'Cancel previous appointment after rescheduling': {
        pt: 'Cancelar agendamento anterior após reagendar',
        en: 'Cancel previous appointment after rescheduling',
    },
    Installation: {
        pt: 'Instalação',
        en: 'Installation',
    },
    'Channel deleted successfully': {
        pt: 'Canal deletado com sucesso',
        en: 'Channel deleted successfully',
    },
    'Are you sure you want to delete the channel? The action cannot be undone': {
        pt: 'Tem certeza que deseja excluir o canal? A ação não poderá ser desfeita',
        en: 'Are you sure you want to delete the channel? The action cannot be undone',
    },
    'Are you sure you want to delete the payment? The action cannot be undone': {
        pt: 'Tem certeza que deseja excluir o pagamento? A ação não poderá ser desfeita',
        en: 'Are you sure you want to delete the payment? The action cannot be undone',
    },
    'The faq corresponds to requests for sending messages using frequently asked questions': {
        pt: 'O faq corresponde aos pedidos de envio de mensagens usando as perguntas frequentes',
        en: 'The faq corresponds to requests for sending messages using frequently asked questions',
    },
    'Criteria will match with selected faq to send message from faq-value to user': {
        pt: 'Os critérios corresponderão ao faq selecionado para enviar mensagem do valor faq para o usuário',
        en: 'Criteria will match with selected faq to send message from faq-value to user',
    },
    Criteria: {
        pt: 'Critério',
        en: 'Criteria',
    },
    'The value of faq value that matches with selected faq and criteria will be saved on this attribute': {
        pt: 'O valor da pergunta frequente correspondente ao faq e aos critérios selecionados serão salvos neste atributo',
        en: 'The value of faq-value that matches with selected faq and criteria will be saved on this attribute',
    },
    'End attendance': {
        pt: 'Finalizar atendimento',
        en: 'End attendance',
    },
    'Remove actions and style from the chat initiator': {
        pt: 'Remover ações e estilo do iniciador do chat',
        en: 'Remove actions and style from the chat initiator',
    },
    'Link a bot to your channel': {
        pt: 'Vincule um bot ao seu canal',
        en: 'Link a bot to your channel',
    },
    'Create a new bot': {
        pt: 'Criar novo bot',
        en: 'Create a new bot',
    },
    'Created bot': {
        pt: 'Bot criado',
        en: 'Created bot',
    },
    'Bot successfully created': {
        pt: 'Bot criado com sucesso',
        en: 'Bot successfully created',
    },
    'Error creating bot': {
        pt: 'Erro ao criar bot',
        en: 'Error creating bot',
    },
    'There was an error creating the bot, please try again': {
        pt: 'Ocorreu um erro ao criar o bot, tente novamente',
        en: 'There was an error creating the bot, please try again',
    },
    'Linked Bot': {
        pt: 'Bot vinculado',
        en: 'Linked Bot',
    },
    'Integration code': {
        pt: 'Código de integração',
        en: 'Integration code',
    },
    Insurance: {
        pt: 'Convênio',
        en: 'Insurance',
    },
    'Insurance number': {
        pt: 'Número do convênio',
        en: 'Insurance number',
    },
    'Information on how to use variables in the message': {
        pt: 'Informações de como usar variáveis na mensagem',
        en: 'Information on how to use variables in the message',
    },
    'Standard variables:': {
        pt: 'Variáveis padrão:',
        en: 'Standard variables:',
    },
    'It will be filled with the name of the agent that will use the template.': {
        pt: 'Será preenchido com o nome do agente que utilizará o template.',
        en: 'It will be filled with the name of the agent that will use the template.',
    },
    'It will be filled with the ID of the conversation in which the template was used. Ex: #22549': {
        pt: 'Será preenchido com o ID da conversa em que foi utilizado o template. Ex: #22549',
        en: 'It will be filled with the ID of the conversation in which the template was used. Ex: #22549',
    },
    'It will be filled with the name of the patient in the conversation that the template is used.': {
        pt: 'Será preenchido com o nome do paciente na conversa que for utilizado o template.',
        en: 'It will be filled with the name of the patient in the conversation that the template is used.',
    },
    "It will be filled in with the patient's phone number in the conversation using the template.": {
        pt: 'Será preenchido com o telefone do paciente na conversa que for utilizado o template.',
        en: "It will be filled in with the patient's phone number in the conversation using the template.",
    },
    '*These variables do not need to be edited when using the template, they will be automatically filled by the system!':
        {
            pt: '*Estás variáveis não precisam ser editadas na hora da utilização do template elas serão automaticamente preenchidas pelo sistema!',
            en: '*These variables do not need to be edited when using the template, they will be automatically filled by the system!',
        },
    'Editable variables:': {
        pt: 'Variáveis editáveis:',
        en: 'Editable variables:',
    },
    'use editable variables when you need to implement custom texts in a template.': {
        pt: 'utilize de variáveis editáveis quando necessitar implementar textos personalizados em um template.',
        en: 'use editable variables when you need to implement custom texts in a template.',
    },
    "*Don't forget to edit these variables.": {
        pt: '*Não se esqueça de editar estas variáveis.',
        en: "*Don't forget to edit these variables.",
    },
    'Editable variable terms:': {
        pt: 'Termos das variáveis editáveis:',
        en: 'Editable variable terms:',
    },
    'Select if this variable is mandatory to submit the template.': {
        pt: 'Selecione caso está variável seja de preenchimento obrigatório para o envio do template.',
        en: 'Select if this variable is mandatory to submit the template.',
    },
    'Fill in with the name you put in the custom variable in the message.': {
        pt: 'Preencha com o nome que você colocou na variável personalizada da mensagem.',
        en: 'Fill in with the name you put in the custom variable in the message.',
    },
    'Fill in the field that will be shown to fill in the template before submitting. Ex: patient name': {
        pt: 'Preencha com o campo que será mostrado para preencher no template antes de enviar. Ex: Nome do paciente',
        en: 'Fill in the field that will be shown to fill in the template before submitting. Ex: patient name',
    },
    'Select which type this variable will have to be filled.': {
        pt: 'Selecione qual será o tipo que está variável terá que ser preenchida.',
        en: 'Select which type this variable will have to be filled.',
    },
    Mandatory: {
        pt: 'Obrigatório',
        en: 'Mandatory',
    },
    'Will only match this attribute if is equal to entity': {
        pt: 'Só corresponderá a este atributo se for igual à entidade',
        en: 'Will only match this attribute if is equal to entity',
    },
    'User says will be saved in attribute': {
        pt: 'O usuário diz que será salvo no atributo',
        en: 'User says will be saved in attribute',
    },
    'Value:': {
        pt: 'Valor:',
        en: 'Value:',
    },
    'Type:': {
        pt: 'Tipo:',
        en: 'Type:',
    },
    'Insurance plan': {
        pt: 'Plano do convênio',
        en: 'Insurance plan',
    },
    Procedure: {
        pt: 'Procedimento',
        en: 'Procedure',
    },
    'Procedure type': {
        pt: 'Tipo de procedimento',
        en: 'Procedure type',
    },
    'Organization unit': {
        pt: 'Unidade de organização',
        en: 'Organization unit',
    },
    'Check account': {
        pt: 'Checar conta',
        en: 'Check account',
    },
    'Parameters to search for available times': {
        pt: 'Parâmetros para buscar os horários disponíveis',
        en: 'Parameters to search for available times',
    },
    'Days from today': {
        pt: 'Dias a partir de hoje',
        en: 'Days from today',
    },
    'Appointment not confirmed goto': {
        pt: 'Goto de agendamento não confirmado',
        en: 'Appointment not confirmed goto',
    },
    'Until day': {
        pt: 'Até o dia',
        en: 'Until day',
    },
    'Number of days from the initial date informed': {
        pt: 'Quantidade de dias a partir da data inicial informada',
        en: 'Number of days from the initial date informed',
    },
    'Result limit': {
        pt: 'Limite de resultados',
        en: 'Result limit',
    },
    Randomize: {
        pt: 'Randomizar',
        en: 'Randomize',
    },
    'Randomize schedules': {
        pt: 'Randomizar horários',
        en: 'Randomize schedules',
    },
    'Number of days to search': {
        pt: 'Quantidade de dias a serem buscados',
        en: 'Number of days to search',
    },
    'Number of days that will pass from today to start searching for timetables': {
        pt: 'Quantidade de dias que serão passados a partir de hoje para iniciar a busca de horários',
        en: 'Number of days that will pass from today to start searching for timetables',
    },
    'Select the steps to be performed': {
        pt: 'Selecione as etapas que devem ser executadas',
        en: 'Select the steps to be performed',
    },
    Steps: {
        pt: 'Etapas',
        en: 'Steps',
    },
    Gender: {
        pt: 'Gênero',
        en: 'Gender',
    },
    'Account created': {
        pt: 'Conta criada',
        en: 'Account created',
    },
    Phone: {
        pt: 'Telefone',
        en: 'Phone',
    },
    Accounts: {
        pt: 'Contas',
        en: 'Accounts',
    },
    'Account not exists': {
        pt: 'Conta não existe',
        en: 'Account not exists',
    },
    'Existing account': {
        pt: 'Conta existente',
        en: 'Existing account',
    },
    'Are you sure you want to delete the bot? The action cannot be undone': {
        pt: 'Tem certeza que deseja excluir o bot? A ação não poderá ser desfeita',
        en: 'Are you sure you want to delete the bot? The action cannot be undone',
    },
    'Are you sure you want to delete the user? The action cannot be undone': {
        pt: 'Tem certeza que deseja excluir o usuário? A ação não poderá ser desfeita',
        en: 'Are you sure you want to delete the user? The action cannot be undone',
    },
    Download: {
        pt: 'Baixar',
        en: 'Download',
    },
    Downloading: {
        pt: 'Baixando',
        en: 'Downloading',
    },
    'Share service': {
        pt: 'Compartilhar atendimento',
        en: 'Share service',
    },
    Online: {
        pt: 'Online',
        en: 'Online',
    },
    Add: {
        pt: 'Adicionar',
        en: 'Add',
    },
    Offline: {
        pt: 'Desconectado',
        en: 'Offline',
    },
    Disconnect: {
        pt: 'Desconectar',
        en: 'Disconnect',
    },
    'Left the conversation': {
        pt: 'Saiu do atendimento',
        en: 'Left the attendance',
    },
    Configuration: {
        pt: 'Configuração',
        en: 'Configuration',
    },
    'Api key': {
        pt: 'Chave da api',
        en: 'Api key',
    },
    'Phone number': {
        pt: 'Número do celular',
        en: 'Phone number',
    },
    Closure: {
        pt: 'Encerramento',
        en: 'Closure',
    },
    'Standard conversation end message': {
        pt: 'Mensagem padrão de encerramento de conversa',
        en: 'Standard conversation end message',
    },
    'Phone number is not valid': {
        pt: 'Número inválido',
        en: 'Phone number is not valid',
    },
    'Contact list': {
        pt: 'Lista de contatos',
        en: 'Contact list',
    },
    'Not allowing the patient to confirm their appointment through the bot': {
        pt: 'Não permitir que o paciente confirme seu agendamento através do bot',
        en: 'Not allowing the patient to confirm their appointment through the bot',
    },
    'Disallow active confirmation sending for this flow': {
        pt: 'Não permitir o envio de confirmação ativa para este fluxo',
        en: 'Disallow active confirmation sending for this flow',
    },
    'Disallow automatic rescheduling of this entity in the bot flow': {
        pt: 'Não permitir o reagendamento automático desta entidade no fluxo do bot',
        en: 'Disallow automatic rescheduling of this entity in the bot flow',
    },
    'Disallow automatic cancellation of this entity within the bot flow': {
        pt: 'Não permita o cancelamento automático desta entidade dentro do fluxo do bot',
        en: 'Disallow automatic cancellation of this entity within the bot flow',
    },
    'Search times by days': {
        pt: 'Buscar horários a partir de dias.',
        en: 'Search times by days',
    },
    'There is no contact created.': {
        pt: 'Não existe nenhum contato criado.',
        en: 'There is no contact created.',
    },
    'No contacts found': {
        pt: 'Nenhum contato encontrado',
        en: 'No contacts found',
    },
    'Choose a workspace': {
        pt: 'Escolha um workspace',
        en: 'Choose a workspace',
    },
    'Choose a channel': {
        pt: 'Escolha um canal',
        en: 'Choose a channel',
    },
    'Import contacts': {
        pt: 'Importar contatos',
        en: 'Import contacts',
    },
    'Select a CSV file to import contacts': {
        pt: 'Selecione um arquivo CSV para importar contatos',
        en: 'Select a CSV file to import contacts',
    },
    'Import patient contacts via CSV or XLSX file': {
        pt: 'Importe sua lista de contatos a partir de um arquivo CSV ou XLSX com as colunas obrigatórias: nome e telefone. Email é opcional.',
        en: 'Import your contact list from a CSV or XLSX file with required columns: nome and telefone. Email is optional.',
    },
    'CSV must contain the columns: nome, telefone and email': {
        pt: 'O CSV deve conter as colunas obrigatórias: nome e telefone. Email é opcional.',
        en: 'CSV must contain required columns: nome and telefone. Email is optional.',
    },
    'Each row represents one patient contact': {
        pt: 'Cada linha representa um contato de paciente',
        en: 'Each row represents one patient contact',
    },
    'Only CSV format is accepted': {
        pt: 'Apenas o formato CSV é aceito',
        en: 'Only CSV format is accepted',
    },
    'Contacts will be added to your service base': {
        pt: 'Os contatos serão adicionados à sua base de atendimento',
        en: 'Contacts will be added to your service base',
    },
    'Click or drag a CSV or XLSX file to import': {
        pt: 'Clique ou arraste um arquivo CSV ou XLSX',
        en: 'Click or drag a CSV or XLSX file to import',
    },
    'Click or drag a file to upload': {
        pt: 'Clique ou arraste um arquivo para enviar',
        en: 'Click or drag a file to upload',
    },
    'Download template file': {
        pt: 'Baixar arquivo modelo',
        en: 'Download template file',
    },
    'Contacts imported successfully': {
        pt: 'Contatos importados com sucesso',
        en: 'Contacts imported successfully',
    },
    'Contacts are being added to your service base': {
        pt: 'Os contatos estão sendo adicionados a sua base de atendimento',
        en: 'Contacts are being added to your service base',
    },
    'Error importing contacts': {
        pt: 'Erro ao importar contatos',
        en: 'Error importing contacts',
    },
    'Only CSV and XLSX files are allowed': {
        pt: 'Apenas arquivos CSV e XLSX são permitidos',
        en: 'Only CSV and XLSX files are allowed',
    },
    'Missing required column: {column}': {
        pt: 'Coluna obrigatória ausente: {column}',
        en: 'Missing required column: {column}',
    },
    'Invalid phones found: {count} error(s) starting at line {line}': {
        pt: '{count} telefone(s) inválido(s) encontrado(s), a partir da linha {line}',
        en: '{count} invalid phone(s) found, starting at line {line}',
    },
    'File exceeds the 3MB limit': {
        pt: 'O arquivo excede o limite de 3MB',
        en: 'File exceeds the 3MB limit',
    },
    'The message exceeds 1024 characters. Reduce it before saving with quick reply buttons.': {
        pt: 'A mensagem ultrapassa 1024 caracteres. Reduza o texto antes de salvar com botões de resposta rápida.',
        en: 'The message exceeds 1024 characters. Reduce it before saving with quick reply buttons.',
    },
    'Importing...': {
        pt: 'Importando...',
        en: 'Importing...',
    },
    'Select a file first': {
        pt: 'Selecione um arquivo primeiro',
        en: 'Select a file first',
    },
    'I agree to the whatsApp': {
        pt: 'Eu concordo com os',
        en: 'I agree to the whatsApp',
    },
    'Terms of Service': {
        pt: 'Termos de serviço',
        en: 'Terms of Service',
    },
    'Privacy policy': {
        pt: 'Política de privacidade',
        en: 'Privacy policy',
    },
    'How to register your privacy policy': {
        pt: 'Como cadastrar sua política de privacidade',
        en: 'How to register your privacy policy',
    },
    'Privacy policy text': {
        pt: 'Texto da política de privacidade',
        en: 'Privacy policy text',
    },
    'Accept button text': {
        pt: 'Texto do botão aceitar',
        en: 'Accept button text',
    },
    'Decline button text': {
        pt: 'Texto do botão recusar',
        en: 'Decline button text',
    },
    'Shipping channels': {
        pt: 'Canais para envio',
        en: 'Shipping channels',
    },
    'Confirm save': {
        pt: 'Confirmar atualização',
        en: 'Confirm save',
    },
    Accept: {
        pt: 'Aceitar',
        en: 'Accept',
    },
    Refuse: {
        pt: 'Recusar',
        en: 'Refuse',
    },
    Register: {
        pt: 'Cadastro',
        en: 'Register',
    },
    'Privacy policy created successfully': {
        pt: 'Política de privacidade criada com sucesso',
        en: 'Privacy policy created successfully',
    },
    'Privacy policy updated successfully': {
        pt: 'Política de privacidade atualizada com sucesso',
        en: 'Privacy policy updated successfully',
    },
    'Select channels': {
        pt: 'Selecionar canais',
        en: 'Select channels',
    },
    'Changing the text of the privacy policy will result in a new request for acceptance by all again!': {
        pt: 'A alteração do texto da política de privacidade implicará em uma nova solicitação do aceite para todos novamente!',
        en: 'Changing the text of the privacy policy will result in a new request for acceptance by all again!',
    },
    'Confirm new acceptance request': {
        pt: 'Confirmar nova solicitação de aceite',
        en: 'Confirm new acceptance request',
    },
    'Are you sure you want to request acceptance of the privacy policy, this action will cause the privacy policy to be accepted again!':
        {
            pt: 'Tem certeza de que deseja solicitar aceite na política de privacidade, essa ação fará com que a política de privacidade tenha que ser aceita novamente!',
            en: 'Are you sure you want to request acceptance of the privacy policy, this action will cause the privacy policy to be accepted again!',
        },
    'Request accept again': {
        pt: 'Solicitar aceite novamente',
        en: 'Request accept again',
    },
    'Are you sure you want to update, this action will cause the privacy policy to have to be accepted again!': {
        pt: 'Tem certeza de que deseja atualizar, essa ação fará com que a política de privacidade tenha que ser aceita novamente!',
        en: 'Are you sure you want to update, this action will cause the privacy policy to have to be accepted again!',
    },
    'Are you sure you want to delete this privacy policy?': {
        pt: 'Tem certeza que deseja excluir esta política de privacidade?',
        en: 'Are you sure you want to delete this privacy policy?',
    },
    'It was not possible to save, as it has channels that are already being used in another privacy policy.': {
        pt: 'Não foi possível salvar, pois possui canais que já estão sendo utilizados em outra politica de privacidade.',
        en: 'It was not possible to save, as it has channels that are already being used in another privacy policy.',
    },
    'Qr code requested': {
        pt: 'Qr code solicitado',
        en: 'Qr code requested',
    },
    Sended: {
        pt: 'Enviado',
        en: 'Sended',
    },
    'Invalid number': {
        pt: 'Número inválido',
        en: 'Invalid number',
    },
    'Time exceeded for validation': {
        pt: 'Tempo excedido para validação',
        en: 'Time exceeded for validation',
    },
    'Time exceeded for validation. Try again': {
        pt: 'Tempo excedido para validação. Tentar novamente',
        en: 'Time exceeded for validation. Try again',
    },
    'Contact already exists, ': {
        pt: 'O contato já existe, ',
        en: 'Contact already exists, ',
    },
    'see contact': {
        pt: 'ver contato',
        en: 'see contact',
    },
    'Valid number': {
        pt: 'Número válido',
        en: 'Valid number',
    },
    'User successfully saved': {
        pt: 'Usuário salvo com sucesso',
        en: 'User successfully saved',
    },
    Create: {
        pt: 'Criar',
        en: 'Create',
    },
    'Attendance will start on the channel': {
        pt: 'O atendimento será iniciado no canal',
        en: 'Attendance will start on the channel',
    },
    'You need to validate the number to continue.': {
        pt: 'Necessário validar o número para continuar.',
        en: 'You need to validate the number to continue.',
    },
    Authenticating: {
        pt: 'Autenticando',
        en: 'Authenticating',
    },
    'Appointment type': {
        pt: 'Tipo de agendamento',
        en: 'Appointment type',
    },
    'Unity filial': {
        pt: 'Unidade filial',
        en: 'Organization unity',
    },
    'Week day': {
        pt: 'Dia da semana',
        en: 'Week day',
    },
    'Started appointment': {
        pt: 'Agendamento iniciado',
        en: 'Started appointment',
    },
    'Ended appointment': {
        pt: 'Agendamento finalizado',
        en: 'Ended appointment',
    },
    'Restart appointment': {
        pt: 'Reiniciar agendamento',
        en: 'Restart appointment',
    },
    'Appointment step': {
        pt: 'Step da marcação',
        en: 'Appointment step',
    },
    'Show notification of new attendance': {
        pt: 'Exibir notificação de novo atendimento',
        en: 'Show notification of new attendance',
    },
    'The number is already present in the contact list': {
        pt: 'O numero já esta presente na lista de contatos',
        en: 'The number is already present in the contact list',
    },
    'Submit a review at the end of the call': {
        pt: 'Enviar avaliação no fim do atendimento',
        en: 'Submit a review at the end of the call',
    },
    'Navigate to article': {
        pt: 'Navegar para o artigo',
        en: 'Navigate to article',
    },
    'Click to open article': {
        pt: 'Clique para abrir o artigo',
        en: 'Click to open article',
    },
    'Click to resend message': {
        pt: 'Clique para reenviar a mensagem',
        en: 'Click to resend message',
    },
    'Error sending, click to see details': {
        pt: 'Erro no envio, clique para ver detalhes',
        en: 'Error sending, click to see details',
    },
    'No details available': {
        pt: 'Sem detalhes disponíveis',
        en: 'No details available',
    },
    Resend: {
        pt: 'Reenviar',
        en: 'Resend',
    },
    'Message resent successfully': {
        pt: 'Mensagem reenviada com sucesso',
        en: 'Message resent successfully',
    },
    'At least one of the fields must be filled in!': {
        pt: 'Pelo menos um dos campos deve estar preenchido!',
        en: 'At least one of the fields must be filled in!',
    },
    Source: {
        pt: 'Fonte',
        en: 'Source',
    },
    Appointment: {
        pt: 'Consulta',
        en: 'Appointment',
    },
    appointment: {
        pt: 'Agendamento',
        en: 'Appointment',
    },
    reuseAppointments: {
        pt: 'Reutilizar agendamento',
        en: 'Reuse appointment',
    },
    Flow: {
        pt: 'Fluxo',
        en: 'Flow',
    },
    Weigth: {
        pt: 'Peso',
        en: 'Weigth',
    },
    Plan: {
        en: 'Plan',
        pt: 'Plano',
    },
    'When empty will go to interaction': {
        pt: 'Quando estiver vazio ir até a interação',
        en: 'When empty will go to interaction',
    },
    'Bot and agent': {
        pt: 'Bot e agente',
        en: 'Bot and agent',
    },
    'Account exists, data mismatch': {
        pt: 'Conta existe porém os dados estão incorretos',
        en: 'Account exists, data mismatch',
    },
    'If the account exists but data mismatch': {
        pt: 'Se a conta existe mas os dados estão incorretos ',
        en: 'If the account exists but data mismatch',
    },
    'Is empty goto': {
        pt: 'Ir para quando estiver vazio',
        en: 'Is empty goto',
    },
    'Action ignored goto': {
        pt: 'Ir para quando ação ignorada',
        en: 'Action ignored goto',
    },
    'Cannot found any user': {
        pt: 'Nenhum usuário encontrado',
        en: 'Cannot found any user',
    },
    'Error on load users': {
        pt: 'Erro ao carregar usuários',
        en: 'Error on load users',
    },
    'Cannot found any team': {
        pt: 'Nenhum time encontrado',
        en: 'Cannot found any team',
    },
    'Error on update flow': {
        pt: 'Erro ao atualizar fluxo',
        en: 'Error on update flow',
    },
    Organization: {
        pt: 'Organização',
        en: 'Organization',
    },
    'Error on save flow': {
        pt: 'Erro ao salvar fluxo',
        en: 'Error on save flow',
    },
    'Flow saved': {
        pt: 'Fluxo salvo',
        en: 'Flow saved',
    },
    'Search entity': {
        pt: 'Busca de entidade',
        en: 'Search entity',
    },
    'Add step': {
        pt: 'Adicionar passo',
        en: 'Add step',
    },
    'Select entity': {
        pt: 'Selecione uma entidade',
        en: 'Select entity',
    },
    'Error on load flows': {
        pt: 'Erro ao carregar fluxos',
        en: 'Error on load flows',
    },
    Doctor: {
        pt: 'Médico',
        en: 'Doctor',
    },
    'Service group': {
        pt: 'Grupo de serviço',
        en: 'Service group',
    },
    Group: {
        pt: 'Grupo',
        en: 'Group',
    },
    'Day period': {
        pt: 'Período do dia',
        en: 'Day period',
    },
    'If filled will lead to an transboard interaction': {
        pt: 'Se preenchido, irá a uma interação de transbordo',
        en: 'If filled will lead to an transboard interaction',
    },
    'Invalid credentials': {
        en: 'Invalid credentials',
        pt: 'Credenciais inválidas',
    },
    'Invalid email or password': {
        en: 'Invalid email or password',
        pt: 'E-mail ou senha inválidas',
    },
    'Email not valid': {
        pt: 'Email inválido',
        en: 'Email not valid',
    },
    Email: {
        pt: 'Email',
        en: 'Email',
    },
    Password: {
        pt: 'Senha',
        en: 'Password',
    },
    'Search attendances, messages': {
        en: 'Search attendances, messages',
        pt: 'Buscar atendimentos, mensagens',
    },
    'Error creating user.': {
        pt: 'Erro ao criar usuário.',
        en: 'Error creating user.',
    },
    'Email in use': {
        pt: 'Email em uso',
        en: 'Email in use',
    },
    'Try entering another email address': {
        pt: 'Tente preencher outro endereço de e-mail',
        en: 'Try entering another email address',
    },
    'Create user': {
        pt: 'Criar usuário',
        en: 'Create user',
    },
    'User limit of the contracted plan has been reached! \nNew users will be billed on the next invoice.': {
        pt: 'Limite de usuários do plano contratado foi atingido! \nNovos usuários serão cobrados na próxima fatura.',
        en: 'User limit of the contracted plan has been reached! \nNew users will be billed on the next invoice.',
    },
    'amount contracted in the plan': {
        pt: 'quantidade contratada no plano',
        en: 'amount contracted in the plan',
    },
    "When changing the user's permission, the user limit will be exceeded, resulting in an increase for the next invoice.":
        {
            pt: 'Ao alterar a permissão do usuário, o limite de usuários será ultrapassado, resultando num acréscimo para proxima fatura.',
            en: "When changing the user's permission, the user limit will be exceeded, resulting in an increase for the next invoice.",
        },
    'Enter an email to get it': {
        pt: 'Digite um email para buscá-lo',
        en: 'Enter an email to get it',
    },
    Messages: {
        pt: 'Mensagens',
        en: 'Messages',
    },
    'No messages found': {
        pt: 'Nenhuma mensagem encontrada',
        en: 'No messages found',
    },
    Rotate: {
        pt: 'Girar',
        en: 'Rotate',
    },
    'Error sending, click to retry': {
        pt: 'Erro no envio, clique para tentar novamente',
        en: 'Error sending, click to retry',
    },
    'Blocked message': {
        pt: 'Mensagem bloqueada',
        en: 'Blocked message',
    },
    'Load messages': {
        pt: 'Carregar mensagens',
        en: 'Load messages',
    },
    'There was an error loading messages': {
        pt: 'Ocorreu um erro ao carregar as mensagens',
        en: 'There was an error loading messages',
    },
    'Try again': {
        pt: 'Tente novamente',
        en: 'Try again',
    },
    'Try again later': {
        pt: 'Tente novamente mais tarde',
        en: 'Try again later',
    },
    Nobody: {
        pt: 'Ninguém',
        en: 'Nobody',
    },
    Official: {
        pt: 'Oficial',
        en: 'Official',
    },
    Historic: {
        pt: 'Histórico',
        en: 'Historic',
    },
    'Enter a name to trigger the template': {
        pt: 'Digite um nome para acionar o template',
        en: 'Enter a name to trigger the template',
    },
    'Template name': {
        pt: 'Nome do template',
        en: 'Template name',
    },
    Message: {
        pt: 'Mensagem',
        en: 'Message',
    },
    'Template message': {
        pt: 'Mensagem do template',
        en: 'Template message',
    },
    'Text can be changed after selected': {
        pt: 'Texto poderá ser alterado após selecionado',
        en: 'Text can be changed after selected',
    },
    "It's an official whatsapp template field": {
        pt: 'É um campo template do whatsapp oficial',
        en: "It's an official whatsapp template field",
    },
    'Create template': {
        pt: 'Criar novo modelo',
        en: 'Create template',
    },
    'Creating template': {
        pt: 'Criando novo modelo',
        en: 'Creating template',
    },
    'Existing templates': {
        pt: 'Modelos existentes',
        en: 'Existing templates',
    },
    'Editing template': {
        pt: 'Editando modelo',
        en: 'Editing template',
    },
    'Template successfully created': {
        pt: 'Modelo criado com sucesso',
        en: 'Template successfully created',
    },
    'Template cloned successfully with warnings': {
        pt: 'Template clonado com sucesso, porém algumas informações do botão de fluxo não foram validadas.',
        en: 'Template cloned successfully, but some flow button information was not validated.',
    },
    'Message must have at least 20 characters': {
        pt: 'A mensagem deve ter pelo menos 20 caracteres',
        en: 'Message must have at least 20 characters',
    },
    TEMPLATE_BUTTONS_TEXT_LENGTH_ERROR: {
        pt: 'O texto do botão deve ter entre 1 e 20 caracteres.',
        en: 'Button text must have between 1 and 20 characters.',
    },
    TEMPLATE_BUTTONS_LENGTH_EXCEED: {
        pt: 'Quantidade de botões inválida para este template.',
        en: 'Invalid number of buttons for this template.',
    },
    TEMPLATE_INVALID_BUTTON_TYPE: {
        pt: 'Tipo de botão inválido para a categoria do template.',
        en: 'Invalid button type for the template category.',
    },
    TEMPLATE_MESSAGE_LENGTH_EXCEED: {
        pt: 'A mensagem do template excede o limite permitido.',
        en: 'Template message exceeds the allowed limit.',
    },
    TEMPLATE_MESSAGE_MIN_LENGTH: {
        pt: 'A mensagem do template deve ter pelo menos 10 caracteres quando houver arquivo.',
        en: 'Template message must have at least 10 characters when there is a file.',
    },
    TEMPLATE_VARIABLES_INVALID: {
        pt: 'Existem variáveis inválidas ou não preenchidas no template.',
        en: 'There are invalid or unfilled variables in the template.',
    },
    TEMPLATE_MESSAGE_INVALID: {
        pt: 'Mensagem do template inválida.',
        en: 'Invalid template message.',
    },
    TEMPLATE_NOT_FOUND_FILE_UPLOAD: {
        pt: 'Não foi possível localizar o arquivo do template para clonagem.',
        en: 'Could not find the template file for cloning.',
    },
    TEMPLATE_CHANNEL_APPNAME_NOT_FOUND: {
        pt: 'Nenhum canal válido foi encontrado para enviar o template.',
        en: 'No valid channel was found to submit the template.',
    },
    NOT_FOUND_FLOW_DATA: {
        pt: 'Fluxo do botão não encontrado.',
        en: 'Button flow not found.',
    },
    INACTIVATED_FLOW: {
        pt: 'O fluxo do botão está inativo.',
        en: 'Button flow is inactive.',
    },
    'Template clone route unavailable': {
        pt: 'A rota de clonagem de template não está disponível na API atual. Atualize/reinicie a API e tente novamente.',
        en: 'The template clone route is not available in the current API. Update/restart the API and try again.',
    },
    'Template updated successfully': {
        pt: 'Template atualizado com sucesso',
        en: 'Template updated successfully',
    },
    'Are you sure you want to delete the template?': {
        pt: 'Tem certeza de que deseja excluir o modelo?',
        en: 'Are you sure you want to delete the template?',
    },
    'Template messages': {
        pt: 'Mensagens modelo',
        en: 'Template messages',
    },
    'Most used by you': {
        pt: 'Mais utilizados por você',
        en: 'Most used by you',
    },
    'All templates': {
        pt: 'Todos os templates',
        en: 'All templates',
    },
    Editable: {
        pt: 'Editável',
        en: 'Editable',
    },
    'No templates found': {
        pt: 'Nenhum template encontrado',
        en: 'No templates found',
    },
    'templates listed': {
        pt: 'templates listados',
        en: 'templates listed',
    },
    'Official template': {
        pt: 'Template oficial',
        en: 'Official template',
    },
    'Unofficial template': {
        pt: 'Não oficial',
        en: 'Unofficial template',
    },
    'Non-editable template': {
        pt: 'Template não editável',
        en: 'Non-editable template',
    },
    'Editable template': {
        pt: 'Template editável',
        en: 'Editable template',
    },
    'Utility template': {
        pt: 'Template de utilidade',
        en: 'Utility template',
    },
    'Marketing template': {
        pt: 'Template de marketing',
        en: 'Marketing template',
    },
    MARKETING: {
        pt: 'Marketing',
        en: 'Marketing',
    },
    'No linked channel': {
        pt: 'Nenhum canal vinculado',
        en: 'No linked channel',
    },
    'View channel status': {
        pt: 'Ver status por canal',
        en: 'View channel status',
    },
    'Channel status': {
        pt: 'Status por canal',
        en: 'Channel status',
    },
    variable: {
        pt: 'variável',
        en: 'variable',
    },
    variables: {
        pt: 'variáveis',
        en: 'variables',
    },
    'Official template awaiting approval from Whatsapp': {
        pt: 'Template oficial aguardando aprovação do Whatsapp',
        en: 'Official template awaiting approval from Whatsapp',
    },
    'Official template has not been approved by Whatsapp, contact support': {
        pt: 'Template oficial não foi aprovado pelo Whatsapp, entre em contato com o suporte',
        en: 'Official template has not been approved by Whatsapp, contact support',
    },
    'Select the type of template you want to create': {
        pt: 'Selecione o tipo do template que deseja criar',
        en: 'Select the type of template you want to create',
    },
    'Unofficial template that assists in sending prompt messages in customer service.': {
        pt: 'Template não oficial que auxilia no envio de mensagens prontas no atendimento.',
        en: 'Unofficial template that assists in sending prompt messages in customer service.',
    },
    'Official template, requires approval by Whatsapp so that it can be used to create new appointments or start a new session.':
        {
            pt: 'Template oficial, necessita de aprovação pelo Whatsapp para que possa ser usado na criação de novos atendimentos ou inicio de uma nova sessão.',
            en: 'Official template, requires approval by Whatsapp so that it can be used to create new appointments or start a new session.',
        },
    'Fill in this field or select a file': {
        pt: 'Preencha este campo ou selecione um arquivo',
        en: 'Fill in this field or select a file',
    },
    'There are variables that have not yet been filled in': {
        pt: 'Existem variáveis que ainda não foram preenchidas',
        en: 'There are variables that have not yet been filled in',
    },
    'Invalid message, variables at the beginning or end of the text are not allowed': {
        pt: 'Mensagem inválida, não é permitido variáveis no inicio ou fim do texto',
        en: 'Invalid message, variables at the beginning or end of the text are not allowed',
    },
    'It is not possible to edit messages in official templates, if you have questions click on the link below': {
        pt: 'Não é possível editar mensagem em templates oficiais, caso tenha dúvidas clique no link abaixo',
        en: 'It is not possible to edit messages in official templates, if you have questions click on the link below',
    },
    'Template information outdated': {
        pt: 'Informações do template desatualizadas',
        en: 'Template information outdated',
    },
    'Variable has not yet been edited': {
        pt: 'Variável ainda não foi editada',
        en: 'Variable has not yet been edited',
    },
    'The attribute has not yet been edited': {
        pt: 'O atributo ainda não foi editado',
        en: 'The attribute has not yet been edited',
    },
    'Populate with custom variable': {
        pt: 'Preencher com variável personalizada',
        en: 'Populate with custom variable',
    },
    'select default variable': {
        pt: 'Selecionar variável padrão',
        en: 'select default variable',
    },
    'Add variable': {
        pt: 'Adicionar variável',
        en: 'Add variable',
    },
    'Add an example for variable': {
        pt: 'Adicione um exemplo para variável',
        en: 'Add an example for variable',
    },
    'Remove variable': {
        pt: 'Remover variável',
        en: 'Remove variable',
    },
    'Example that will be sent instead of the variable for WhatsApp approval': {
        pt: 'Exemplo que sera enviado no lugar da variável para aprovação do Whatsapp',
        en: 'Example that will be sent instead of the variable for WhatsApp approval',
    },
    'Field name': {
        pt: 'Nome do campo',
        en: 'Field name',
    },
    'Name that will be displayed when filling out': {
        pt: 'Nome que será exibido quando for preencher',
        en: 'Name that will be displayed when filling out',
    },
    'Variable value for identification': {
        pt: 'Valor da variável para identificação',
        en: 'Variable value for identification',
    },
    'Default variable': {
        pt: 'Variável padrão',
        en: 'Default variable',
    },
    'Automatically filled in by the system when sending the template': {
        pt: 'Preenchida automaticamente pelo sistema na hora do envio do template',
        en: 'Automatically filled in by the system when sending the template',
    },
    'Fill in the fields or select one of the standard system variables': {
        pt: 'Preencha os campos ou selecione uma das variáveis padrão do sistema',
        en: 'Fill in the fields or select one of the standard system variables',
    },
    'Variable editing': {
        pt: 'Edição de variável',
        en: 'Variable editing',
    },
    Rejected: {
        pt: 'Reprovado',
        en: 'Rejected',
    },
    'Try to resubmit the template': {
        pt: 'Tentar nova submissão do template',
        en: 'Try to resubmit the template',
    },
    'Submit template for Whatsapp approval': {
        pt: 'Submeter template para aprovação do Whatsapp',
        en: 'Submit template for Whatsapp approval',
    },
    'Delete template from this channel': {
        pt: 'Deletar template deste canal',
        en: 'Delete template from this channel',
    },
    'template status': {
        pt: 'Status do template',
        en: 'Template status',
    },
    'Not submitted for approval': {
        pt: 'Não enviado para aprovação',
        en: 'Not submitted for approval',
    },
    'allow step back': {
        pt: 'Permitir voltar etapa',
        en: 'allow step back',
    },
    Approved: {
        pt: 'Aprovado',
        en: 'Approved',
    },
    Disapproved: {
        pt: 'Reprovado',
        en: 'Disapproved',
    },
    'Channel disabled': {
        pt: 'Canal desabilitado',
        en: 'Channel disabled',
    },
    Deleted: {
        pt: 'Deletado',
        en: 'Deleted',
    },
    Disabled: {
        pt: 'Desabilitado',
        en: 'Disabled',
    },
    'Not Submitted': {
        pt: 'Não Enviado',
        en: 'Not Submitted',
    },
    'Template inactive': {
        pt: 'Template inativo',
        en: 'Template inactive',
    },
    'Active template': {
        pt: 'Template ativo',
        en: 'Active template',
    },
    'Template category': {
        pt: 'Categoria de template',
        en: 'Template category',
    },
    'Search for templates by name or message': {
        pt: 'Pesquise templates por nome ou mensagem',
        en: 'Search for templates by name or message',
    },
    'There are channels that the template is awaiting approval on Whatsapp': {
        pt: 'Possui canais que o template esta aguardando aprovação no Whatsapp',
        en: 'There are channels that the template is awaiting approval on Whatsapp',
    },
    'It has channels that the template was disapproved by Whatsapp': {
        pt: 'Possui canais que o template foi reprovado pelo Whatsapp',
        en: 'It has channels that the template was disapproved by Whatsapp',
    },
    'An error occurred while submitting the template for some channel': {
        pt: 'Ocorreu um erro na submissão do template para algum canal',
        en: 'An error occurred while submitting the template for some channel',
    },
    'It has channels that the template was deleted in Whatsapp': {
        pt: 'Possui canais que o template foi deletado no Whatsapp',
        en: 'It has channels that the template was deleted in Whatsapp',
    },
    'There are channels that the template has had an error in the submission': {
        pt: 'Possui canais que o template ocorreu algum erro na submissão',
        en: 'There are channels that the template has had an error in the submission',
    },
    'It has channels that the template was disabled in Whatsapp': {
        pt: 'Possui canais que o template foi desabilitado no Whatsapp',
        en: 'It has channels that the template was disabled in Whatsapp',
    },
    'It has channels that the template was approved by Whatsapp': {
        pt: 'Possui canais que o template foi aprovado pelo Whatsapp',
        en: 'It has channels that the template was approved by Whatsapp',
    },
    'Template submission required. Select one by typing "/".': {
        pt: 'Obrigatório envio de template. Selecione um digitando "/".',
        en: 'Template submission required. Select one by typing "/".',
    },
    'You do not have permission to edit this template': {
        pt: 'Você não tem permissão para editar este template',
        en: 'You do not have permission to edit this template',
    },
    'Workspace tags': {
        pt: 'Tags do workspace',
        en: 'Workspace tags',
    },
    Photo: {
        pt: 'Foto',
        en: 'Photo',
    },
    File: {
        pt: 'Arquivo',
        en: 'File',
    },
    'Template format': {
        pt: 'Formato do template',
        en: 'Template format',
    },
    Normal: {
        pt: 'Padrão',
        en: 'Standard',
    },
    List: {
        pt: 'Lista',
        en: 'List',
    },
    'Save as most used channel': {
        pt: 'Salvar como canal mais utilizado',
        en: 'Save as most used channel',
    },
    'If selected, this channel will be used as the default for starting new conversations': {
        pt: 'Se selecionado,  este canal será utilizado como padrão para inicio de novas conversas',
        en: 'If selected, this channel will be used as the default for starting new conversations',
    },
    Start: {
        pt: 'Iniciar',
        en: 'Start',
    },
    'No channels found': {
        pt: 'Nenhum canal encontrado',
        en: 'No channels found',
    },
    'No channels available to validate the number': {
        pt: 'Nenhum canal disponível para validar o número',
        en: 'No channels available to validate the number',
    },
    'We were unable to create a conversation for this contact': {
        pt: 'Não foi possível criar uma conversa para este contato',
        en: 'We were unable to create a conversation for this contact',
    },
    "We didn't find any results, please try again with another term": {
        pt: 'Não encontramos nenhum resultado, tente novamente com outro termo',
        en: "We didn't find any results, please try again with another term",
    },
    "Type a message or press '/' to select a template": {
        pt: "Digite uma mensagem ou pressione '/' para selecionar um modelo",
        en: "Type a message or press '/' to select a template",
    },
    'Send message to input field.': {
        pt: 'Enviar mensagem para o campo de entrada.',
        en: 'Send message to input field.',
    },
    'AI note': {
        pt: 'Nota da IA',
        en: 'AI note',
    },
    'Error note': {
        pt: 'Nota de erro',
        en: 'Error note',
    },
    'Internal use only. Not sent to the patient.': {
        pt: 'Uso interno. Não é enviado ao paciente.',
        en: 'Internal use only. Not sent to the patient.',
    },
    'Longer wait': {
        pt: 'Maior espera',
        en: 'Longer wait',
    },
    Creation: {
        pt: 'Criação',
        en: 'Creation',
    },
    'Last notification': {
        pt: 'Ultima notificação',
        en: 'Last notification',
    },
    Priority: {
        pt: 'Prioridade',
        en: 'Priority',
    },
    'Teams resume': {
        en: 'Teams resume',
        pt: 'Resumo dos Times',
    },
    'Hide inactive teams': {
        en: 'Hide inactive teams',
        pt: 'Ocultar times inativos',
    },
    'Take action if': {
        pt: 'Realizar ações caso',
        en: 'Take action if',
    },
    'Future Scheduling': {
        pt: 'Agendamento Futuro',
        en: 'Future Scheduling',
    },
    'Only messages': {
        en: 'Only messages',
        pt: 'Apenas mensagens',
    },
    'Only validate attendance': {
        en: 'Only validate attendance',
        pt: 'Apenas validar período de atendimento',
    },
    'show recent times': {
        en: 'show recent times',
        pt: 'Mostrar horários recentes',
    },
    'If this option is activated, the most recent times of the base will be shown': {
        en: 'If this option is activated, the most recent times of the base will be shown',
        pt: 'Se acionado está opção serão mostrados os horários mais recentes da base',
    },
    Team: {
        en: 'Team',
        pt: 'Time',
    },
    'No team assigned': {
        en: 'No team assigned',
        pt: 'Nenhum time atribuído',
    },
    Week: {
        en: 'Week',
        pt: 'Semana',
    },
    Day: {
        en: 'Day',
        pt: 'Dia',
    },
    Hour: {
        en: 'Hour',
        pt: 'Hora',
    },
    Minute: {
        en: 'Minute',
        pt: 'Minuto',
    },
    Months: {
        en: 'Months',
        pt: 'Mês',
    },
    'Agents resume': {
        en: 'Agents resume',
        pt: 'Resumo dos Agentes',
    },
    'Registered agents': {
        en: 'Registered agents',
        pt: 'Agentes cadastrados',
    },
    'Waiting for response': {
        en: 'Waiting for response',
        pt: 'Aguardando resposta',
    },
    'Appointments that have been taken over by the agent (no longer waiting for service) and are in their inbox, awaiting the agent response':
        {
            en: 'Appointments that have been taken over by the agent (no longer waiting for service) and are in their inbox, awaiting the agent response',
            pt: 'Atendimentos que foram assumidos pelo agente (não estão mais aguardando atendimento) e que estão no Inbox dele aguardando resposta do agente',
        },
    "Average time taken for the agent's services to be initiated by him (taken over)": {
        en: "Average time taken for the agent's services to be initiated by him (taken over)",
        pt: 'Média de tempo que os atendimentos do agente levaram até serem iniciados por ele (assumidos)',
    },
    'Total in attendance': {
        en: 'Total in attendance',
        pt: 'Total em atendimento',
    },
    'Total number of appointments currently handled by the agent': {
        en: 'Total number of appointments currently handled by the agent',
        pt: 'Total de atendimentos que estão assumidos pelo agente',
    },
    'Average time the agent appointments took from being transferred to the team until the session was completed': {
        en: 'Average time the agent appointments took from being transferred to the team until the session was completed',
        pt: 'Média de tempo que os atendimentos do agente levaram desde a transferência para o time até a finalização do atendimento',
    },
    'Appointments that were completed by the agent on the day': {
        en: 'Appointments that were completed by the agent on the day',
        pt: 'Atendimentos que foram finalizados no dia pelo agente',
    },
    'Registered teams': {
        en: 'Registered teams',
        pt: 'Times cadastrados',
    },
    'Appointments that were transferred to a team and are waiting for an agent to take over': {
        en: 'Appointments that were transferred to a team and are waiting for an agent to take over',
        pt: 'Atendimentos que foram transferidos para um time e estão aguardando algum agente assumir',
    },
    'Average time it takes for the team pending appointments to be initiated (taken over)': {
        en: 'Average time it takes for the team pending appointments to be initiated (taken over)',
        pt: 'Média de tempo que os atendimentos do time que estão aguardando atendimento levam até serem iniciados (assumidos)',
    },
    'Total number of appointments currently handled by the team agents': {
        en: 'Total number of appointments currently handled by the team agents',
        pt: 'Total de atendimentos que estão assumidos por agentes do time',
    },
    'Average time the team appointments take from being transferred to the team until the session is completed': {
        en: 'Average time the team appointments take from being transferred to the team until the session is completed',
        pt: 'Média de tempo que os atendimentos do time levam desde a transferência para um time até a finalização do atendimento',
    },
    'Number of appointments completed by the team on the day': {
        en: 'Number of appointments completed by the team on the day',
        pt: 'Quantidade de atendimentos que foram finalizados no dia pelo time',
    },
    'Performance Agents': {
        en: 'Performance Agents',
        pt: 'Desempenho Agentes',
    },
    'Error downloading report': {
        en: 'Error downloading report',
        pt: 'Erro ao baixar relatório',
    },
    'Average agent response time': {
        en: 'Average agent response time',
        pt: 'Tempo Médio de Resposta Agente',
    },
    'Average patient response time': {
        en: 'Average patient response time',
        pt: 'Tempo Médio de Resposta Paciente',
    },
    'This table does not present data for unfinished attendances': {
        en: 'This table does not present data for unfinished attendances',
        pt: 'Essa tabela não apresenta dados para atendimentos não finalizados',
    },
    'Average Patient Response Time': {
        en: 'Average Patient Response Time',
        pt: 'Tempo Médio de Resposta Paciente',
    },
    'Total assumed by agent': {
        en: 'Total assumed by agent',
        pt: 'Total assumido pelo agente',
    },
    'Finalized agents': {
        en: 'Agents resume',
        pt: 'Resumo dos Agentes',
    },
    'Agents (assumed)': {
        en: 'Agents (assumed)',
        pt: 'Agentes (assumidos)',
    },
    opposeStepText: {
        en: 'Oppose',
        pt: 'Negação',
    },
    confirmPresence: {
        en: 'Confirm presence',
        pt: 'Confirmar presença',
    },
    'Agents (finalized)': {
        en: 'Agents (finalized)',
        pt: 'Agentes (finalizado)',
    },
    'Messages by agent': {
        en: 'Messages by agent',
        pt: 'Mensagens por agente',
    },
    'Messages by tags': {
        en: 'Messages by tags',
        pt: 'Mensagens por etiqueta',
    },
    'Awaiting agent': {
        en: 'Awaiting agent',
        pt: 'Aguardando atendimento',
    },
    'In attendance': {
        en: 'In attendance',
        pt: 'Em atendimento',
    },
    Teams: {
        pt: 'Times',
        en: 'Teams',
    },
    'Error updating the user. Try again': {
        pt: 'Erro ao atualizar o usuário. Tente novamente',
        en: 'Error updating the user. Try again',
    },
    'User updated successfully': {
        pt: 'Usuário atualizado com sucesso',
        en: 'User updated successfully',
    },
    'Last synced': {
        pt: 'Última atualização',
        en: 'Last synced',
    },
    'Avatar updated successfully': {
        pt: 'Avatar atualizado com sucesso',
        en: 'Avatar updated successfully',
    },

    'Failed to update avatar. Try again': {
        pt: 'Falha ao atualizar o avatar. Tente novamente',
        en: 'Failed to update avatar. Try again',
    },
    'Avatar removed successfully': {
        pt: 'Avatar removido com sucesso',
        en: 'Avatar removed successfully',
    },
    'Synchronization effected. Follow the progress through the status field': {
        pt: 'Sincronização efetuada. Acompanhe o andamento através do campo status',
        en: 'Synchronization effected. Follow the progress through the status field',
    },
    'Last entities synced': {
        pt: 'Última atualização de entidades',
        en: 'Last entities synced',
    },
    'Published entities': {
        pt: 'Entidades publicadas',
        en: 'Published entities',
    },
    Correlations: {
        pt: 'Correlações',
        en: 'Correlations',
    },
    'Extract request sended': {
        pt: 'Solicitação de extração enviada. Aguarde alguns minutos.',
        en: 'Extract request sended. Wait a few minutes.',
    },
    'The import of entities is already being executed': {
        pt: 'A importação de entidades já está sendo executada',
        en: 'The import of entities is already being executed',
    },
    'Synchronize entities': {
        pt: 'Sincronizar entidades',
        en: 'Synchronize entities',
    },
    'Import entities': {
        pt: 'Importar entidades',
        en: 'Import entities',
    },
    'Access token': {
        pt: 'Token para acesso',
        en: 'Access token',
    },
    'Test integration': {
        pt: 'Testar integração',
        en: 'Test integration',
    },
    'Start attendance to view messages': {
        pt: 'Inicie o atendimento para visualizar as mensagens',
        en: 'Start attendance to view messages',
    },
    'Unread messages': {
        pt: 'Mensagens não lidas',
        en: 'Unread messages',
    },
    Exam: {
        pt: 'Exame',
        en: 'Exam',
    },
    'Message to user': {
        pt: 'Mensagem para o usuário',
        en: 'Message to user',
    },
    Comment: {
        pt: 'Comentário',
        en: 'Comment',
    },
    'Create an annotation that will be available only at the attendance': {
        pt: 'Crie uma anotação que ficará disponível apenas no atendimento',
        en: 'Create an annotation that will be available only at the attendance',
    },
    'Add annotation for this file (max 4096 characters)': {
        pt: 'Adicione uma anotação para este arquivo (máx. 4096 caracteres)',
        en: 'Add annotation for this file (max 4096 characters)',
    },
    'Annotation will not be sent to the client': {
        pt: 'A anotação não será enviada para o cliente',
        en: 'Annotation will not be sent to the client',
    },
    Annotation: {
        pt: 'Anotação',
        en: 'Annotation',
    },
    'It seems that there is no team or you are not allowed to start new attendances. Talk to your supervisor!': {
        pt: 'Parece que não existe nenhum time ou você não tem permissão para iniciar novos atendimentos. Fale com seu supervisor!',
        en: 'It seems that there is no team or you are not allowed to start new attendances. Talk to your supervisor!',
    },
    'There is no channel available to start attendances': {
        pt: 'Não existe nenhum canal disponível para iniciar atendimentos',
        en: 'There is no channel available to start attendances',
    },
    'Invite to the workspace': {
        pt: 'Convidar para o workspace',
        en: 'Invite to the workspace',
    },
    'User already exists in workspace': {
        pt: 'Usuário já existe no workspace',
        en: 'User already exists in workspace',
    },
    'User already exists': {
        pt: 'Usuário já existe',
        en: 'User already exists',
    },
    'Not sent to user': {
        pt: 'Não é enviado para o usuário',
        en: 'Not sent to user',
    },
    Active: {
        pt: 'Ativo',
        en: 'Active',
    },
    Actives: {
        pt: 'Ativos',
        en: 'Actives',
    },
    'Importing messages': {
        pt: 'Importação de mensagens',
        en: 'Importing messages',
    },
    'Whatsapp messages will be imported from a predefined date': {
        pt: 'As mensagens do whatsapp serão importadas a partir de uma data pré-definida',
        en: 'Whatsapp messages will be imported from a predefined date',
    },
    'No period registered': {
        pt: 'Nenhum período cadastrado',
        en: 'No period registered',
    },
    'Conversation transferred': {
        en: 'Conversation transferred',
        pt: 'Conversa transferida',
    },
    'Conversation could not be transferred': {
        en: 'Conversation could not be transferred',
        pt: 'Não foi possível transferir a conversa',
    },
    Transfer: {
        en: 'Transfer',
        pt: 'Transferir',
    },
    'It seems that there is no team or you are not allowed to make transfers': {
        en: 'It seems that there is no team or you are not allowed to make transfers',
        pt: 'Parece que não existe nenhum time ou você não tem permissão para realizar transferências',
    },
    'There was an error while trying to resend the message': {
        en: 'There was an error while trying to resend the message',
        pt: 'Houve um erro ao tentar reenviar a mensagem',
    },
    'The conversation could not be loaded. Try again': {
        en: 'The conversation could not be loaded. Try again',
        pt: 'Não foi possível carregar a conversa. Tente novamente',
    },
    'Bot published': {
        pt: 'Bot publicado com sucesso',
        en: 'Bot published successfully',
    },
    'Bot interactions publish failed': {
        pt: 'Falha ao publicar interações',
        en: 'Error on publish interactions',
    },
    Publish: {
        pt: 'Publicar',
        en: 'Publish',
    },
    'Very large file. Select a file with a maximum of 10Mb': {
        en: 'Very large file. Select a file with a maximum of 10Mb',
        pt: 'Arquivo muito grande. Selecione um arquivo com no máximo 10Mb',
    },
    Record: {
        en: 'Record',
        pt: 'Gravar',
    },
    Finish: {
        en: 'Finish',
        pt: 'Concluir',
    },
    'Import messages from a specific number': {
        pt: 'Importar mensagens de um número especifico',
        en: 'Import messages from a specific number',
    },
    Import: {
        pt: 'Importar',
        en: 'Import',
    },
    'Battery level': {
        pt: 'Nível de Bateria',
        en: 'Battery level',
    },
    Connected: {
        pt: 'Conectado',
        en: 'Connected',
    },
    Connecting: {
        pt: 'Conectando',
        en: 'Connecting',
    },
    Timestamp: {
        pt: 'Data e Hora',
        en: 'Timestamp',
    },
    'Waiting average time': {
        pt: 'Tempo Médio de Espera',
        en: 'Waiting average time',
    },
    'Attendance average time': {
        pt: 'Tempo Médio de Atendimento',
        en: 'Attendance average time',
    },
    'Attendance average time (general)': {
        pt: 'Tempo Médio de Atendimento (Geral)',
        en: 'Attendance average time (general)',
    },
    'Attendance average time (segregated)': {
        pt: 'Tempo Médio de Atendimento (Segregado)',
        en: 'Attendance average time (segregated)',
    },
    'TMA General': {
        pt: 'TMA Geral',
        en: 'TMA General',
    },
    'TMA Segregated': {
        pt: 'TMA Segregado',
        en: 'TMA Segregated',
    },
    TME: {
        pt: 'TME',
        en: 'TME',
    },
    TMRA: {
        pt: 'TMRA',
        en: 'TMRA',
    },
    TMRP: {
        pt: 'TMRP',
        en: 'TMRP',
    },
    TMEHA: {
        pt: 'TMEHA',
        en: 'TMEHA',
    },
    Bot: {
        pt: 'Bot',
        en: 'Bot',
    },
    'Sent an image': {
        pt: 'Enviou uma imagem',
        en: 'Sent an image',
    },
    'Sent a video': {
        pt: 'Enviou um video',
        en: 'Sent a video',
    },
    'Sent an audio': {
        pt: 'Enviou um áudio',
        en: 'Sent an audio',
    },
    'Sent a file': {
        pt: 'Enviou um arquivo',
        en: 'Sent a file',
    },
    Conversation: {
        pt: 'Conversa',
        en: 'Conversation',
    },
    'Download conversation': {
        pt: 'Baixar conversa',
        en: 'Download conversation',
    },
    'Sent a message': {
        pt: 'Enviou uma mensagem',
        en: 'Sent a message',
    },
    Integration: {
        pt: 'Integração',
        en: 'Integration',
    },
    'Jump speciality': {
        pt: 'Pular especialidade',
        en: 'Jump speciality',
    },
    'Select a file up to 2MB': {
        pt: 'Selecione um arquivo de até 2MB!',
        en: 'Select a file up to 2MB!',
    },
    'Select a file up to': {
        pt: 'Selecione um arquivo de até',
        en: 'Select a file up to',
    },
    'Real time': {
        pt: 'Tempo real',
        en: 'Real time',
    },
    'Finished of the day': {
        pt: 'Finalizados no dia',
        en: 'Finished of the day',
    },
    'TME average total': {
        pt: 'Total Médio TME',
        en: 'TME average total',
    },
    'Active TME': {
        pt: 'TMEHA - Tempo Médio em Horário Ativo',
        en: 'Active TME',
    },
    'TME 1st response': {
        pt: 'TME - Tempo Médio de Espera',
        en: 'TME 1st response',
    },
    'Services completed': {
        pt: 'Atendimentos finalizados',
        en: 'Services completed',
    },
    'TMA average total': {
        pt: 'Total Médio TMA Segregado',
        en: 'TMA Segregated average total',
    },
    'Conversation expired. It is necessary to send templates or wait for the user to respond to send messages normally.':
        {
            pt: 'Atendimento expirado. Para enviar mensagens é necessário um template oficial ou aguardar uma nova mensagem do usuário.',
            en: 'Conversation expired. It is necessary to send templates or wait for the user to respond to send messages normally.',
        },
    'The conversation expired': {
        pt: 'A conversa expirou',
        en: 'The conversation expired',
    },
    'It is necessary to wait for the user`s response before sending messages': {
        pt: 'É necessário aguardar uma resposta do usuário antes de enviar uma mensagem',
        en: 'It is necessary to wait for the user`s response before sending messages',
    },
    'Invalid message contains blank spaces': {
        pt: 'Mensagem inválida possui espaços em branco',
        en: 'Invalid message contains blank spaces',
    },
    'Message field is required': {
        pt: 'Campo de mensagem é obrigatório',
        en: 'Message field is required',
    },
    'Show less': {
        pt: 'Mostrar menos',
        en: 'Show less',
    },
    'Show more': {
        pt: 'Mostrar mais',
        en: 'Show more',
    },
    'Teams that can use the template': {
        pt: 'Times que podem utilizar o template',
        en: 'Teams that can use the template',
    },
    'All teams can use this template': {
        pt: 'Todos os times podem utilizar este template',
        en: 'All teams can use this template',
    },
    'All teams': {
        pt: 'Todos os times',
        en: 'All teams',
    },
    'All channels can use this template': {
        pt: 'Todos os canais podem utilizar este template',
        en: 'All channels can use this template',
    },
    'Fill in the fields to proceed with sending the message': {
        en: 'Fill in the fields to proceed with sending the message',
        pt: 'Preencha os campos para prosseguir com o envio da mensagem',
    },
    'Template text cannot be edited': {
        en: 'Template text cannot be edited',
        pt: 'Texto do template não pode ser editado',
    },
    'This official template is locked. Remove it to type a custom message.': {
        en: 'This official template is locked. Remove it to type a custom message.',
        pt: 'Este template oficial está bloqueado. Remova-o para digitar uma mensagem personalizada.',
    },
    'Text improvement disabled for non-editable templates': {
        en: 'Text improvement disabled for non-editable templates',
        pt: 'Melhoria de texto desabilitada para templates não editáveis',
    },
    'Emoji selection disabled for non-editable templates': {
        en: 'Emoji selection disabled for non-editable templates',
        pt: 'Seleção de emoji desabilitada para templates não editáveis',
    },
    'File attachment disabled for non-editable templates': {
        en: 'File attachment disabled for non-editable templates',
        pt: 'Anexar arquivo desabilitado para templates não editáveis',
    },
    'Audio recording disabled for non-editable templates': {
        en: 'Audio recording disabled for non-editable templates',
        pt: 'Gravação de áudio desabilitada para templates não editáveis',
    },
    'Allow Whatsapp to change template category': {
        en: 'Allow Whatsapp to change template category',
        pt: 'Permitir que o Whatsapp altere a categoria do template',
    },
    'Select the channels that can use the template': {
        en: 'Select the channels that can use the template',
        pt: 'Selecione os canais que podem utilizar o template',
    },
    'Select the teams that can use the template': {
        en: 'Select the teams that can use the template',
        pt: 'Selecione os times que podem utilizar o template',
    },
    'An error has occurred. Try to validate the number again': {
        en: 'An error has occurred. Try to validate the number again',
        pt: 'Ocorreu um erro. Tente validar o número novamente',
    },
    'An error has occurred. Check the fields': {
        en: 'An error has occurred. Check the fields',
        pt: 'Ocorreu um erro. Verifique os campos',
    },
    'Intent is already being used in this context. Interaction:': {
        en: 'Intent is already being used in this context. Interaction:',
        pt: 'A intenção já está sendo usada neste contexto. Interação:',
    },
    'Agent empty reply placeholder': {
        en: 'No response',
        pt: 'Sem resposta',
    },
    'Sem mensagem de resposta': {
        en: 'No response message',
        pt: 'Sem mensagem de resposta',
    },
    'Permitir envio de áudio': {
        en: 'Allow audio sending',
        pt: 'Permitir envio de áudio',
    },
    'Edit variables': {
        en: 'Edit variables',
        pt: 'Editar variáveis',
    },
    Variables: {
        en: 'Variables',
        pt: 'Variáveis',
    },
    'Patient code': {
        en: 'Patient code',
        pt: 'Código do paciente',
    },
    'Type of service': {
        en: 'Type of service',
        pt: 'Tipo do serviço',
    },
    return: {
        en: 'Return',
        pt: 'Retorno',
    },
    view: {
        en: 'View',
        pt: 'Visualizar',
    },
    cancel: {
        en: 'Cancel',
        pt: 'Cancelar',
    },
    confirm: {
        en: 'Confirm',
        pt: 'Confirmar',
    },
    Objective: {
        en: 'Objective',
        pt: 'Objetivo',
    },
    Objectives: {
        en: 'Objectives',
        pt: 'Objetivos',
    },
    'Enable message replies': {
        en: 'Enable message replies',
        pt: 'Habilitar responder mensagens',
    },
    'By enabling this feature, the agent will be able to reply to specific messages in the ongoing conversation, just as they can today when replying directly to a message in WhatsApp':
        {
            en: 'By enabling this feature, the agent will be able to reply to specific messages in the ongoing conversation, just as they can today when replying directly to a message in WhatsApp',
            pt: 'Ao habilitar este recurso, o agente poderá responder mensagens específicas na conversa em andamento, assim como já faz hoje ao responder diretamente a uma mensagem no WhatsApp',
        },
    Footer: {
        en: 'Footer',
        pt: 'Rodapé',
    },
    'Footer message': {
        en: 'Footer message',
        pt: 'Mensagem do rodapé',
    },
    'Security recommendation': {
        en: 'Security recommendation',
        pt: 'Recomendação de segurança',
    },
    'Type a footer message (optional)': {
        en: 'Type a footer message (optional)',
        pt: 'Digite uma mensagem para o rodapé (opcional)',
    },
    'Passive confirmation': {
        en: 'Passive confirmation',
        pt: 'Confirmação passiva',
    },
    'Enable reschedule': {
        en: 'Enable reschedule',
        pt: 'Habilitar reagendar',
    },
    'Disable reschedule': {
        en: 'Disable reschedule',
        pt: 'Desabilitar reagendar',
    },
    "Enables automatic rescheduling of this entity within the bot's flow.": {
        pt: 'Permite reagendamento automático desta entidade no fluxo do bot.',
        en: "Enables automatic rescheduling of this entity within the bot's flow.",
    },
    "Enables automatic cancellation of this entity within the bot's flow.": {
        en: "Enables automatic cancellation of this entity within the bot's flow.",
        pt: 'Possibilita o cancelamento automático desta entidade dentro do fluxo do bot.',
    },
    "Enables automatic scheduling of this entity within the bot's flow.": {
        en: "Enables automatic scheduling of this entity within the bot's flow.",
        pt: 'Permite agendamento automático desta entidade no fluxo do bot.',
    },
    'Allows visualization of the entity.': {
        en: 'Allows visualization of the entity.',
        pt: 'Permite a visualização da entidade.',
    },
    'Name to be displayed in the bot': {
        en: 'Name to be displayed in the bot',
        pt: 'Nome a ser exibido no bot',
    },
    'The higher the number, the closer to the beginning it will be.': {
        en: 'The higher the number, the closer to the beginning it will be.',
        pt: 'Quanto maior o número, mais no início ele estará.',
    },
    'Name imported into ERP': {
        en: 'Name imported into ERP',
        pt: 'Nome importado no ERP',
    },
    'Keywords that, when typed, will match with the entity.': {
        en: 'Keywords that, when typed, will match with the entity.',
        pt: 'Palavras-chave que, ao serem digitadas, encontrarão correspondência com a entidade.',
    },
    'Enable view': {
        en: 'Enable view',
        pt: 'Habilitar visualizar',
    },
    'Disable view': {
        en: 'Disable view',
        pt: 'Desabilitar visualizar',
    },
    'Enable Actively confirm': {
        en: 'Enable Actively confirm',
        pt: 'Habilitar Confirmar ativamente',
    },
    'Enable Confirm passively': {
        en: 'Enable Confirm passively',
        pt: 'Habilitar Confirmar passivamente',
    },
    'Disable Actively confirm': {
        en: 'Disable Actively confirm',
        pt: 'Desabilitar Confirmar ativamente',
    },
    'Disable Confirm passively': {
        en: 'Disable Confirm passively',
        pt: 'Desabilitar Confirmar passivamente',
    },
    'Select an action': {
        en: 'Select an action',
        pt: 'Selecione uma ação',
    },
    'Ignored action': {
        en: 'Ignored action',
        pt: 'Ação ignorada',
    },
    'Can send audio messages': {
        en: 'Can send audio messages',
        pt: 'Enviar mensagens de áudio',
    },
    'Can send official template': {
        en: 'Can send official template',
        pt: 'Enviar template oficial',
    },
    Time: {
        en: 'Time',
        pt: 'Horário',
    },
    Boolean: {
        en: 'Boolean',
        pt: 'Boleano',
    },
    'Requires authentication': {
        en: 'Requires authentication',
        pt: 'Exige autenticação',
    },
    'Hang tags': {
        en: 'Hang tags',
        pt: 'Etiquetas',
    },
    'Create hang tags': {
        en: 'Create hang tags',
        pt: 'Criar etiquetas',
    },
    'Existing tags': {
        en: 'Existing tags',
        pt: 'Etiquetas existentes',
    },
    'No hang tags found': {
        en: 'No hang tags found',
        pt: 'Nenhuma etiqueta encontrada',
    },
    'Creating tag': {
        en: 'Creating tag',
        pt: 'Criando etiqueta',
    },
    'Editing tag': {
        en: 'Editing tag',
        pt: 'Editando etiqueta',
    },
    'Are you sure you want to delete the tag?': {
        pt: 'Tem certeza de que deseja excluir a etiqueta?',
        en: 'Are you sure you want to delete the tag?',
    },
    'Tag successfully created': {
        pt: 'Etiqueta criada com sucesso',
        en: 'Tag successfully created',
    },
    'Tag updated successfully': {
        pt: 'Etiqueta atualizada com sucesso',
        en: 'Tag updated successfully',
    },
    'Find a tag': {
        pt: 'Encontre uma etiqueta',
        en: 'Find a tag',
    },
    Interconsultation: {
        pt: 'Interconsulta',
        en: 'Interconsultation',
    },
    'Interconsultation period': {
        pt: 'Período de interconsulta',
        en: 'Interconsultation period',
    },
    Subplan: {
        pt: 'Subplano',
        en: 'Subplan',
    },
    Subplans: {
        pt: 'Subplanos',
        en: 'Subplans',
    },
    Plans: {
        pt: 'Planos',
        en: 'Plans',
    },
    Synced: {
        pt: 'Sincronizado',
        en: 'Synced',
    },
    Synchronizing: {
        pt: 'Sincronizando',
        en: 'Synchronizing',
    },
    'Check all': {
        pt: 'Selecionar todos',
        en: 'Check all',
    },
    'Invert selection': {
        pt: 'Inverter seleção',
        en: 'Invert selection',
    },
    'Edit all selected': {
        pt: 'Editar todos os selecionados',
        en: 'Edit all selected',
    },
    'Edit in table': {
        pt: 'Editar na tabela',
        en: 'Edit in table',
    },
    'Edit in modal': {
        pt: 'Editar no modal',
        en: 'Edit in  modal',
    },
    Enabled: {
        pt: 'Habilitado',
        en: 'Enabled',
    },
    'Api token': {
        en: 'Api token',
        pt: 'Token de api',
    },
    'Show appointment value': {
        en: 'Show appointment value',
        pt: 'Exibe valor do procedimento',
    },
    'Discount plan': {
        en: 'Discount plan',
        pt: 'Convênio de desconto',
    },
    Exit: {
        pt: 'Sair',
        en: 'Exit',
    },
    'Find patient': {
        en: 'Find patient',
        pt: 'Encontrar paciente',
    },
    'Enter the platform': {
        en: 'Enter the platform',
        pt: 'Entrar na plataforma',
    },
    Wait: {
        pt: 'Aguarde',
        en: 'Wait',
    },
    'Send image': {
        pt: 'Enviar imagem',
        en: 'Send image',
    },
    Sending: {
        en: 'Sending',
        pt: 'Enviando',
    },
    'Sending...': {
        en: 'Sending...',
        pt: 'Enviando...',
    },
    'Upload file': {
        en: 'Upload file',
        pt: 'Enviar arquivo',
    },
    'Remove file': {
        en: 'Remove file',
        pt: 'Remover arquivo',
    },
    'File size exceeds 10MB limit': {
        en: 'File size exceeds 10MB limit',
        pt: 'Tamanho do arquivo excede o limite de 10MB',
    },
    Unity: {
        en: 'Unity',
        pt: 'Unidade',
    },
    Appointments: {
        en: 'Appointments',
        pt: 'Agendamentos',
    },
    Nothing: {
        en: 'Nothing',
        pt: 'Nenhum',
    },
    'Search another patient': {
        en: 'Search another patient',
        pt: 'Buscar outro paciente',
    },
    'User not registered': {
        en: 'User not registered',
        pt: 'Usuário não cadastrado',
    },
    'Authentication error, try log in again': {
        en: 'Authentication error, try log in again',
        pt: 'Erro de autenticação, tente logar novamente',
    },
    'CPF or birthdate invalid': {
        en: 'CPF or birthdate invalid',
        pt: 'CPF ou data de nascimento inválido',
    },
    'File type': {
        en: 'File type',
        pt: 'Tipo de arquivo',
    },
    'Enable message notification sound.': {
        en: 'Enable message notification sound.',
        pt: 'Habilitar som de notificação de mensagem.',
    },
    Sound: {
        en: 'Sound',
        pt: 'Som',
    },
    'Flow synchronized successfully': {
        en: 'Flow synchronized successfully',
        pt: 'Fluxo sincronizado com sucesso',
    },
    'All flows are already published in homologation.': {
        en: 'All flows are already published in homologation.',
        pt: 'Todos os fluxos já estão publicados em homologação.',
    },
    'Are you sure you want to publish the flow to production?': {
        en: 'Are you sure you want to publish the flow to production?',
        pt: 'Tem certeza que deseja fazer a publicação do fluxo para produção?',
    },
    'There are flows that have not yet been published for approval.': {
        en: 'There are flows that have not yet been published for approval.',
        pt: 'Existem fluxos que ainda não foram publicados para homologação.',
    },
    'All streams are already published in production.': {
        en: 'All streams are already published in production.',
        pt: 'Todos os fluxos já estão publicados em produção.',
    },
    'Publish approval flow': {
        en: 'Publish approval flow',
        pt: 'Publicar fluxo para homologação',
    },
    'Flow already published for homologation': {
        en: 'Flow already published for homologation',
        pt: 'Fluxo já publicado para homologação',
    },
    'Change not published for production': {
        en: 'Change not published for production',
        pt: 'Alteração não publicada para produção',
    },
    'Service settings': {
        en: 'Service settings',
        pt: 'Configurações dos atendimentos',
    },
    'Could not get image types': {
        en: 'Could not get image types',
        pt: 'Não foi possível obter os tipos de imagem',
    },
    Service: {
        en: 'Service',
        pt: 'Serviço',
    },
    'Show external entities': {
        en: 'Show external entities',
        pt: 'Mostrar entidades externas',
    },
    'Supervisor (All permissions enabled)': {
        pt: 'Supervisor (Todas as permissões habilitadas)',
        en: 'Supervisor (All permissions enabled)',
    },
    'Start attendances': {
        pt: 'Iniciar atendimentos',
        en: 'Start attendances',
    },
    'There was an error loading the workspace teams. Refresh the page': {
        pt: 'Ocorreu um erro ao carregar os times do workspace. Atualize a página',
        en: 'There was an error loading the workspace teams. Refresh the page',
    },
    'An error has occurred': {
        en: 'An error has occurred',
        pt: 'Ocorreu um erro',
    },
    'Invalid file type for transcription.': {
        en: 'Invalid file type for transcription.',
        pt: 'Tipo do arquivo inválido para transcrição.',
    },
    'File size too large for transcription.': {
        en: 'File size too large for transcription.',
        pt: 'Tamanho do arquivo muito grande para transcrição.',
    },
    'An error occurred, please try again later.': {
        en: 'An error occurred, please try again later.',
        pt: 'Ocorreu um erro, tente novamente mais tarde.',
    },
    'Convert to text': {
        en: 'Convert to text',
        pt: 'Transformar em texto',
    },
    'Powered by AI': {
        en: 'Powered by AI',
        pt: 'Realizado por IA',
    },
    'Download audio': {
        en: 'Download audio',
        pt: 'Baixar áudio',
    },
    'Text transcribed by artificial intelligence': {
        en: 'Text transcribed by artificial intelligence',
        pt: 'Texto transcrito por inteligência artificial',
    },
    'Transcribing audio': {
        en: 'Transcribing audio',
        pt: 'Transcrevendo áudio',
    },
    'Show text': {
        en: 'Show text',
        pt: 'Mostrar texto',
    },
    'Hide text': {
        en: 'Hide text',
        pt: 'Ocultar texto',
    },
    'Formatting rules for case types in patient names': {
        en: 'Formatting rules for case types in patient names',
        pt: 'Regras de formatação para tipos de case em nomes de paciente',
    },
    Uppercase: {
        en: 'Uppercase',
        pt: 'Maiúscula',
    },
    Lowercase: {
        en: 'Lowercase',
        pt: 'Minúscula',
    },
    'None of the options': {
        en: 'None of the options',
        pt: 'Nenhuma das opções',
    },
    'Capitalize the first letter of each word.': {
        en: 'Capitalize the first letter of each word.',
        pt: 'Primeira letra de cada palavra maiúscula',
    },
    Rules: {
        en: 'Rules',
        pt: 'Regras',
    },
    'Rules confirmation': {
        en: 'Rules confirmation',
        pt: 'Regras confirmação',
    },
    'Edit integrations rules': {
        en: 'Edit integrations rules',
        pt: 'Editar regras de integração',
    },
    'Integration message': {
        pt: 'Mensagens da integração',
        en: 'Integration message',
    },
    'Message configuration': {
        pt: ' Configuração de mensagem',
        en: 'Message configuration',
    },
    'Integrations rules': {
        en: 'Integrations rules',
        pt: 'Regras de integração',
    },
    'Enable sending list for all steps': {
        en: 'Enable sending list for all steps',
        pt: 'Habilitar envio de lista para todas as etapas',
    },
    'Show speciality and procedure as a single option for the AI': {
        en: 'Show speciality and procedure as a single option for the AI',
        pt: 'Mostrar especialidade e procedimento como uma opção só para a IA',
    },
    'Require medical request to schedule exams': {
        en: 'Require medical request to schedule exams',
        pt: 'Exigir pedido médico para agendar exames',
    },
    'Available only for integrations with AI medical request reading enabled': {
        en: 'Available only for integrations with AI medical request reading enabled',
        pt: 'Disponível apenas para integrações com leitura de pedido médico por IA ativa.',
    },
    'Time limit rules': {
        en: 'Time limit rules',
        pt: 'Regras de limite de tempo',
    },
    'List only doctors with available schedules': {
        en: 'List only doctors with available schedules',
        pt: 'Listar apenas médicos com horários disponíveis',
    },
    'Run routine to search for available schedules': {
        en: 'Run routine to search for available schedules',
        pt: 'Executar rotina de buscar agendas disponiveis',
    },
    'Apply interquery in the timetable listing': {
        en: 'Apply interquery in the timetable listing',
        pt: 'Aplicar interconsulta na listagem de horários',
    },
    'Integration rules updated': {
        en: 'Integration rules updated',
        pt: 'Regras da integração atualizadas',
    },
    Continue: {
        en: 'Continue',
        pt: 'Continuar',
    },
    'Copy date': {
        en: 'Copy date',
        pt: 'Copiar data',
    },
    'Copy date to:': {
        en: 'Copy date to:',
        pt: 'Copiar data para:',
    },
    'Cannot assign conversation': {
        en: 'Cannot assign conversation',
        pt: 'Não é possível atribuir conversa',
    },
    'Disable all options': {
        en: 'Disable all options',
        pt: 'Desabilitar todas as opções',
    },
    'Selection of an existing team in this workspace is required': {
        en: 'Selection of an existing team in this workspace is required',
        pt: 'Obrigatório seleção de um time existente neste workspace',
    },
    'It is not possible to create a bot in this workspace because there is no DialogFlow account.': {
        en: 'It is not possible to create a bot in this workspace because there is no DialogFlow account.',
        pt: 'Não é possível criar um bot neste workspace por não haver uma conta no DialogFlow.',
    },
    'The search text is too long. Use at most': {
        en: 'The search text is too long. Use at most',
        pt: 'O texto da busca é muito grande. Utilize no máximo',
    },
    words: {
        en: 'words',
        pt: 'palavras',
    },
    'Got it': {
        en: 'Got it',
        pt: 'Entendi',
    },
    'No Data': {
        en: 'No Data',
        pt: 'Sem Dados',
    },
    Notifications: {
        en: 'Notifications',
        pt: 'Notificações',
    },
    'Notification List': {
        en: 'Notification List',
        pt: 'Lista de Notificações',
    },
    'Can start conversation': {
        en: 'Can start conversation',
        pt: 'Pode iniciar conversa',
    },
    'Can validate number': {
        en: 'Can validate number',
        pt: 'Pode validar o número',
    },
    'Date limit': {
        en: 'Date limit',
        pt: 'Data limite',
    },
    'Reschedule attribute code': {
        en: 'Reschedule attribute code',
        pt: 'Código do atributo de reagendamento',
    },
    rescheduled: {
        en: 'Rescheduled',
        pt: 'Reagendar',
    },
    schedule: {
        en: 'Schedule',
        pt: 'Agendar',
    },
    Unit: {
        en: 'Unit',
        pt: 'Unidade',
    },
    'Off days': {
        en: 'Off days',
        pt: 'Dias de folga',
    },
    'Offline Integration': {
        en: 'Offline Integration',
        pt: 'Integração Offline',
    },
    'Offline Integrations': {
        en: 'Offline Integrations',
        pt: 'Integrações Offline',
    },
    'The integration is offline': {
        en: 'The integration is offline',
        pt: 'A integração esta offline',
    },
    'The integration is disabled': {
        en: 'The integration is disabled',
        pt: 'A integração está desativada',
    },
    'The integration is online': {
        en: 'The integration is online',
        pt: 'A integração está online',
    },
    Identification: {
        en: 'Identification',
        pt: 'Identificação',
    },
    'Speciality Type': {
        en: 'Speciality Type',
        pt: 'Tipo de especialidade',
    },
    Position: {
        en: 'Position',
        pt: 'Posição',
    },
    creating: {
        en: 'creating',
        pt: 'criando',
    },
    editing: {
        en: 'editing',
        pt: 'editando',
    },
    'Entity not found!!!': {
        en: 'Entity not found!!!',
        pt: 'Entidade não encontrada!!!',
    },
    'Are you sure you want to delete entity': {
        en: 'Are you sure you want to delete entity',
        pt: 'Tem certeza de que deseja excluir a entidade',
    },
    'Entities empty': {
        en: 'Entities empty',
        pt: 'Entidades vazias',
    },
    sun: {
        en: 'sun',
        pt: 'dom',
    },
    mon: {
        en: 'mon',
        pt: 'seg',
    },
    tue: {
        en: 'tue',
        pt: 'ter',
    },
    wed: {
        en: 'wed',
        pt: 'qua',
    },
    thur: {
        en: 'thur',
        pt: 'qui',
    },
    fri: {
        en: 'fri',
        pt: 'sex',
    },
    sat: {
        en: 'sat',
        pt: 'sab',
    },
    'Add comment': {
        en: 'Add comment',
        pt: 'Adicionar Comentário',
    },
    'No comments': {
        en: 'No comments',
        pt: 'Sem comentários',
    },
    'No DialogFlow': {
        en: 'No DialogFlow',
        pt: 'Sem DialogFlow',
    },
    'Add a new comment below.': {
        en: 'Add a new comment below.',
        pt: 'Adicione um novo comentário abaixo.',
    },
    organizationUnit: {
        en: 'Organization',
        pt: 'Unidade',
    },
    organizationUnit_search: {
        en: 'Organization search',
        pt: 'Busca da unidade',
    },
    speciality: {
        en: 'Speciality',
        pt: 'Especialidade',
    },
    speciality_search: {
        en: 'Speciality search',
        pt: 'Busca da especialidade',
    },
    procedure: {
        en: 'Procedure',
        pt: 'Procedimento',
    },
    procedure_search: {
        en: 'Procedure search',
        pt: 'Busca do procedimento',
    },
    appointmentType: {
        en: 'Appointment type',
        pt: 'Tipo agendamento',
    },
    insurance: {
        en: 'Insurance',
        pt: 'Convênio',
    },
    insurance_search: {
        en: 'Insurance search',
        pt: 'Busca do convênio',
    },
    insurancePlan: {
        en: 'Insurance plan',
        pt: 'Plano',
    },
    insurancePlan_search: {
        en: 'Insurance plan search',
        pt: 'Busca do plano',
    },
    insuranceSubPlan: {
        en: 'Insurance sub plan',
        pt: 'Sub plano',
    },
    insuranceSubPlan_search: {
        en: 'Insurance sub plan search',
        pt: 'Busca do Sub plano',
    },
    planCategory: {
        en: 'Category',
        pt: 'Categoria',
    },
    planCategory_search: {
        en: 'Category search',
        pt: 'Busca da categoria',
    },
    group: {
        en: 'Group',
        pt: 'Grupo',
    },
    doctor: {
        en: 'Doctor',
        pt: 'Médico',
    },
    doctor_search: {
        en: 'Doctor search',
        pt: 'Busca do médico',
    },
    chooseDoctor: {
        en: 'Choose doctor',
        pt: 'Escolha de médico',
    },
    choose_doctor: {
        en: 'Choose doctor',
        pt: 'Escolher médico',
    },
    choose_day_period: {
        en: 'Choose period of day',
        pt: 'Escolher período do dia',
    },
    choosePeriodOfDay: {
        en: 'Choose period of day',
        pt: 'Escolher período do dia',
    },
    appointmentValue: {
        en: 'Appointment value question',
        pt: 'Confirma preço agendamento',
    },
    listPatientSchedules: {
        en: 'List patient schedules',
        pt: 'Listar agendamentos paciente',
    },
    reschedule: {
        en: 'Reschedule',
        pt: 'Reagendar',
    },
    omit: {
        en: 'Omit',
        pt: 'Omitir',
    },
    action: {
        en: 'Action',
        pt: 'Ação',
    },
    Step: {
        en: 'Step',
        pt: 'Etapa',
    },
    'Add tag': {
        en: 'Add tag',
        pt: 'Adicionar tag',
    },
    'List available exams': {
        en: 'List available exams',
        pt: 'Listar exames disponíveis',
    },
    'Add attribute': {
        en: 'Add attribute',
        pt: 'Adicionar atributo',
    },
    'Add postback': {
        en: 'Add postback',
        pt: 'Adicionar postback',
    },
    'Add goto': {
        en: 'Add goto',
        pt: 'Adicionar ir para',
    },
    'Add text': {
        en: 'Add text',
        pt: 'Adicionar texto',
    },
    'Add rules': {
        en: 'Add rules',
        pt: 'Adicionar regras',
    },
    'Add rules confirmation': {
        en: 'Add rules confirmation',
        pt: 'Adicionar regras de confirmação',
    },
    'Team transfer': {
        en: 'Team transfer',
        pt: 'Transferir para time',
    },
    'Team Transfer': {
        en: 'Team Transfer',
        pt: 'Transferir para time',
    },
    Respond: {
        en: 'Respond',
        pt: 'Responder',
    },
    'There are no actions, select one to add!': {
        en: 'There are no actions, select one to add!',
        pt: 'Não existe ações, selecione uma para adicionar!',
    },
    'Confirm cancellation': {
        en: 'Confirm cancellation',
        pt: 'Confirmar cancelamento',
    },
    'No flows registered': {
        en: 'No flows registered',
        pt: 'Nenhum fluxo cadastrado',
    },
    'search by entity': {
        en: 'search by entity',
        pt: 'procurar por entidade',
    },
    'search by flow id': {
        en: 'search by flow id',
        pt: 'procura por ID do Flow',
    },
    'New flow': {
        en: 'New flow',
        pt: 'Novo fluxo',
    },
    'Error loading flows': {
        en: 'Error loading flows',
        pt: 'Erro ao carregar os fluxos',
    },
    'Error loading entities': {
        en: 'Error loading entities',
        pt: 'Erro ao carregar entidades',
    },
    'Flow updated successfully': {
        en: 'Flow updated successfully',
        pt: 'Fluxo atualizado com sucesso',
    },
    'Invalid image format, select an image in another format.': {
        en: 'Invalid image format, select an image in another format.',
        pt: 'Formato de imagem invalido, selecione uma imagem em outro formato.',
    },
    Scheduling: {
        en: 'Scheduling',
        pt: 'Agendamento',
    },
    Force: {
        en: 'Force',
        pt: 'Forçar',
    },
    'Correlation in progress': {
        en: 'Correlation in progress',
        pt: 'Correlação em andamento',
    },
    'Move up': {
        en: 'Move up',
        pt: 'Mover para cima',
    },
    'Move down': {
        en: 'Move down',
        pt: 'Mover para baixo',
    },
    'Current password': {
        en: 'Current password',
        pt: 'Senha atual',
    },
    'New password': {
        en: 'New password',
        pt: 'Nova senha',
    },
    'New password confirmation': {
        en: 'New password confirmation',
        pt: 'Confirmar nova senha',
    },
    'Password confirmation': {
        en: 'Password confirmation',
        pt: 'Confirmar senha',
    },
    'Password expiration forces the user to change it on next login.': {
        en: 'Password expiration forces the user to change it on next login.',
        pt: 'A expiração de senha força o usuário a altera-lá no próximo login.',
    },
    'To expire the password, the user': {
        en: 'To expire the password, the user',
        pt: 'Para expirar a senha, o usuário',
    },
    'must know what your current password is': {
        en: 'must know what your current password is',
        pt: 'deve saber qual sua senha atual',
    },
    'If you have lost/forgotten a password, a password change must be carried out.': {
        en: 'If you have lost/forgotten a password, a password change must be carried out.',
        pt: 'Caso tenha perdido/esquecido, uma troca de senha deve ser efetuada.',
    },
    'Continue and force password change': {
        en: 'Continue and force password change',
        pt: 'Continuar e forçar troca de senha',
    },
    'Attention, your password has expired! Look for an administrator to gain access to the password change link.': {
        en: 'Attention, your password has expired! Look for an administrator to gain access to the password change link.',
        pt: 'Atenção sua senha está expirada! Procure um administrador para obter acesso ao link de troca de senha.',
    },

    'Contact your supervisor': {
        en: 'Contact your supervisor',
        pt: 'Entre em contato com seu supervisor',
    },
    'Contact your': {
        en: 'Contact your',
        pt: 'Entre em contato com seu',
    },
    'and request release': {
        en: 'and request release',
        pt: 'e solicite liberação',
    },
    Change: {
        en: 'Change',
        pt: 'Alterar',
    },
    'At least 8 characters': {
        en: 'At least 8 characters',
        pt: 'Pelo menos 8 caracteres',
    },
    'Maximum 20 characters': {
        en: 'Maximum 20 characters',
        pt: 'Máximo de 20 caracteres',
    },
    'Passwords must match': {
        en: 'Passwords must match',
        pt: 'As senhas devem corresponder',
    },
    'invalid current password': {
        en: 'Invalid current password',
        pt: 'Senha atual inválida. Verifique',
    },
    'invalid equal password': {
        en: 'Your new password must be different from your current password',
        pt: 'Sua nova senha tem que ser diferente de sua senha atual',
    },
    'Your password must contain at least one special character': {
        en: 'Your password must contain at least one special character',
        pt: 'Sua senha deve conter pelo menos um caractere especial',
    },
    'Your password expires in less than 5 days, do you want to change it now?': {
        en: 'Your password expires in less than 5 days.',
        pt: 'Sua senha expira em menos de 5 dias.',
    },
    'Change now': {
        en: 'Change now',
        pt: 'Trocar agora',
    },
    'Your password expires in': {
        en: 'Your password expires in ',
        pt: 'Sua senha expira em ',
    },
    'This conversation has not been categorized.': {
        en: 'This conversation has not been categorized. ',
        pt: 'Esta conversa não foi categorizada.',
    },
    'This conversation was automatically categorized by AI.': {
        en: 'This conversation was automatically categorized by AI.',
        pt: 'Esta conversa foi categorizada automaticamente pela IA.',
    },
    'Conversation categorized by AI': {
        en: 'Conversation categorized by AI',
        pt: 'Conversa categorizada por IA',
    },
    'Tags added': {
        en: 'Tags added',
        pt: 'Etiquetas adicionadas',
    },
    'Tags added by AI': {
        en: 'Tags added by AI',
        pt: 'Etiquetas adicionadas por IA',
    },
    'Message sent': {
        en: 'Message sent',
        pt: 'Mensagem enviada',
    },
    'REMI applied': {
        en: 'REMI applied',
        pt: 'REMI aplicado',
    },
    'Conversation priority increased': {
        en: 'Conversation priority increased',
        pt: 'Prioridade da conversa aumentada',
    },
    'Conversation summary generated': {
        en: 'Conversation summary generated',
        pt: 'Resumo da conversa gerado',
    },
    'Conversation summary': {
        en: 'Conversation summary',
        pt: 'Resumo da conversa',
    },
    'File data extracted': {
        en: 'File data extracted',
        pt: 'Dados extraídos do arquivo',
    },
    'Unable to categorize by AI': {
        en: 'Unable to categorize by AI',
        pt: 'Não foi possível categorizar por IA',
    },
    'Failed to add tags': {
        en: 'Failed to add tags',
        pt: 'Falha ao adicionar etiquetas',
    },
    'Failed to add tags by AI': {
        en: 'Failed to add tags by AI',
        pt: 'Falha ao adicionar etiquetas por IA',
    },
    'Failed to send message': {
        en: 'Failed to send message',
        pt: 'Falha ao enviar mensagem',
    },
    'Failed to apply REMI': {
        en: 'Failed to apply REMI',
        pt: 'Falha ao aplicar REMI',
    },
    'Failed to increase priority': {
        en: 'Failed to increase priority',
        pt: 'Falha ao aumentar a prioridade',
    },
    'Failed to generate summary': {
        en: 'Failed to generate summary',
        pt: 'Falha ao gerar o resumo',
    },
    'Failed to extract file data': {
        en: 'Failed to extract file data',
        pt: 'Falha ao extrair dados do arquivo',
    },
    'Failure in': {
        en: 'Failure in',
        pt: 'Falha em',
    },
    'The AI could not find an objective/outcome that fits this attendance.': {
        en: 'The AI could not find an objective/outcome that fits this attendance.',
        pt: 'A IA não encontrou um objetivo/desfecho que se encaixasse neste atendimento.',
    },
    'The workspace has no objectives/outcomes registered to categorize.': {
        en: 'The workspace has no objectives/outcomes registered to categorize.',
        pt: 'O workspace não tem objetivos/desfechos cadastrados para categorizar.',
    },
    'The action could not be executed.': {
        en: 'The action could not be executed.',
        pt: 'A ação não pôde ser executada.',
    },
    'An official (HSM) template is required to send the message.': {
        en: 'An official (HSM) template is required to send the message.',
        pt: 'É necessário um template oficial (HSM) para enviar a mensagem.',
    },
    'Template message status invalid': {
        en: 'The template is not approved for sending.',
        pt: 'O template não está aprovado para envio.',
    },
    'Go to automation': {
        en: 'Go to automation',
        pt: 'Ir para a automação',
    },
    'If you do not remember your password, contact your supervisor.': {
        en: 'If you do not remember your password, contact your supervisor.',
        pt: 'Caso não lembre sua senha contate o supervisor.',
    },
    'Change later': {
        en: 'Change later',
        pt: 'Trocar depois',
    },
    Login: {
        en: 'Login',
        pt: 'Entrar',
    },
    'Not enough permission to take action': {
        en: 'Not enough permission to take action',
        pt: 'Sem permissão suficiente para efetuar ação',
    },
    'Change password': {
        en: 'Change password',
        pt: 'Alterar senha',
    },
    Portuguese: {
        en: 'Portuguese',
        pt: 'Português',
    },
    English: {
        en: 'English',
        pt: 'Inglês',
    },
    'You are not allowed to make transfers': {
        en: 'You are not allowed to make transfers',
        pt: 'Você não tem permissão para efetuar transferências',
    },
    'Transfer conversation to another team': {
        pt: 'Transferir conversa para outro time',
        en: 'Transfer conversation to another team',
    },
    'Transfer conversation': {
        pt: 'Transferir atendimento',
        en: 'Transfer conversation',
    },
    'Full name': {
        en: 'Full name',
        pt: 'Nome completo',
    },
    'Groups access': {
        en: 'Groups access',
        pt: 'Grupos de acesso',
    },
    'Group access': {
        en: 'Group access',
        pt: 'Grupo de acesso',
    },
    'Find a group access': {
        en: 'Find a group access',
        pt: 'Encontre um grupo de acesso',
    },
    'No access groups found': {
        en: 'No access groups found',
        pt: 'Nenhum grupo de acesso encontrado',
    },
    'User list': {
        en: 'User list',
        pt: 'Lista de usuários',
    },
    'Select one or more users': {
        en: 'Select one or more users',
        pt: 'Selecione um ou mais usuários',
    },
    'Editing group access': {
        en: 'Editing group access',
        pt: 'Editando grupo de acesso',
    },
    'Creating group access': {
        en: 'Creating group access',
        pt: 'Criando grupo de acesso',
    },
    'Are you sure you want to delete the group access?': {
        en: 'Are you sure you want to delete the group access?',
        pt: 'Tem certeza de que deseja excluir o grupo de acesso?',
    },
    'Are you sure you want to delete the contact list?': {
        en: 'Are you sure you want to delete the contact list?',
        pt: 'Tem certeza de que deseja excluir a lista de contatos?',
    },
    'Group access successfully created': {
        en: 'Group access successfully created',
        pt: 'Grupo de acesso criado com sucesso',
    },
    'Group access updated successfully': {
        en: 'Group access updated successfully',
        pt: 'Grupo de acesso atualizado com sucesso',
    },
    'IP list': {
        en: 'IP list',
        pt: 'Lista de IPs',
    },
    Features: {
        en: 'Features',
        pt: 'Recursos',
    },
    sessionCreated: {
        en: 'Session start',
        pt: 'Início da sessão',
    },
    bookingCodeRequested: {
        en: 'Booking code requested',
        pt: 'Solicitação de código',
    },
    sessionInvalid: {
        en: 'Invalid session',
        pt: 'Sessão inválida',
    },
    doAppointment: {
        en: 'Appointment time',
        pt: 'Marcação de horário',
    },
    listAppointments: {
        en: 'Appointment list',
        pt: 'Listagem de horários',
    },
    'add/remove tag': {
        en: 'add/remove tag',
        pt: 'adicionar/remover etiqueta',
    },
    'Download table data in csv format to view in Excel.': {
        en: 'Download table data in csv format to view in Excel.',
        pt: 'Baixar dados da tabela em  formato csv para visualizar no Excel.',
    },
    'Download chart data in csv format to view in Excel.': {
        en: 'Download chart data in csv format to view in Excel.',
        pt: 'Baixar dados do gráfico em  formato csv para visualizar no Excel.',
    },
    'Select a period to view in the table.': {
        en: 'Select a period to view in the table.',
        pt: 'Selecione um período para visualizar na tabela.',
    },
    'Select a period to view on the chart.': {
        en: 'Select a period to view on the chart.',
        pt: 'Selecione um período para visualizar no gráfico.',
    },
    'Force password change': {
        pt: 'Forçar troca de senha',
        en: 'Force password change',
    },
    'Expired password': {
        pt: 'Senha expirada',
        en: 'Expired password',
    },
    'Password change will be requested on next login': {
        pt: 'Troca de senha será solicitada no próximo login',
        en: 'Password change will be requested on next login',
    },
    'The password will expire and the user will be forced to update the password': {
        pt: 'A senha será expirada e o usuário forçado a atualizar a senha',
        en: 'The password will expire and the user will be forced to update the password',
    },
    'Password expires in': {
        pt: 'Senha expira em',
        en: 'Password expires in',
    },
    'Link expiry time': {
        pt: 'Tempo de expiração do link',
        en: 'Link expiry time',
    },
    'Disable link after review': {
        pt: 'Desativar link após avaliação',
        en: 'Disable link after review',
    },
    'Usability Settings': {
        pt: 'Configurações de usabilidade',
        en: 'Usability Settings',
    },
    'Disable the link after the rating, the patient will not be able to change the grade after having performed an assessment':
        {
            pt: 'Desative o link após a classificação, o paciente não poderá alterar a nota após ter realizado uma avaliação',
            en: 'Disable the link after the rating, the patient will not be able to change the grade after having performed an assessment',
        },
    'Time for the link to be deactivated, and the patient can no longer rate the service': {
        pt: 'Tempo para que o link seja desativado, e o paciente não possa mais dar nota ao atendimento',
        en: 'Time for the link to be deactivated, and the patient can no longer rate the service',
    },
    at: {
        en: 't',
        pt: 'ás',
    },
    'Medical record': {
        en: 'Medical record',
        pt: 'Prontuário',
    },
    'Disabled while REMI is controlling the service.': {
        en: 'Disabled while REMI is controlling the service.',
        pt: 'Desativado enquanto o REMI estiver controlando o atendimento.',
    },
    Access: {
        en: 'Access',
        pt: 'Acessar',
    },
    Billing: {
        en: 'Billing',
        pt: 'Cobrança',
    },
    Billings: {
        en: 'Billings',
        pt: 'Cobranças',
    },
    'Billing specifications': {
        en: 'Billing specifications',
        pt: 'Especificações cobrança',
    },
    'Search the list': {
        en: 'Search the list',
        pt: 'Procurar na lista',
    },
    'Adding contact list': {
        en: 'Adding contact list',
        pt: 'Adicionando lista de contatos',
    },
    'Name of list': {
        en: 'Name of list',
        pt: 'Nome da lista',
    },
    'Number of contacts': {
        en: 'Number of contacts',
        pt: 'Quantidade de contatos',
    },
    'Send as quick replay': {
        en: 'Send as quick replay',
        pt: 'Enviar como resposta rápida',
    },
    'Send as list': {
        en: 'Send as list',
        pt: 'Enviar como lista',
    },
    'List menu button text': {
        en: 'List menu button text',
        pt: 'Texto do botão de menu da lista',
    },
    'Button Description': {
        en: 'Button Description',
        pt: 'Descrição do botão',
    },
    'Description for button in list': {
        en: 'Description for button in list',
        pt: 'Descrição para botão na lista',
    },
    'Maximum number of buttons reached (3 max)': {
        en: 'Maximum number of buttons reached (3 max)',
        pt: 'Limite máximo de botões atingido (max. 3 botões)',
    },
    'Maximum number of buttons reached (10 max)': {
        en: 'Maximum number of buttons reached (10 max)',
        pt: 'Limite máximo de botões atingido (max. 10 botões)',
    },
    'Verify the number of characters entered': {
        en: 'Verify the number of characters entered.',
        pt: 'Verifique a quantidade de caracteres inseridos',
    },
    'Customer summary': {
        en: 'Customer summary',
        pt: 'Resumo dos clientes',
    },
    'Generate customer report': {
        en: 'Generate customer report',
        pt: 'Gerar relatório dos clientes',
    },
    'Select for which month the report should be generated:': {
        en: 'Select for which month the report should be generated:',
        pt: 'Selecione para que mês deve ser gerado o relatório:',
    },
    'Do you really want to generate the billet?': {
        en: 'Do you really want to generate the billet?',
        pt: 'Deseja realmente gerar o boleto?',
    },
    'Linked workspaces': {
        en: 'Linked workspaces',
        pt: 'Workspaces vinculados',
    },
    'Ibge city code': {
        en: 'Ibge city code',
        pt: 'Código do ibge da cidade',
    },
    City: {
        en: 'City',
        pt: 'Cidade',
    },
    District: {
        en: 'District',
        pt: 'Bairro',
    },
    State: {
        en: 'State',
        pt: 'Estado',
    },
    'Country code': {
        en: 'Country code',
        pt: 'Código do pais',
    },
    Complement: {
        en: 'Complement',
        pt: 'Complemento',
    },
    Address: {
        en: 'Address',
        pt: 'Endereço',
    },
    'Postal code': {
        en: 'Postal code',
        pt: 'CEP',
    },
    'Fantasy name': {
        en: 'Fantasy name',
        pt: 'Nome fantasia',
    },
    'Corporate name': {
        en: 'Corporate name',
        pt: 'Razão social',
    },
    'Account successfully created': {
        en: 'Account successfully created',
        pt: 'Conta criada com sucesso',
    },
    'Account successfully updated': {
        en: 'Account successfully updated',
        pt: 'Conta atualizada com sucesso',
    },
    'Setup successfully created': {
        en: 'Setup successfully created',
        pt: 'Setup criado com sucesso',
    },
    'Workspace name cannot be empty.': {
        en: 'Workspace name cannot be empty.',
        pt: 'O nome do workspace não pode ser vazio.',
    },
    'Workspace name': {
        en: 'Workspace name',
        pt: 'Nome do workspace',
    },
    'Create setup': {
        pt: 'Criar setup',
        en: 'Create setup',
    },
    'Setup creation': {
        pt: 'Criação de setup',
        en: 'Setup creation',
    },
    Customers: {
        en: 'Customers',
        pt: 'Clientes',
    },
    Customer: {
        en: 'Customer',
        pt: 'Cliente',
    },
    'New customer': {
        en: 'New customer',
        pt: 'Novo cliente',
    },
    'Generate billet': {
        en: 'Generate billet',
        pt: 'Gerar boleto',
    },
    'Generate next charge': {
        en: 'Generate next charge',
        pt: 'Gerar próxima cobrança',
    },
    'Generate next charge for all': {
        en: 'Generate next charge for all',
        pt: 'Gerar próxima cobrança para todos',
    },
    'Generate billet for everyone': {
        en: 'Generate billet for everyone',
        pt: 'Gerar boleto para todos',
    },
    'Select for which month the slips should be generated:': {
        en: 'Select for which month the slips should be generated:',
        pt: 'Selecione para que mês devem ser gerados os boletos:',
    },
    'Select which month the charges should be generated:': {
        en: 'Select which month the charges should be generated:',
        pt: 'Selecione para que mês devem ser geradas as cobranças:',
    },
    'Select in which month the notes should be synced:': {
        en: 'Select in which month the notes should be synced:',
        pt: 'Selecione em qual mês deve ser sincronizadas as notas:',
    },
    'Select for which month the notes should be generated:': {
        en: 'Select for which month the notes should be generated:',
        pt: 'Selecione para que mês devem ser geradas as notas:',
    },
    'Sync notes': {
        en: 'Sync notes',
        pt: 'Sincronizar notas',
    },
    'Generate grade': {
        en: 'Generate grade',
        pt: 'Gerar nota',
    },
    'Generate grade for everyone': {
        en: 'Generate grade for everyone',
        pt: 'Gerar nota para todos',
    },
    'There is no grade to generate for the selected month!': {
        en: 'There is no grade to generate for the selected month!',
        pt: 'Não há nenhuma nota a ser gerada para o mês selecionado!',
    },
    paymentDescription: {
        en: 'Billing description',
        pt: 'Descrição da cobrança',
    },
    invoiceDescription: {
        en: 'Note Description',
        pt: 'Descrição da nota',
    },
    'invoiceDescription-msg': {
        en: `Field that describes the service provided. \n'{{MES}}' attribute can be used, to assist in the construction of the message. \nEx: 'Note regarding services provided in the month: {{MES}}'.`,
        pt: `Campo que descreve o serviço prestado. \nPoderá ser usado atributo '{{MES}}', para auxiliar na construção da mensagem. \nEx: 'Nota referente aos serviços prestados no mês: {{MES}}. Quantidade de atendimentos: {{QTD_ATENDIMENTOS}}.'.`,
    },
    'paymentDescription-msg': {
        en: `Field that describes the service provided. \n'{{MES}}' attribute can be used, to assist in the construction of the message. \nEx: 'Bill for services provided in the month: {{MES}}'.`,
        pt: `Campo que descreve o serviço prestado. \nPoderá ser usado atributo '{{MES}}', para auxiliar na construção da mensagem. \nEx: 'Cobrança referente ao serviços prestados no mês: {{MES}}'.`,
    },
    'Contains overdue invoices': {
        en: 'Contains overdue invoices',
        pt: 'Contém faturas vencidas',
    },
    'Last payment': {
        en: 'Last payment',
        pt: 'Último pagamento',
    },
    'Last charge': {
        en: 'Last charge',
        pt: 'Última cobrança',
    },
    Period: {
        en: 'Period',
        pt: 'Período',
    },
    'Payment summary': {
        en: 'Payment summary',
        pt: 'Resumo das faturas',
    },
    Quantity: {
        en: 'Quantity',
        pt: 'Quantidade',
    },
    AwaitingPayment: {
        en: 'Awaiting payment',
        pt: 'Aguardando pagamento',
    },
    OverDue: {
        en: 'Overdue',
        pt: 'Atrasado',
    },
    ExternalReportGenerated: {
        en: 'External report generated',
        pt: 'Relatório externo gerado',
    },
    ExternalImported: {
        en: 'Imported (external)',
        pt: 'Importado (externo)',
    },
    'Generate external report for everyone': {
        en: 'Generate external report for everyone',
        pt: 'Gerar relatório externo para todos',
    },
    'Select for which month the external report should be generated:': {
        en: 'Select for which month the external report should be generated:',
        pt: 'Selecione para qual mês o relatório externo deve ser gerado:',
    },
    'Dar baixa': {
        en: 'Mark as paid',
        pt: 'Dar baixa',
    },
    'Confirma a baixa manual deste pagamento?': {
        en: 'Confirm manual payment confirmation for this invoice?',
        pt: 'Confirma a baixa manual deste pagamento?',
    },
    'Successfully synced': {
        en: 'Successfully synced',
        pt: 'Sincronizado com sucesso',
    },
    'activeMessage-channelConfigToken': {
        en: 'Whatsapp number will be used to send the message.',
        pt: 'Número do whatsapp que será usado para enviar a mensagem.',
    },
    'activeMessage-settingName': {
        en: 'Name that will be shown in the active message settings list.',
        pt: 'Nome que será mostrado na lista de configurações da mensagem ativa.',
    },
    'activeMessage-callbackUrl': {
        en: 'Return url for message events. Call when:\n - Number sent is invalid.\n - "Send message to open conversation" setting is disable,\nand there is already a conversation for the number.',
        pt: 'Url de retorno para eventos da mensagem. Chamada quando:\n - Numero enviado é inválido.\n - Configuração "Enviar mensagem para conversa aberta" estiver desativado,\ne já existir uma conversa para o número.',
    },
    'activeMessage-suspended': {
        en: `The number's conversation will be suspended for the specified time.\nWhen overflowing it will be necessary to filter by suspended conversations to view it.`,
        pt: 'A conversa do número ficará como suspensa pelo tempo determinado.\nNo transbordo será necessário filtrar por conversas suspensas para visualizá-la.',
    },
    'activeMessage-objective': {
        en: `What is the purpose of this active message, where will it be used.`,
        pt: 'Qual o objetivo desta mensagem ativa, onde será utilizada.',
    },
    'activeMessage-expiration': {
        en: 'The conversation will expire at the given time.',
        pt: 'A conversa irá expirar no tempo determinado.',
    },
    'activeMessage-active': {
        en: 'When this option is disabled, the api will not receive the requests.',
        pt: 'Quando desabilitada essa opção, a api não irá receber as solicitações.',
    },
    'activeMessage-sendMessageToOpenConversation': {
        en: 'If this option is disable the api will ignore messages whose number already has an open conversation.\nIn this case the callbackUrl will be called.',
        pt: 'Se desabilitada essa opção a api irá ignorar mensagens cujo número já tenha uma conversa aberta.\nNesse caso o callbackUrl será chamado.',
    },
    'activeMessage-tags': {
        en: 'Tags that will be added to the service created through this active message.',
        pt: 'Etiquetas que serão adicionadas ao atendimento criado através desta mensagem ativa.',
    },
    'activeMessage-templateId': {
        en: 'Template that will be sent when using this active message setting.',
        pt: 'Template que sera enviado quando utilizar essa configuração de mensagem ativa.',
    },
    'activeMessage-action': {
        en: 'Custom flow that will be applied when starting a service',
        pt: 'Fluxo personalizado que será aplicado quando iniciar um atendimento',
    },
    'activeMessage-authorizationHeader': {
        en: 'Authorization configuration of callbackUrl request header',
        pt: 'Configuração authorization do header da requisição de callbackUrl',
    },
    'Add chart': {
        en: 'Add chart',
        pt: 'Adicionar gráfico',
    },
    'Add filter': {
        en: 'Add filter',
        pt: 'Adicionar filtro',
    },
    Field: {
        en: 'Field',
        pt: 'Campo',
    },
    And: {
        en: 'And',
        pt: 'E',
    },
    Condition: {
        en: 'Condition',
        pt: 'Condição',
    },
    'Group by': {
        en: 'Group by',
        pt: 'Agrupar por',
    },
    Dimension: {
        en: 'Dimension',
        pt: 'Dimensão',
    },
    Table: {
        en: 'Table',
        pt: 'Tabela',
    },
    Line: {
        en: 'Line',
        pt: 'Linha',
    },
    Columns: {
        en: 'Columns',
        pt: 'Colunas',
    },
    At: {
        en: 'At',
        pt: 'Às',
    },
    'Hour range': {
        en: 'Hour range',
        pt: 'Intervalo de horas',
    },
    'Type of chart': {
        en: 'Type of chart',
        pt: 'Tipo de gráfico',
    },
    Graphic: {
        en: 'Graphic',
        pt: 'Gráfico',
    },
    'Edit chart': {
        en: 'Edit chart',
        pt: 'Editar gráfico',
    },
    'Clone chart': {
        en: 'Clone chart',
        pt: 'Clonar gráfico',
    },
    'Copy to...': {
        en: 'Copy to...',
        pt: 'Copiar para...',
    },
    'Move to...': {
        en: 'Move to...',
        pt: 'Mover para...',
    },
    'Select dashboard': {
        en: 'Select dashboard',
        pt: 'Selecione o dashboard',
    },
    'Delete chart': {
        en: 'Delete chart',
        pt: 'Excluir gráfico',
    },
    'No dashboards available': {
        en: 'No dashboards available',
        pt: 'Nenhum dashboard disponível',
    },
    'Chart copied successfully to {dashboard}': {
        en: 'Chart copied successfully to {dashboard}',
        pt: 'Gráfico copiado com sucesso para {dashboard}',
    },
    'Chart moved successfully to {dashboard}': {
        en: 'Chart moved successfully to {dashboard}',
        pt: 'Gráfico movido com sucesso para {dashboard}',
    },
    'Unfinished services': {
        en: 'Unfinished services',
        pt: 'Atendimentos não finalizados',
    },
    'Service without assigned team': {
        en: 'Service without assigned team',
        pt: 'Atendimentos sem time atribuído',
    },
    'Services without linked advertising': {
        en: 'Services without linked advertising',
        pt: 'Atendimentos sem publicidade vinculada',
    },
    'Appointments without a purpose': {
        en: 'Appointments without a purpose',
        pt: 'Atendimentos sem objetivos',
    },
    'Appointments without an outcome': {
        en: 'Appointments without an outcome',
        pt: 'Atendimentos sem desfecho',
    },
    'This JSON will be merged with the current integration rules configuration': {
        en: 'This JSON will be merged with the current integration rules configuration',
        pt: 'Este JSON será mesclado com a configuração atual de regras da integração',
    },
    'Enter JSON configuration here...': {
        en: 'Enter JSON configuration here...',
        pt: 'Insira a configuração JSON aqui...',
    },
    'Error processing the JSON. Please review your JSON and try again': {
        en: 'Error processing the JSON. Please review your JSON and try again',
        pt: 'Error ao processar o JSON. Por favor revise o seu JSON e tente novamente',
    },
    'Total attendances': {
        en: 'Total attendances',
        pt: 'Total de atendimentos',
    },
    'Evaluation average': {
        en: 'Evaluation average',
        pt: 'Média da avaliação',
    },
    'Create Dashboard': {
        en: 'Create Dashboard',
        pt: 'Criar Dashboard',
    },
    Visibility: {
        en: 'Visibility',
        pt: 'Visibilidade',
    },
    Public: {
        en: 'Public',
        pt: 'Público',
    },
    Private: {
        en: 'Private',
        pt: 'Privado',
    },
    Include: {
        en: 'Include',
        pt: 'Incluir',
    },
    'It will show service data according to the selected category': {
        en: 'It will show service data according to the selected category',
        pt: 'Mostrará dados de atendimento de acordo com a categoria selecionada',
    },
    'Type of data about calls that appears in the graph': {
        en: 'Type of data about calls that appears in the graph',
        pt: 'Tipo de dado sobre atendimentos que aparece no gráfico',
    },
    'By which field the filter will be applied': {
        en: 'By which field the filter will be applied',
        pt: 'Por qual campo o filtro será aplicado',
    },
    'Which values ​​will be filtered according to the selected field': {
        en: 'Which values ​​will be filtered according to the selected field',
        pt: 'Quais valores estarão sendo filtrados de acordo com o campo selecionado',
    },
    'Everyone can see your Dashboard': {
        en: 'Everyone can see your Dashboard',
        pt: 'Todos podem ver seu Dashboard',
    },
    'Only you can see your Dashboard': {
        en: 'Only you can see your Dashboard',
        pt: 'Apenas você pode ver seu Dashboard',
    },
    'Allow changes by other users.': {
        en: 'Allow changes by other users.',
        pt: 'Permitir que outros usuários façam alterações.',
    },
    'Created by:': {
        en: 'Created by:',
        pt: 'Criado por:',
    },
    Created: {
        en: 'Created',
        pt: 'Criado',
    },
    Updated: {
        en: 'Updated',
        pt: 'Atualizado',
    },
    'Audit metadata by': {
        en: 'by',
        pt: 'por',
    },
    'Audit metadata on': {
        en: 'on',
        pt: 'em',
    },
    Activated: {
        en: 'Activated',
        pt: 'Ativado',
    },
    by: {
        en: 'by',
        pt: 'por',
    },
    on: {
        en: 'on',
        pt: 'em',
    },
    'Are you sure you want to delete the Dashboard?': {
        en: 'Are you sure you want to delete the Dashboard?',
        pt: 'Tem certeza de que deseja excluir o Dashboard?',
    },
    'Are you sure you want to delete the chart?': {
        en: 'Are you sure you want to delete the chart?',
        pt: 'Tem certeza de que deseja excluir o gráfico?',
    },
    'Allow push active commit for this entity': {
        en: 'Allow push active commit for this entity',
        pt: 'Permitir envio de confirmação ativa para esta entidade',
    },
    'Address that will be presented to the patient when confirming the selected time': {
        en: 'Address that will be presented to the patient when confirming the selected time',
        pt: 'Endereço que será apresentado ao paciente na confirmação de horário selecionado',
    },
    'Value that will be presented to the patient when confirming the selected time': {
        en: 'Value that will be presented to the patient when confirming the selected time',
        pt: 'Valor que será apresentado ao paciente na confirmação de horário selecionado',
    },
    'Number of days that will be sought to present schedules to the patient': {
        en: 'Number of days that will be sought to present schedules to the patient',
        pt: 'Quantidade de dias que serão buscados para apresentação de horários ao paciente',
    },
    'Allow the patient to confirm their appointment through the bot': {
        en: 'Allow the patient to confirm their appointment through the bot',
        pt: 'Permitir que  o paciente confirme seu agendamento através do bot',
    },
    'You still not': {
        en: 'You still not',
        pt: 'Você ainda não',
    },
    'has no dashboard': {
        en: 'has no dashboard',
        pt: 'possui nenhum dashboard',
    },
    'My reports': {
        en: 'My reports',
        pt: 'Meus relatórios',
    },
    'Contracted quantity:': {
        en: 'Contracted quantity:',
        pt: 'Quantidade contratada:',
    },
    'Active users:': {
        en: 'Active users:',
        pt: 'Usuários ativos:',
    },
    'General Settings': {
        en: 'General settings',
        pt: 'Configurações gerais',
    },
    'Help center': {
        en: 'Help center',
        pt: 'Central de ajuda',
    },
    Campaigns: {
        en: 'Campaigns',
        pt: 'Campanhas',
    },
    Campaign: {
        en: 'Campaign',
        pt: 'Campanha',
    },
    'Enable confirmation resend': {
        en: 'Enable confirmation resend',
        pt: 'Habilitar reenvio de confirmação',
    },
    'Enable resending of the message for those who did not respond': {
        en: 'Enable resending of the message for those who did not respond',
        pt: 'Habilitar reenvio da mensagem para quem não respondeu',
    },
    'Omit appointment type in description': {
        en: 'Omit appointment type in description',
        pt: 'Omitir tipo de agendamento na descrição',
    },
    'Omit doctor name in description': {
        en: 'Omit doctor name in description',
        pt: 'Omitir nome do médico na descrição',
    },
    'Omit extraction orientation': {
        en: 'Omit extraction orientation',
        pt: 'Omitir orientação da extração',
    },
    'Send on Friday, weekend and Monday': {
        en: 'Send on Friday, weekend and Monday',
        pt: 'Enviar na sexta feira envios de final de semana e segunda',
    },
    'Check if there have been changes to the schedule when resending a message': {
        en: 'Check if there have been changes to the schedule when resending a message',
        pt: 'Checar se houve alterações no agendamento ao reenviar mensagem',
    },
    'Activating this option will make the system handle times in order of arrival.': {
        en: 'Activating this option will make the system handle times in order of arrival.',
        pt: 'Ativar essa opção fará com que o sistema trate os horários por ordem de chegada.',
    },
    'Omit time in group description': {
        en: 'Omit time in group description',
        pt: 'Omitir horário na descrição do grupo',
    },
    'Contact list limit': {
        en: 'Contact list limit',
        pt: 'Limite da lista de contatos',
    },
    'It is used to set the active message sending limit per day': {
        en: 'It is used to set the active message sending limit per day',
        pt: 'É usado para definir o limite de envio de mensagem ativa por dia',
    },
    'Personalization Settings': {
        en: 'Personalization Settings',
        pt: 'Configurações de personalização',
    },
    'Use organization name in group description': {
        en: 'Use organization name in group description',
        pt: 'Utilizar nome da organização na descrição do grupo',
    },
    Draft: {
        en: 'Draft',
        pt: 'Rascunho',
    },
    Sent: {
        en: 'Sent',
        pt: 'Enviados',
    },
    of: {
        en: 'of',
        pt: 'de',
    },
    contacts: {
        en: 'contacts',
        pt: 'contatos',
    },
    Pause: {
        en: 'Pause',
        pt: 'Pausar',
    },
    'Broadcast list': {
        en: 'Broadcast list',
        pt: 'Lista de transmissão',
    },
    'Sending permissions': {
        en: 'Sending permissions',
        pt: 'Permissões de envio',
    },
    'Email templates': {
        en: 'Email templates',
        pt: 'Templates de e-mail',
    },
    'Download CSV': {
        en: 'Download CSV',
        pt: 'Baixar arquivo CSV',
    },
    'Standard chart': {
        en: 'Standard chart',
        pt: 'Gráfico padrão',
    },
    'Shipping time': {
        en: 'Shipping time',
        pt: 'Horário de envio',
    },
    'Synonyms - Tip: you can paste multiple synonyms separated by ;': {
        en: 'Synonyms - Tip: you can paste multiple synonyms separated by ;',
        pt: 'Sinônimos - Dica: você pode colar vários sinônimos separados por ;',
    },
    'Sent with success': {
        en: 'Sent with success',
        pt: 'Enviado com sucesso',
    },
    Exist: {
        en: 'Exist',
        pt: 'Existem',
    },
    'incomplete recipients': {
        en: 'incomplete recipients',
        pt: 'destinatários incompletos',
    },
    'Shipping settings': {
        en: 'Shipping settings',
        pt: 'Configurações de envio',
    },
    'Delete selected recipients': {
        en: 'Delete selected recipients',
        pt: 'Excluir destinatários selecionados',
    },
    'Execute from of': {
        en: 'Execute from of',
        pt: 'Executar a partir de',
    },
    'Execute until': {
        en: 'Execute until',
        pt: 'Executar até',
    },
    'Execute from this time': {
        en: 'Execute from this time',
        pt: 'Executar a partir deste horário',
    },
    'Execute until time': {
        en: 'Execute until time',
        pt: 'Executar até este horário',
    },
    'Limit of days to list doctors with available appointments': {
        en: 'Limit of days to list doctors with available appointments',
        pt: 'Limite de dias para listar médicos com horários disponíveis',
    },
    'Divide timetable search into periods of X days': {
        en: 'Divide timetable search into periods of X day',
        pt: 'Dividir busca de horários em períodos de X dias',
    },
    'How long in minutes to display first available time': {
        en: 'How long in minutes to display first available time',
        pt: 'Quanto tempo em minutos para exibir primeiro horário disponível',
    },
    'Force time listing for all active units': {
        en: 'Force time listing for all active units',
        pt: 'Forçar listagem de horário de todas unidades ativas',
    },
    'In the list of doctors, display an option at the end to change doctors': {
        en: 'In the list of doctors, display an option at the end to change doctors',
        pt: 'Na listagem de médicos, exibir no final uma opção para trocar de médico',
    },
    'Show option to search for future times in the timetable list': {
        en: 'Show option to search for future times in the timetable list',
        pt: 'Mostrar opção de buscar horários futuros, na listagem de horários',
    },
    conversationId: {
        en: 'Conversation Id',
        pt: 'ID da conversa',
    },
    channelId: {
        en: 'Channel',
        pt: 'Canal',
    },
    timestamp: {
        en: 'Timestamp',
        pt: 'Data/Hora',
    },
    conversationUrl: {
        en: 'Conversation Url',
        pt: 'Link da conversa',
    },
    specialityName: {
        en: 'Speciality',
        pt: 'Especialidade',
    },
    procedureName: {
        en: 'Procedure',
        pt: 'Procedimento',
    },
    appointmentTypeName: {
        en: 'Appointment type',
        pt: 'Tipo de agendamento',
    },
    insuranceName: {
        en: 'Insurance',
        pt: 'Convênio',
    },
    insurancePlanName: {
        en: 'Insurance plan',
        pt: 'Plano do convênio',
    },
    doctorName: {
        en: "Professional's name",
        pt: 'Nome do profissional',
    },
    insuranceCategoryName: {
        en: 'Insurance category',
        pt: 'Categoria do convênio',
    },
    insuranceSubPlanName: {
        en: 'Insurance sub plan',
        pt: 'Sub plano do convênio',
    },
    organizationUnitName: {
        en: 'Organization unit',
        pt: 'Nome da unidade',
    },
    patientCode: {
        en: 'Patient code within the ERP',
        pt: 'Código do paciente dentro do ERP',
    },
    lastPatientAppointmentDate: {
        en: 'Last patient appointment date',
        pt: 'Data da última consulta do paciente',
    },
    nextPatientAppointmentDate: {
        en: 'Next patient appointment date',
        pt: 'Próxima data de consulta do paciente',
    },
    avaliableDateCount: {
        en: 'Avaliable date count',
        pt: 'Número de datas disponíveis',
    },
    occupationAreaName: {
        en: 'Occupation area name',
        pt: 'Nome da área de atuação',
    },
    firstAvaliableDate: {
        en: 'First avaliable date',
        pt: 'Primeira data disponível',
    },
    firstAvaliableDateDistance: {
        en: 'First avaliable date distance',
        pt: 'Tempo para primeira data disponível',
    },
    periodOfDay: {
        en: 'Period od day',
        pt: 'Período do dia',
    },
    appointmentConfirmed: {
        en: 'scheduling attempts',
        pt: 'Tentativa de agendamento',
    },
    appointmentCode: {
        en: 'Appointment code',
        pt: 'Código do agendamento',
    },
    appointmentDate: {
        en: 'Appointment date',
        pt: 'Data do agendamento',
    },
    step: {
        en: 'Scheduling stage',
        pt: 'Etapa do agendamento',
    },
    appointmentStatus: {
        en: 'Appointment status',
        pt: 'Status do agendamento',
    },
    patientAge: {
        en: 'Patient age',
        pt: 'Idade do paciente',
    },
    price: {
        en: 'Procedure price',
        pt: 'Preço do procedimento',
    },
    organizationUnitLocationName: {
        en: 'Unit location code',
        pt: 'Código de localização da unidade',
    },
    typeOfServiceCode: {
        en: 'Service type code',
        pt: 'Código do tipo de serviço',
    },
    typeOfServiceName: {
        en: 'Service type',
        pt: 'Tipo de serviço',
    },
    confirmActive: {
        en: 'Active confirmation',
        pt: 'Confirmação ativa',
    },
    reasonCode: {
        en: 'Reason code',
        pt: 'Código do motivo de não agendamento',
    },
    reasonName: {
        en: 'Reason name',
        pt: 'Nome do motivo de não agendamento',
    },
    reasonText: {
        en: 'Description of the reason for not scheduling',
        pt: 'Descrição do motivo de não agendamento',
    },
    retryAvaliableDateCount: {
        en: 'Retry available date count',
        pt: 'Número de tentativas para datas disponíveis',
    },
    retryFirstAvaliableDate: {
        en: 'Retry first available date',
        pt: 'Primeira data disponível do tentar novamente',
    },
    retryFirstAvaliableDateDistance: {
        en: 'Retry first available date distance',
        pt: 'Tempo para primeira data disponível no tentar novamente',
    },
    retryCount: {
        en: 'Retry count',
        pt: 'Número de tentativas do tentar novamente',
    },
    removed: {
        en: 'removed',
        pt: 'removeu',
    },
    'of conversation': {
        en: 'of conversation',
        pt: 'do atendimento',
    },
    Remove: {
        pt: 'Remover',
        en: 'Remove',
    },
    agent: {
        pt: 'agente',
        en: 'agent',
    },
    'this conversation': {
        pt: 'deste atendimento',
        en: 'this conversation',
    },
    'Remove agent from conversation?': {
        pt: 'Remover agente do atendimento?',
        en: 'Remove agent from conversation?',
    },
    'Without rating': {
        pt: 'Sem avaliação',
        en: 'Without rating',
    },
    Trigger: {
        pt: 'Gatilho',
        en: 'Trigger',
    },
    Triggers: {
        pt: 'Gatilhos',
        en: 'Triggers',
    },
    'The action will trigger another trigger interaction': {
        pt: ' A ação acionará outra interação por gatilhos',
        en: 'The action will trigger another trigger interaction',
    },
    'Enter a trigger': {
        pt: ' Digite um gatilho',
        en: 'Enter a trigger',
    },
    'Enter a action': {
        pt: ' Digite um ação',
        en: 'Enter a action',
    },
    before_end_conversation: {
        pt: 'Antes de finalizar a conversa',
        en: 'Before end conversation',
    },
    active_confirmation_confirm: {
        pt: 'Confirmação ativa - Confirmou',
        en: 'Confirmação ativa - Confirmou',
    },
    active_confirmation_cancel: {
        pt: 'Confirmação ativa - Cancelou',
        en: 'Confirmação ativa - Cancelou',
    },
    'Period cloned successfully!': {
        pt: 'Período clonado com sucesso!',
        en: 'Period cloned successfully!',
    },
    'Flow executed until': {
        en: 'Flow executed until',
        pt: 'Fluxo executou até',
    },
    'Flow executing until': {
        en: 'Flow executing until',
        pt: 'Fluxo executando até',
    },
    'with execution time of': {
        en: 'with execution time of',
        pt: 'com horário de execução das',
    },
    to: {
        en: 'to',
        pt: 'às',
    },
    'Flow with execution time of': {
        en: 'Flow with execution time of',
        pt: 'Fluxo com horário de execução das',
    },
    'Post disabled by:': {
        pt: 'Publicação desativada por:',
        en: 'Post disabled by:',
    },
    'deactivated publishing this Bot on': {
        pt: 'desativou a publicação deste Bot em',
        en: 'deactivated publishing this Bot on',
    },
    'Disables publishing for everyone except those who turned it off': {
        pt: 'Desabilita o publicar para todos, menos para quem o desativou',
        en: 'Disables publishing for everyone except those who turned it off:',
    },
    'Disable publish': {
        pt: 'Desabilitar publicação',
        en: 'Disable publish',
    },
    'List of automatic send configurations': {
        pt: 'Lista de configurações de envio automático',
        en: 'List of automatic send configurations',
    },
    'Enable Publication': {
        pt: 'Habilitar Publicação',
        en: 'Enable Publication',
    },
    'Publishing disabled': {
        pt: 'Publicação desabilitada',
        en: 'Publishing disabled',
    },
    'This number may not have a WhatsApp account. Please check that the number is correct or see our article for more details on sending errors.':
        {
            pt: 'Este número pode não possuir uma conta no WhatsApp. Verifique se o número está correto ou consulte nosso artigo para mais detalhes sobre erros de envio.',
            en: 'This number may not have a WhatsApp account. Please check that the number is correct or see our article for more details on sending errors.',
        },
    'Message not delivered by WhatsApp.': {
        pt: 'Mensagem não entregue pelo WhatsApp.',
        en: 'Message not delivered by WhatsApp.',
    },
    '⚠️ Error generated by WhatsApp.': {
        pt: '⚠️ Erro gerado pelo WhatsApp.',
        en: '⚠️ Error generated by WhatsApp.',
    },
    'Check if the number is valid. If the patient number is correct and active, WhatsApp is blocking the company from sending messages at this moment. This can happen when:':
        {
            pt: 'Verifique se o número é válido. Caso o número do paciente esteja correto e ativo, o WhatsApp está impedindo envio de mensagens da empresa neste momento. Isso pode acontecer quando:',
            en: 'Check if the number is valid. If the patient number is correct and active, WhatsApp is blocking the company from sending messages at this moment. This can happen when:',
        },
    "the patient's app is outdated;": {
        pt: 'o aplicativo do paciente está desatualizado;',
        en: "the patient's app is outdated;",
    },
    'the recent WhatsApp terms have not yet been accepted;': {
        pt: 'os termos recentes do WhatsApp ainda não foram aceitos;',
        en: 'the recent WhatsApp terms have not yet been accepted;',
    },
    'there are message restrictions configured in the patient app (even if the patient can send messages, sending company templates may be blocked)':
        {
            pt: 'existem restrições de recebimento de mensagens configuradas no aplicativo do paciente (mesmo que o paciente consiga enviar mensagens, o envio de templates da empresa pode ser bloqueado)',
            en: 'there are message restrictions configured in the patient app (even if the patient can send messages, sending company templates may be blocked)',
        },
    'Guide the patient to update WhatsApp and send a new message to release the service.': {
        pt: 'Oriente o paciente a atualizar o WhatsApp e enviar uma nova mensagem para liberar o atendimento.',
        en: 'Guide the patient to update WhatsApp and send a new message to release the service.',
    },
    'Are you sure you want to delete the selected entities?': {
        pt: 'Tem certeza que deseja excluir as entidades selecionadas?',
        en: 'Are you sure you want to delete the selected entities?',
    },
    'Change workspace': {
        pt: 'Alterar workspace',
        en: 'Change workspace',
    },
    'To schedule': {
        pt: 'Agendar',
        en: 'To schedule',
    },
    Reschedule: {
        pt: 'Reagendar',
        en: 'reschedule',
    },
    'Confirm active': {
        pt: 'Confirmar ativo',
        en: 'Confirm active',
    },
    'Confirm liability': {
        pt: 'Confirmar passivo',
        en: 'confirm liability',
    },
    'To view': {
        pt: 'Visualizar',
        en: 'To view',
    },
    'Click here for more details': {
        pt: 'Clique aqui para mais detalhes',
        en: 'Click here for more details',
    },
    'Cannot do action': {
        pt: 'Não pode realizar a ação',
        en: 'Cannot do action',
    },
    'How long before can confirmation be made (Hours)': {
        pt: 'Quanto tempo antes poderá ser feita confirmação (Horas)',
        en: 'How long before can confirmation be made (Hours)',
    },
    'Time that the first schedule listing will be cached (Minutes)': {
        pt: 'Tempo que o primeiro horário da listagem de horários ficará em cache (Minutos)',
        en: 'Time that the first schedule listing will be cached (Minutes)',
    },
    'Show times after (Days)': {
        pt: 'Mostrar horários após (Dias)',
        en: 'Show times after (Days)',
    },
    'Channel service limit': {
        pt: 'Limite de atendimentos do canal',
        en: 'Channel service limit',
    },
    'Channel message limit': {
        pt: 'Limite de mensagens do canal',
        en: 'Channel message limit',
    },
    'Billing type': {
        pt: 'Tipo de cobrança',
        en: 'Billing type',
    },
    'View only chat history for this team': {
        pt: 'Visualizar apenas histórico de conversas deste time',
        en: 'View only chat history for this team',
    },
    'View team attendance history': {
        pt: 'Ver histórico de atendimentos do time',
        en: 'View team attendance history',
    },
    Pending: {
        pt: 'Pendente',
        en: 'Pending',
    },
    Received: {
        pt: 'Recebido',
        en: 'Received',
    },
    Read: {
        pt: 'Lido',
        en: 'Read',
    },
    Played: {
        pt: 'Reproduzido',
        en: 'Played',
    },
    'The number does not exist on WhatsApp': {
        pt: 'O número não existe no WhatsApp',
        en: 'The number does not exist on WhatsApp',
    },
    'invalid template': {
        pt: 'Template invalido',
        en: 'invalid template',
    },
    'Template message was declined by number': {
        pt: 'Mensagem de template foi recusada pelo número',
        en: 'Template message was declined by number',
    },
    'Invalid media url': {
        pt: 'URL de mídia inválido',
        en: 'Invalid media url',
    },
    'You must fill in the message field with at least 10 characters, along with the file!': {
        pt: 'Necessário o preenchimento do campo mensagem com no mínimo 10 caracteres, junto com o arquivo!',
        en: 'You must fill in the message field with at least 10 characters, along with the file!',
    },
    'Invalid media size': {
        pt: 'Tamanho de mídia inválido',
        en: 'Invalid media size',
    },
    'Limit of days for listing appointments': {
        pt: 'Limite de dias para listar agendamentos',
        en: 'Limit of days for listing appointments',
    },
    'Limit of days to list appointments when you have a doctor selected': {
        pt: 'Limite de dias para listar agendamentos quando tiver médico selecionado',
        en: 'Limit of days to list your appointment when you have a doctor selected',
    },
    'Template is disabled': {
        pt: 'Template está desativado',
        en: 'Template is disabled',
    },
    'Could not send message': {
        pt: 'Não foi possível enviar a mensagem',
        en: 'Could not send message',
    },
    'Skin color': {
        pt: 'Cor de pele',
        en: 'Skin color',
    },
    'Custom flow': {
        pt: 'Fluxo personalizado',
        en: 'Custom flow',
    },
    'Select a flow if you want the bot to continue the conversation when the recipient replies to the message. To create a custom conversation flow, contact support.':
        {
            pt: 'Selecione um fluxo caso deseje que o bot de continuidade na conversa quando o destinatário responder a mensagem. Para criar um fluxo personalizado de conversa entre em contato com o suporte.',
            en: 'Select a flow if you want the bot to continue the conversation when the recipient replies to the message. To create a custom conversation flow, contact support.',
        },
    'Add new list': {
        pt: 'Adicionar nova lista',
        en: 'Add new list',
    },
    'Add Users': {
        pt: 'Adicionar usuários',
        en: 'Add Users',
    },
    'Search teams': {
        pt: 'Buscar times',
        en: 'Search teams',
    },
    'Team not found.': {
        pt: 'Time não encontrado.',
        en: 'Team not found.',
    },
    'There is data pending publication in the flow or entities': {
        pt: 'Existem dados pendentes de publicação no flow ou entidades',
        en: 'There is data pending publication in the flow or entities',
    },
    'Email (Optional)': {
        pt: 'Email (Opcional)',
        en: 'Email (Optional)',
    },
    'The email must be a valid email.': {
        pt: 'O e-mail deve ser um e-mail válido.',
        en: 'The email must be a valid email.',
    },
    DDI: {
        pt: 'DDI',
        en: 'DDI',
    },
    'No results found': {
        pt: 'Nenhum resultado encontrado',
        en: 'No results found',
    },
    'It is used to reassign a conversation': {
        pt: 'É usado para reatribuir uma conversa',
        en: 'It is used to reassign a conversation',
    },
    'When used, transfers the ongoing conversation to the last team it was assigned to': {
        pt: 'Quando usado, transfere a conversa em andamento para o último time à qual foi atribuída',
        en: 'When used, transfers the ongoing conversation to the last team it was assigned to',
    },
    'Name is required': {
        pt: 'O nome é obrigatório',
        en: 'Name is required',
    },
    'Character max length is 255': {
        pt: 'O comprimento máximo do caractere é 255',
        en: 'Character max length is 255',
    },
    'Character min length is 3': {
        pt: 'O comprimento mínimo do caractere é 3',
        en: 'Character min length is 3',
    },
    'Team is required': {
        pt: 'Um time é necessário',
        en: 'Team is required',
    },
    'Channel is required': {
        pt: 'O canal é obrigatório',
        en: 'Channel is required',
    },
    'Error: One of the numbers provided is invalid to be a phone number': {
        pt: 'Erro: Um dos números fornecidos é inválido para ser um número de telefone',
        en: 'Error: One of the numbers provided is invalid to be a phone number',
    },
    'Error: Duplicate contact found': {
        pt: 'Erro: contato duplicado encontrado',
        en: 'Error: Duplicate contact found',
    },
    'Error: Invalid format. Please separate name and phone number with a comma or semicolon': {
        pt: 'Erro: Formato inválido. Por favor, separe o nome e o número de telefone com uma vírgula ou ponto e vírgula',
        en: 'Error: Invalid format. Please separate name and phone number with a comma or semicolon',
    },
    'Paste here the contacts to be added or enter manually in the format: (name;phone)': {
        pt: 'Cole aqui os contatos a serem adicionados ou insira manualmente no formato: (nome;telefone)',
        en: 'Paste here the contacts to be added or enter manually in the format: (name;phone)',
    },
    UTILITY: {
        pt: 'UTILIDADE',
        en: 'UTILITY',
    },
    AUTHENTICATION: {
        pt: 'AUTENTICAÇÃO',
        en: 'AUTHENTICATION',
    },
    Authentication: {
        pt: 'Autenticação',
        en: 'Authentication',
    },
    'Code example': {
        pt: 'Exemplo do código',
        en: 'Code example',
    },
    'Code expires': {
        pt: 'Código expira',
        en: 'Code expires',
    },
    minutes: {
        pt: 'minutos',
        en: 'minutes',
    },
    'Authentication template message is fixed': {
        pt: 'A mensagem do template de autenticação é fixa e não pode ser alterada.',
        en: 'The authentication template message is fixed and cannot be changed.',
    },
    'Authentication templates use a fixed WhatsApp message and cannot be edited.': {
        pt: 'Templates de autenticação utilizam uma mensagem fixa do WhatsApp e não podem ser editados.',
        en: 'Authentication templates use a fixed WhatsApp message and cannot be edited.',
    },
    'Authentication template must have only one button': {
        pt: 'Template de autenticação deve ter apenas um botão',
        en: 'Authentication template must have only one button',
    },
    'Authentication template button must be copy code': {
        pt: 'O botão do template de autenticação deve ser copiar código',
        en: 'Authentication template button must be copy code',
    },
    'Code example is required': {
        pt: 'Exemplo do código é obrigatório',
        en: 'Code example is required',
    },
    'Expiration minutes is required': {
        pt: 'Minutos de expiração é obrigatório',
        en: 'Expiration minutes is required',
    },
    Reminder: {
        pt: 'Lembrete',
        en: 'Reminder',
    },
    Medical_report: {
        pt: 'Laudo médico',
        en: 'Medical report',
    },
    Api_ivr: {
        pt: 'URA',
        en: 'IVR',
    },
    Schedule_notification: {
        pt: 'Notificação de agendamento',
        en: 'Schedule notification',
    },
    Recover_lost_schedule: {
        pt: 'Resgate de agendamento perdido',
        en: 'Recover lost schedule',
    },
    Nps_score: {
        pt: 'NPS avaliação',
        en: 'NPS score',
    },
    Documents_request: {
        pt: 'Solicitação de documentos',
        en: 'Documents request',
    },
    Active_mkt: {
        pt: 'Marketing ativo',
        en: 'Active marketing',
    },
    'The metric used in this chart has changed:': {
        pt: 'A métrica utilizada neste gráfico teve mudanças:',
        en: 'The metric used in this chart has changed:',
    },
    'This graph had a change in its metrics:': {
        pt: 'Este gráfico teve uma mudança em suas métricas:',
        en: 'This graph had a change in its metrics:',
    },
    'There is already an open service on the channel for this number': {
        pt: 'Já existe atendimento aberto no canal para este número',
        en: 'There is already an open service on the channel for this number',
    },
    'Channel available to start answering the number': {
        pt: 'Canal disponível para iniciar atendimento para o número',
        en: 'Channel available to start answering the number',
    },
    Unavailable: {
        pt: 'Indisponível',
        en: 'Unavailable',
    },
    Available: {
        pt: 'Disponível',
        en: 'Available',
    },
    'Omit invalids': {
        pt: 'Omitir inválidos',
        en: 'Omit invalids',
    },
    'Omit calls with invalid numbers': {
        pt: 'Omitir atendimentos com número inválido',
        en: 'Omit calls with invalid numbers',
    },
    'reacted with': {
        pt: 'reagiu com',
        en: 'reacted with',
    },
    'to a message': {
        pt: 'a uma mensagem',
        en: 'to a message',
    },
    'Schedule configuration name': {
        pt: 'Nome da configuração de agendamento',
        en: 'Schedule configuration name',
    },
    Alias: {
        pt: 'Alias',
        en: 'Alias',
    },
    'Scheduling Settings': {
        pt: 'Configurações de agendamento',
        en: 'Scheduling Settings',
    },
    'Confirmation Settings': {
        pt: 'Configurações confirmação',
        en: 'Confirmation Settings',
    },
    'automatic sending': {
        pt: 'envio automático',
        en: 'automatic sending',
    },
    'Schedule search interval (Minutes)': {
        pt: 'Intervalo de busca dos agendamentos (Minutos)',
        en: 'Schedule search interval (Minutes)',
    },
    'Shipping time before appointment date (Hours)': {
        pt: 'Tempo de envio antes da data do agendamento (Horas)',
        en: 'Shipping time before appointment date (Hours)',
    },
    'Group rule': {
        pt: 'Regra do grupo',
        en: 'Group rule',
    },
    'Invalid repeat': {
        pt: 'Repetir inválidos',
        en: 'Invalid repeat',
    },
    'Parameters for ERP': {
        pt: 'Parâmetros para ERP',
        en: 'Parameters for ERP',
    },
    'Reminder Settings': {
        pt: 'Configurações do lembrete',
        en: 'Reminder Settings',
    },
    'Extract at (Minutes)': {
        pt: 'Extraia em (Minutos)',
        en: 'Extract at (Minutes)',
    },
    'Use specialty in exam message': {
        pt: 'Usar especialidade na mensagem de exame',
        en: 'Use specialty in exam message',
    },
    'Send Only Principal Exam': {
        pt: 'Enviar apenas exame principal',
        en: 'Send Only Principal Exam',
    },
    'Extract rule': {
        pt: 'Regra de extração',
        en: 'Extract rule',
    },
    'Shipping List': {
        pt: 'Listagem de envios',
        en: 'Shipping List',
    },
    'Automatic sending': {
        pt: 'Envios automáticos',
        en: 'Automatic sending',
    },
    'Cancellation Reasons': {
        pt: 'Motivos de cancelamento',
        en: 'Cancellation Reasons',
    },
    'Request completed successfully': {
        pt: 'Solicitação realizada com sucesso',
        en: 'Request completed successfully',
    },
    'Your clone will be available in a few minutes.': {
        pt: 'Seu clone estará disponível em alguns minutos.',
        en: 'Your clone will be available in a few minutes.',
    },
    'Enter a Name': {
        pt: 'Digite um Nome',
        en: 'Enter a Name',
    },
    'Select an item...': {
        pt: 'Selecione um item...',
        en: 'Select an item...',
    },
    'Document number': {
        pt: 'Número do documento',
        en: 'Document number',
    },
    'Doctor data': {
        pt: 'Dados do médico',
        en: 'Doctor data',
    },
    "When you can't find the doctor": {
        pt: 'Quando não encontrar o médico',
        en: "When you can't find the doctor",
    },
    'When the document number is empty': {
        pt: 'Quando o número do documento vier vazio',
        en: 'When the document number is empty',
    },
    'Go to instead of asking for document number': {
        pt: 'Ir para ao invés de perguntar o número do documento',
        en: 'Go to instead of asking for document number',
    },
    Ads: {
        pt: 'Publicidade',
        en: 'Advertising',
    },
    'You do not have permission to access this conversation!': {
        pt: 'Você não possui permissão para acessar este atendimento!',
        en: 'You do not have permission to access this conversation!',
    },
    'Delete Disabled Entities': {
        pt: 'Apagar Entidades Inativas',
        en: 'Delete Disabled Entities',
    },
    'Error on disabled inactive entities': {
        pt: 'Erro ao apagar entidades inativas',
        en: 'Error on disabled inactive entities',
    },
    'Invalid file type for reaction.': {
        pt: 'Tipo de arquivo inválido para reação.',
        en: 'Invalid file type for reaction.',
    },
    Categorization: {
        pt: 'Categorização',
        en: 'Categorization',
    },
    Outcomes: {
        pt: 'Desfechos',
        en: 'Outcomes',
    },
    'Generate message': {
        pt: 'Gerar mensagem',
        en: 'Generate message',
    },
    'reacted to the message': {
        pt: 'reagiu a mensagem',
        en: 'reacted to the message',
    },
    'This interaction was modified by another user. Do you want to continue saving?': {
        pt: 'Esta interação foi modificada por outro usuário. Você quer continuar salvando?',
        en: 'This interaction was modified by another user. Do you want to continue saving?',
    },
    'You have unsaved changes. Please save before publishing.': {
        pt: 'Você tem alterações não salvas. Salve antes de publicar.',
        en: 'You have unsaved changes. Please save before publishing.',
    },
    'Interaction modified by another user': {
        pt: 'Interação modificada por outro usuário',
        en: 'Interaction modified by another user',
    },
    'Interaction pending publication': {
        pt: 'Interação pendente de publicação',
        en: 'Interaction pending publication',
    },
    'Now that you have completed the appointment, simply categorize it by indicating the reason for its completion (completion objectives) and the outcome of the service (result).':
        {
            pt: 'Agora que você finalizou o atendimento, basta categorizá-lo indicando o objetivo do contato neste atendimento (objetivo) e qual foi o resultado do atendimento (desfecho).',
            en: 'Now that you have completed the appointment, simply categorize it by indicating the purpose of the contact in this service (objective) and what was the outcome of the service (result).',
        },
    'Select or type a objective': {
        pt: 'Selecione ou digite um objetivo',
        en: 'Select or type a objective',
    },
    Outcome: {
        pt: 'Desfecho',
        en: 'Outcome',
    },
    'Select or type a outcome': {
        pt: 'Selecione ou digite um desfecho',
        en: 'Select or type a outcome',
    },
    Observation: {
        pt: 'Observação',
        en: 'Observation',
    },
    'Type additional notes about the conversation here': {
        pt: 'Digite aqui notas adicionais sobre o atendimento',
        en: 'Type additional notes about the conversation here',
    },
    'The outcome is required when the objective is filled out!': {
        pt: 'O desfecho é obrigatório quando o objetivo for preenchido!',
        en: 'The outcome is required when the objective is filled out!',
    },
    'The objective is required when the outcome is filled in!': {
        pt: 'O objetivo é obrigatório quando o desfecho for preenchido!',
        en: 'The objective is required when the outcome is filled in!',
    },
    'Error loading objectives': {
        pt: 'Erro ao carregar objetivos',
        en: 'Error loading objectives',
    },
    'Update categorization': {
        pt: 'Atualizar categorização',
        en: 'Update categorization',
    },
    'Error loading outcomes': {
        pt: 'Erro ao carregar desfechos',
        en: 'Error loading outcomes',
    },
    'Error finalizing conversation': {
        pt: 'Erro ao finalizar conversa',
        en: 'Error finalizing conversation',
    },
    'Error loading tags': {
        pt: 'Erro ao carregar tags',
        en: 'Error loading tags',
    },
    'The entered value contains leading or trailing spaces.': {
        pt: 'O valor digitado contém espaços em branco no início ou fim do texto.',
        en: 'The entered value contains leading or trailing spaces.',
    },
    'It is not possible to group data for more than 2 months, as this may compromise table visualization.': {
        pt: 'Não é possível agrupar dados por mais de 2 meses, pois isso pode comprometer a visualização da tabela.',
        en: 'It is not possible to group data for more than 2 months, as this may compromise table visualization.',
    },
    'Enable step to go back in the integrated flow': {
        pt: 'Ativar etapa de voltar no fluxo integrado',
        en: 'Enable step to go back in the integrated flow',
    },
    'You do not have permission for this action.': {
        pt: 'Você não possui permissão para esta ação.',
        en: 'You do not have permission for this action.',
    },
    'Team is inactive, try transferring to another team.': {
        pt: 'Time esta inativado, tente transferir para outro time.',
        en: 'Team is inactive, try transferring to another team.',
    },
    "This team doesn't allow transfers, try transferring to another team.": {
        pt: 'Este time não permite transferência, tente transferir para outro time.',
        en: "This team doesn't allow transfers, try transferring to another team.",
    },
    'This agent does not have permission to take on appointments in this team, select another team.': {
        pt: 'Este agente não possui permissão para assumir atendimentos neste time, selecione outro time.',
        en: 'This agent does not have permission to take on appointments in this team, select another team.',
    },
    'Search agent': {
        pt: 'Buscar agente',
        en: 'Search agent',
    },
    'Search team': {
        pt: 'Buscar time',
        en: 'Search team',
    },
    'Select the agent to whom you want to transfer this service:': {
        pt: 'Selecione o agente para o qual deseja transferir este atendimento:',
        en: 'Select the agent to whom you want to transfer this service:',
    },
    "We couldn't find any agents with the text you entered. Try searching for another name!": {
        pt: 'Não encontramos nenhum agente com o texto digitado. Tente buscar por outro nome!',
        en: "We couldn't find any agents with the text you entered. Try searching for another name!",
    },
    'Select an agent to list the teams they belong to!': {
        pt: 'Selecione um agente para listar os times que ele faz parte!',
        en: 'Select an agent to list the teams they belong to!',
    },
    'Select a team that the agent is part of to continue!': {
        pt: 'Selecione um time do qual o agente faz parte para continuar!',
        en: 'Select a team that the agent is part of to continue!',
    },
    'Transfer service to a specific agent': {
        pt: 'Transferir atendimento para agente especifico',
        en: 'Transfer service to a specific agent',
    },
    'The agent is not allowed to take over the team.': {
        pt: 'O agente não possui permissão para assumir atendimentos neste time.',
        en: 'The agent is not allowed to take over the team.',
    },
    'Teams the agent is part of': {
        pt: 'Times que o agente faz parte',
        en: 'Teams the agent is part of',
    },
    'This agent is not included in any team, select another agent.': {
        pt: 'Este agente não esta incluído em nenhum time, selecione outro agente.',
        en: 'This agent is not included in any team, select another agent.',
    },
    'Advanced module': {
        pt: 'Módulo avançado',
        en: 'Advanced Module',
    },
    'Activate agent status': {
        pt: 'Ativa status do agente',
        en: 'Activate agent status',
    },
    Breaks: {
        pt: 'Pausas',
        en: 'Breaks',
    },
    Intenções: {
        pt: 'Intenções',
        en: 'Intents',
    },
    'Nova Intenção': {
        pt: 'Nova Intenção',
        en: 'New Intent',
    },
    'Editar Intenção': {
        pt: 'Editar Intenção',
        en: 'Edit Intent',
    },
    'Buscar intenções...': {
        pt: 'Buscar intenções...',
        en: 'Search intents...',
    },
    'Intenção criada com sucesso': {
        pt: 'Intenção criada com sucesso',
        en: 'Intent created successfully',
    },
    'Intenção atualizada com sucesso': {
        pt: 'Intenção atualizada com sucesso',
        en: 'Intent updated successfully',
    },
    'Intenção deletada com sucesso': {
        pt: 'Intenção deletada com sucesso',
        en: 'Intent deleted successfully',
    },
    'Erro ao criar intenção': {
        pt: 'Erro ao criar intenção',
        en: 'Error creating intent',
    },
    'Erro ao atualizar intenção': {
        pt: 'Erro ao atualizar intenção',
        en: 'Error updating intent',
    },
    'Erro ao deletar intenção': {
        pt: 'Erro ao deletar intenção',
        en: 'Error deleting intent',
    },
    'Erro ao carregar intenções': {
        pt: 'Erro ao carregar intenções',
        en: 'Error loading intents',
    },
    'Erro ao detectar intenção': {
        pt: 'Erro ao detectar intenção',
        en: 'Error detecting intent',
    },
    'Tem certeza que deseja deletar esta intenção?': {
        pt: 'Tem certeza que deseja deletar esta intenção?',
        en: 'Are you sure you want to delete this intent?',
    },
    'Digite o nome da intenção': {
        pt: 'Digite o nome da intenção',
        en: 'Enter the intent name',
    },
    'Digite a descrição da intenção': {
        pt: 'Digite a descrição da intenção',
        en: 'Enter the intent description',
    },
    'Digite um exemplo': {
        pt: 'Digite um exemplo',
        en: 'Enter an example',
    },
    'Adicionar Exemplo': {
        pt: 'Adicionar Exemplo',
        en: 'Add Example',
    },
    Remover: {
        pt: 'Remover',
        en: 'Remove',
    },
    Criar: {
        pt: 'Criar',
        en: 'Create',
    },
    Salvar: {
        pt: 'Salvar',
        en: 'Save',
    },
    Cancelar: {
        pt: 'Cancelar',
        en: 'Cancel',
    },
    Fechar: {
        pt: 'Fechar',
        en: 'Close',
    },
    Detectar: {
        pt: 'Detectar',
        en: 'Detect',
    },
    Debug: {
        pt: 'Debug',
        en: 'Debug',
    },
    'Debug - Detectar Intenção': {
        pt: 'Debug - Detectar Intenção',
        en: 'Debug - Detect Intent',
    },
    'Debug Doctor': {
        pt: 'Debugar Médico',
        en: 'Debug Doctor',
    },
    'Doctor Code': {
        pt: 'Código do Médico',
        en: 'Doctor Code',
    },
    'Insurance Code': {
        pt: 'Código do Convênio',
        en: 'Insurance Code',
    },
    'Please enter the insurance code': {
        pt: 'Por favor, insira o código do convênio',
        en: 'Please enter the insurance code',
    },
    'Enter insurance code': {
        pt: 'Digite o código do convênio',
        en: 'Enter insurance code',
    },
    'Please enter the age': {
        pt: 'Por favor, insira a idade',
        en: 'Please enter the age',
    },
    'Enter age': {
        pt: 'Digite a idade',
        en: 'Enter age',
    },
    'Age must be between 0 and 120': {
        pt: 'A idade deve estar entre 0 e 120',
        en: 'Age must be between 0 and 120',
    },
    Age: {
        pt: 'Idade',
        en: 'Age',
    },
    'API Response': {
        pt: 'Resposta da API',
        en: 'API Response',
    },
    'Processing debug request...': {
        pt: 'Processando solicitação de debug...',
        en: 'Processing debug request...',
    },
    'Debug request completed successfully': {
        pt: 'Solicitação de debug concluída com sucesso',
        en: 'Debug request completed successfully',
    },
    'Error during debug request': {
        pt: 'Erro durante solicitação de debug',
        en: 'Error during debug request',
    },
    'Not defined': {
        pt: 'Não definido',
        en: 'Not defined',
    },
    'Texto para detecção': {
        pt: 'Texto para detecção',
        en: 'Text for detection',
    },
    'Digite o texto para detectar a intenção': {
        pt: 'Digite o texto para detectar a intenção',
        en: 'Enter the text to detect the intent',
    },
    Resultado: {
        pt: 'Resultado',
        en: 'Result',
    },
    'Intenção detectada:': {
        pt: 'Intenção detectada:',
        en: 'Detected intent:',
    },
    'ID da intenção:': {
        pt: 'ID da intenção:',
        en: 'Intent ID:',
    },
    'Tokens utilizados:': {
        pt: 'Tokens utilizados:',
        en: 'Tokens used:',
    },
    'Ações:': {
        pt: 'Ações:',
        en: 'Actions:',
    },
    Exemplos: {
        pt: 'Exemplos',
        en: 'Examples',
    },
    intenções: {
        pt: 'intenções',
        en: 'intents',
    },
    mais: {
        pt: 'mais',
        en: 'more',
    },
    'Detecção de Entidades': {
        pt: 'Detecção de Entidades',
        en: 'Entity Detection',
    },
    Editar: {
        pt: 'Editar',
        en: 'Edit',
    },
    Deletar: {
        pt: 'Deletar',
        en: 'Delete',
    },
    'Como usar': {
        pt: 'Como usar',
        en: 'How to use',
    },
    'Digite um texto para testar qual intenção será detectada pelo sistema': {
        pt: 'Digite um texto para testar qual intenção será detectada pelo sistema',
        en: 'Enter text to test which intent will be detected by the system',
    },
    'ID da intenção': {
        pt: 'ID da intenção',
        en: 'Intent ID',
    },
    'Tokens utilizados': {
        pt: 'Tokens utilizados',
        en: 'Tokens used',
    },
    'Erro na detecção': {
        pt: 'Erro na detecção',
        en: 'Detection error',
    },
    'Message Suggestions': {
        pt: 'Sugestões de Mensagem',
        en: 'Message Suggestions',
    },
    'Template Suggestions': {
        pt: 'Sugestões de Template',
        en: 'Template Suggestions',
    },
    'Content to Remove': {
        pt: 'Remover Conteúdo',
        en: 'Content to Remove',
    },
    'Apply Suggestion': {
        pt: 'Aplicar Sugestão',
        en: 'Apply Suggestion',
    },
    Suggestion: {
        pt: 'Sugestão',
        en: 'Suggestion',
    },
    'Conversation automatically assigned to the user': {
        en: 'Conversation automatically assigned to the user',
        pt: 'Conversa atribuída automaticamente para o usuário',
    },
    'The PIVOT Table allows you to visualize details about each scheduling intent in the workspace. This report displays information only when the workspace has integrated automatic scheduling. If the scheduling process depends on an agent to be completed, the data will not be recorded in this table.':
        {
            en: 'The PIVOT Table allows you to visualize details about each scheduling intent in the workspace. This report displays information only when the workspace has integrated automatic scheduling. If the scheduling process depends on an agent to be completed, the data will not be recorded in this table.',
            pt: 'A Tabela PIVOT permite visualizar detalhes sobre cada intenção de agendamento no workspace. Este relatório exibe informações apenas quando o workspace possui agendamento automático integrado. Se o processo de agendamento depende de um atendente para ser concluído, os dados não serão registrados nesta tabela.',
        },
    'transferred the conversation to': {
        en: 'transferred the conversation to',
        pt: 'transferiu o atendimento para',
    },
    'was activated': {
        en: 'was activated',
        pt: 'foi ativado',
    },
    'returned the conversation': {
        en: 'returned the conversation',
        pt: 'devolveu o atendimento',
    },
    'is monitoring the conversation': {
        en: 'is monitoring the conversation',
        pt: 'está monitorando o atendimento',
    },
    'was deactivated': {
        en: 'was deactivated',
        pt: 'foi desativado',
    },
    'was automatically deactivated, as only official templates can be sent': {
        en: 'was automatically deactivated, as only official templates can be sent',
        pt: 'foi desativado automaticamente, pois só é possível realizar o envio de templates oficiais',
    },
    'Patient Appointments - Document Upload': {
        en: 'Patient Appointments - Document Upload',
        pt: 'Agendamentos do Paciente - Envio de Documentos',
    },
    'Future Appointments': {
        en: 'Future Appointments',
        pt: 'Agendamentos Futuros',
    },
    'No future appointments found': {
        en: 'No future appointments found',
        pt: 'Nenhum agendamento futuro encontrado',
    },
    'Send Attachment to Appointment': {
        en: 'Send Attachment to Appointment',
        pt: 'Enviar Anexo para Agendamento',
    },
    'Upload Document': {
        en: 'Upload Document',
        pt: 'Carregar Documento',
    },
    'Select Document Type': {
        en: 'Select Document Type',
        pt: 'Selecionar Tipo de Documento',
    },
    'Select Type': {
        en: 'Select Type',
        pt: 'Selecionar Tipo',
    },
    Upload: {
        en: 'Upload',
        pt: 'Enviar',
    },
    Uploaded: {
        en: 'Uploaded',
        pt: 'Enviados',
    },
    'Use Current Image': {
        en: 'Use Current Image',
        pt: 'Usar Imagem Atual',
    },
    Selected: {
        en: 'Selected',
        pt: 'Selecionado',
    },
    'Failed to load current image': {
        en: 'Failed to load current image',
        pt: 'Falha ao carregar imagem atual',
    },
    'Refresh appointments': {
        en: 'Refresh appointments',
        pt: 'Atualizar agendamentos',
    },
    'Checking document upload permissions...': {
        en: 'Checking document upload permissions...',
        pt: 'Verificando permissões de upload de documentos...',
    },
    'Feature Temporarily Unavailable': {
        en: 'Feature Temporarily Unavailable',
        pt: 'Funcionalidade Temporariamente Indisponível',
    },
    'Document upload feature is not available': {
        en: 'Document upload feature is not available',
        pt: 'A funcionalidade de upload de documentos não está disponível',
    },
    'Document upload feature is temporarily unavailable': {
        en: 'Document upload feature is temporarily unavailable',
        pt: 'A funcionalidade de upload de documentos está temporariamente indisponível',
    },
    'Your account needs additional configuration to upload documents': {
        en: 'Your account needs additional configuration to upload documents',
        pt: 'Sua conta precisa de configuração adicional para enviar documentos',
    },
    'Document upload is currently unavailable': {
        en: 'Document upload is currently unavailable',
        pt: 'Upload de documentos está atualmente indisponível',
    },
    'Document upload is not available': {
        en: 'Document upload is not available',
        pt: 'Upload de documentos não está disponível',
    },
    'Failed to verify document upload permissions': {
        en: 'Failed to verify document upload permissions',
        pt: 'Falha ao verificar permissões de upload de documentos',
    },
    'Please enter patient code first': {
        en: 'Please enter patient code first',
        pt: 'Insira o código do paciente primeiro',
    },
    'No Image Available': {
        en: 'No Image Available',
        pt: 'Nenhuma Imagem Disponível',
    },
    'Please select an image in the preview to upload documents': {
        en: 'Please select an image in the preview to upload documents',
        pt: 'Selecione uma imagem na visualização para enviar documentos',
    },
    'Please select document type and ensure image is selected': {
        en: 'Please select document type and ensure image is selected',
        pt: 'Selecione o tipo de documento e certifique-se de que a imagem está selecionada',
    },
    'Current image already sent': {
        en: 'Current image already sent',
        pt: 'Imagem atual já enviada',
    },
    'Document Sent': {
        en: 'Sent',
        pt: 'Enviado',
    },
    'Description (optional)': {
        en: 'Description (optional)',
        pt: 'Descrição (opcional)',
    },
    'Uploading...': {
        en: 'Uploading...',
        pt: 'Carregando...',
    },
    'Document uploaded successfully': {
        en: 'Document uploaded successfully',
        pt: 'Documento enviado com sucesso',
    },
    'Failed to upload document': {
        en: 'Failed to upload document',
        pt: 'Falha ao enviar documento',
    },
    'Failed to load appointments': {
        en: 'Failed to load appointments',
        pt: 'Falha ao carregar agendamentos',
    },
    'Failed to load document types': {
        en: 'Failed to load document types',
        pt: 'Falha ao carregar tipos de documento',
    },
    'Failed to load documents': {
        en: 'Failed to load documents',
        pt: 'Falha ao carregar documentos',
    },
    'Please fill all required fields': {
        en: 'Please fill all required fields',
        pt: 'Por favor, preencha todos os campos obrigatórios',
    },
    'Uploaded Documents': {
        en: 'Uploaded Documents',
        pt: 'Documentos Enviados',
    },
    'Enter Patient Code': {
        en: 'Enter Patient Code',
        pt: 'Digite o Código do Paciente',
    },
    'Patient code was not found automatically. Please enter the patient code to search for appointments.': {
        en: 'Patient code was not found automatically. Please enter the patient code to search for appointments.',
        pt: 'O código do paciente não foi encontrado automaticamente. Por favor, digite o código do paciente para buscar os agendamentos.',
    },
    'Patient Code': {
        en: 'Patient Code',
        pt: 'Código do Paciente',
    },
    'Please enter patient code': {
        en: 'Please enter patient code',
        pt: 'Por favor, digite o código do paciente',
    },
    'Searching...': {
        en: 'Searching...',
        pt: 'Buscando...',
    },
    'Appointments loaded successfully': {
        en: 'Appointments loaded successfully',
        pt: 'Agendamentos carregados com sucesso',
    },
    'Patient not found': {
        en: 'Patient not found',
        pt: 'Paciente não encontrado',
    },
    'Authentication error': {
        en: 'Authentication error',
        pt: 'Erro de autenticação',
    },
    'Feature not available for this workspace': {
        en: 'Feature not available for this workspace',
        pt: 'Funcionalidade não disponível para este workspace',
    },
    'Summary already exists for this conversation': {
        en: 'Summary already exists for this conversation',
        pt: 'Já existe um resumo para este atendimento',
    },
    'Conversation not found': {
        en: 'Conversation not found',
        pt: 'Atendimento não encontrado',
    },
    'Cannot generate summary for a closed conversation': {
        en: 'Cannot generate summary for a closed conversation',
        pt: 'Não é possível gerar resumo de um atendimento fechado',
    },
    'Conversation has no activities to summarize': {
        en: 'Conversation has no activities to summarize',
        pt: 'Atendimento não possui atividades para resumir',
    },
    'Conversation has no relevant activities to summarize': {
        en: 'Conversation has no relevant activities to summarize',
        pt: 'Atendimento não possui atividades relevantes para resumir',
    },
    'Conversation must have at least 10 messages to generate a summary': {
        en: 'Conversation must have at least 10 messages to generate a summary',
        pt: 'Atendimento deve ter pelo menos 10 mensagens para gerar um resumo',
    },
    'Error checking if can generate summary': {
        en: 'Error checking if can generate summary',
        pt: 'Erro ao verificar se pode gerar resumo',
    },
    'Failed to generate conversation summary': {
        en: 'Failed to generate conversation summary',
        pt: 'Falha ao gerar resumo do atendimento',
    },
    'Could not generate summary': {
        en: 'Could not generate summary',
        pt: 'Não foi possível gerar o resumo',
    },
    'Error generating summary': {
        en: 'Error generating summary',
        pt: 'Erro ao gerar resumo',
    },
    'An unexpected error occurred while generating the conversation summary': {
        en: 'An unexpected error occurred while generating the conversation summary',
        pt: 'Ocorreu um erro inesperado ao gerar o resumo do atendimento',
    },
    'Summary generated successfully': {
        en: 'Summary generated successfully',
        pt: 'Resumo gerado com sucesso',
    },
    'The conversation summary has been generated and is available': {
        en: 'The conversation summary has been generated and is available',
        pt: 'O resumo do atendimento foi gerado e está disponível',
    },
    'Generate summary': {
        en: 'Generate summary',
        pt: 'Gerar resumo',
    },
    'Generating...': {
        en: 'Generating...',
        pt: 'Gerando...',
    },
    'Already generated': {
        en: 'Already generated',
        pt: 'Já gerado',
    },
    'Checking...': {
        en: 'Checking...',
        pt: 'Verificando...',
    },
    'Was this helpful?': {
        en: 'Was this content useful?',
        pt: 'Esse conteúdo foi útil?',
    },
    'Was this suggestion helpful?': {
        en: 'Was this suggestion helpful?',
        pt: 'Essa sugestão ajudou?',
    },
    'Feedback sent': {
        en: 'Feedback sent',
        pt: 'Feedback enviado',
    },
    'Positive feedback': {
        en: 'Positive feedback',
        pt: 'Avaliação positiva',
    },
    'Negative feedback': {
        en: 'Negative feedback',
        pt: 'Avaliação negativa',
    },
    'Positive evaluation recorded': {
        en: 'Positive evaluation recorded',
        pt: 'Avaliação positiva registrada',
    },
    'Negative evaluation recorded': {
        en: 'Negative evaluation recorded',
        pt: 'Avaliação negativa registrada',
    },
    'You already rated this content': {
        en: 'You already rated this content',
        pt: 'Você já avaliou este conteúdo',
    },
    'Unable to send feedback': {
        en: 'Unable to send feedback',
        pt: 'Não foi possível enviar o feedback',
    },
    'Thank you for your feedback': {
        en: 'Thank you for your feedback',
        pt: 'Obrigado pelo seu feedback',
    },
    'Please try again later': {
        en: 'Please try again later',
        pt: 'Por favor, tente novamente mais tarde',
    },
    'Yes, it was helpful': {
        en: 'Yes, it was helpful',
        pt: 'Sim, foi útil',
    },
    'No, it was not helpful': {
        en: 'No, it was not helpful',
        pt: 'Não, não foi útil',
    },
    'Reason for negative feedback': {
        en: 'Reason for negative feedback',
        pt: 'Motivo do feedback negativo',
    },
    'Additional comment': {
        en: 'View full feedback',
        pt: 'Ver feedback completo',
    },
    'We noted your reason': {
        en: 'We noted your reason',
        pt: 'Registramos o motivo que você indicou',
    },
    'Send feedback': {
        en: 'Send feedback',
        pt: 'Enviar feedback',
    },
    'Unable to identify feedback to save details.': {
        en: 'Unable to identify feedback to save details.',
        pt: 'Não foi possível identificar o feedback para salvar os detalhes.',
    },
    'Please wait a moment and try again.': {
        en: 'Please wait a moment and try again.',
        pt: 'Aguarde um momento e tente novamente.',
    },
    'Please provide a comment as the reason.': {
        en: 'Please provide a comment as the reason.',
        pt: 'Informe o comentário para enviar como motivo.',
    },
    'Please select a reason or enter a comment.': {
        en: 'Please select a reason or enter a comment.',
        pt: 'Selecione um motivo ou informe um comentário.',
    },
    'Select a reason or write your comment.': {
        en: 'Select a reason or write your comment.',
        pt: 'Selecione um motivo ou escreva seu comentário.',
    },
    'Unable to send details. Please try again.': {
        en: 'Unable to send details. Please try again.',
        pt: 'Não foi possível enviar os detalhes. Tente novamente.',
    },
    'Loading options...': {
        en: 'Loading options...',
        pt: 'Carregando opções...',
    },
    'Other reason (describe below)': {
        en: 'Other reason (describe below)',
        pt: 'Outro motivo (descreva abaixo)',
    },
    'Type your comment': {
        en: 'Type your comment',
        pt: 'Digite seu comentário',
    },
    'Tell us more about the summary': {
        en: 'Tell us more about the summary',
        pt: 'Conte mais sobre o resumo',
    },
    'Tell us more about the suggestion': {
        en: 'Tell us more about the suggestion',
        pt: 'Conte mais sobre a sugestão',
    },
    'Share your feedback': {
        en: 'Share your feedback',
        pt: 'Compartilhe seu feedback',
    },
    'The objective is unclear or incorrect': {
        en: 'The objective is unclear or incorrect',
        pt: 'O objetivo não ficou claro ou está incorreto',
    },
    'The suggested next steps do not make sense': {
        en: 'The suggested next steps do not make sense',
        pt: 'Os próximos passos sugeridos não fazem sentido',
    },
    'The summary includes irrelevant information': {
        en: 'The summary includes irrelevant information',
        pt: 'O resumo trouxe informações não relevantes',
    },
    'The correction did not fix spelling or grammar errors': {
        en: 'The correction did not fix spelling or grammar errors',
        pt: 'A correção não resolveu erros ortográficos ou gramaticais',
    },
    'The meaning of the message changed': {
        en: 'The meaning of the message changed',
        pt: 'O significado da mensagem mudou',
    },
    'Your negative feedback helps us improve. Pick a reason or describe what went wrong.': {
        en: 'Your negative feedback helps us improve. Pick a reason or describe what went wrong.',
        pt: 'Seu feedback negativo nos ajuda a melhorar. Escolha um motivo ou descreva o que não funcionou.',
    },
    'Main reason': {
        en: 'Main reason',
        pt: 'Motivo principal',
    },
    'Use this when none of the options fit. Briefly describe the issue.': {
        en: 'Use this when none of the options fit. Briefly describe the issue.',
        pt: 'Use quando nenhuma opção se aplica. Descreva brevemente o problema.',
    },
    'View full summary': {
        en: 'View full summary',
        pt: 'Ver resumo completo',
    },
    'Summary automatically generated by AI': {
        en: 'Summary automatically generated by AI',
        pt: 'Resumo gerado automaticamente por IA',
    },
    'Summary in progress': {
        en: 'Summary in progress',
        pt: 'Resumo em andamento',
    },
    Summary: {
        en: 'Summary',
        pt: 'Resumo',
    },
    Sentiment: {
        en: 'Sentiment',
        pt: 'Sentimento',
    },
    'Next Steps': {
        en: 'Next Steps',
        pt: 'Próximos Passos',
    },
    'Improve text with AI': {
        en: 'Improve text with AI',
        pt: 'Melhorar texto com IA',
    },
    'Maximum of 10 improvements per conversation': {
        en: 'Maximum of 10 improvements per conversation',
        pt: 'Máximo de 10 melhorias por atendimento',
    },
    'Smart message copilot feature flag should be enabled to execute this action': {
        en: 'Smart message copilot feature flag should be enabled to execute this action',
        pt: 'Esta função está desabilitada em sua área de trabalho',
    },
    'More formal': {
        en: 'More formal',
        pt: 'Mais formal',
    },
    'Fix errors': {
        en: 'Fix errors',
        pt: 'Corrigir erros',
    },
    'More friendly': {
        en: 'More friendly',
        pt: 'Mais amigável',
    },
    Processing: {
        en: 'Processing',
        pt: 'Processando',
    },
    'Use this text': {
        en: 'Use this text',
        pt: 'Usar este texto',
    },
    'Error generating suggestion': {
        en: 'Error generating suggestion',
        pt: 'Erro ao gerar sugestão',
    },
    'Failed to generate suggestion. Please try again.': {
        en: 'Failed to generate suggestion. Please try again.',
        pt: 'Falha ao gerar sugestão. Por favor, tente novamente.',
    },
    'Failed to generate text suggestion. Please try again.': {
        en: 'Failed to generate text suggestion. Please try again.',
        pt: 'Falha ao gerar sugestão de texto. Por favor, tente novamente.',
    },
    'Type a message to improve': {
        en: 'Type a message to improve',
        pt: 'Digite uma mensagem para melhorar',
    },
    'An unexpected error occurred. Please try again.': {
        en: 'An unexpected error occurred. Please try again.',
        pt: 'Ocorreu um erro inesperado. Por favor, tente novamente.',
    },
    'Text must have at least 3 words': {
        en: 'Text must have at least 3 words',
        pt: 'O texto deve ter pelo menos 3 palavras',
    },
    'Text is too long (max 1,024 characters)': {
        en: 'Text is too long (max 1,024 characters)',
        pt: 'O texto é muito longo (máximo 1.024 caracteres)',
    },
    'Conversation is not open': {
        en: 'Conversation is not open',
        pt: 'A conversa não está aberta',
    },
    'WhatsApp conversation expired': {
        en: 'WhatsApp conversation expired',
        pt: 'Conversa do WhatsApp expirada',
    },
    'Suggestion limit reached for this conversation': {
        en: 'Suggestion limit reached for this conversation',
        pt: 'Limite de sugestões atingido para esta conversa',
    },
    'Cannot generate suggestions for texts containing profanity or offensive language': {
        en: 'Cannot generate suggestions for texts containing profanity or offensive language',
        pt: 'Não é possível gerar sugestões para textos que contenham palavrões ou linguagem ofensiva',
    },
    'Generated at': {
        en: 'Generated at',
        pt: 'Gerado em',
    },
    'Cannot generate summary': {
        en: 'Cannot generate summary',
        pt: 'Não é possível gerar resumo',
    },
    'Very Dissatisfied': {
        en: 'Very Dissatisfied',
        pt: 'Muito insatisfeito',
    },
    Dissatisfied: {
        en: 'Dissatisfied',
        pt: 'Insatisfeito',
    },
    Neutral: {
        en: 'Neutral',
        pt: 'Neutro',
    },
    Satisfied: {
        en: 'Satisfied',
        pt: 'Satisfeito',
    },
    'Very Satisfied': {
        en: 'Very Satisfied',
        pt: 'Muito satisfeito',
    },
    'AI identified objective': {
        en: 'AI identified objective',
        pt: 'Objetivo identificado pela IA',
    },
    'Based on the conversation analysis, the AI identified and pre-selected the objective below. You can change it if necessary.':
        {
            en: 'Based on the service analysis, the AI identified and pre-selected the objective below. You can change it if necessary.',
            pt: 'Com base na análise do atendimento, a IA identificou e pré-selecionou o objetivo abaixo. Você pode alterá-lo se necessário.',
        },
    'The requested flow could not be found': {
        en: 'The requested flow could not be found',
        pt: 'O fluxo solicitado não pôde ser encontrado',
    },
    'Cannot delete interaction': {
        en: 'Cannot delete interaction',
        pt: 'Não é possível deletar a interaction',
    },

    'This flow uses the interaction you tried to delete': {
        en: 'This flow uses the interaction you tried to delete',
        pt: 'Este fluxo usa a interação que você tentou excluir',
    },
    'The interaction cannot be deleted because it is being referenced in the following locations': {
        en: 'The interaction cannot be deleted because it is being referenced in the following locations',
        pt: 'A interaction não pode ser deletada pois está sendo referenciada nos seguintes GOTOs:',
    },
    'Delete references and interaction': {
        en: 'Delete references and interaction',
        pt: 'Deletar referências e interaction',
    },
    'Go to interaction': {
        en: 'Go to interaction',
        pt: 'Ir para interaction',
    },

    'Response Type': {
        en: 'Response Type',
        pt: 'Tipo de resposta',
    },
    'Interaction deleted successfully': {
        en: 'Interaction deleted successfully',
        pt: 'Interaction deletada com sucesso',
    },
    'Failed to delete interaction': {
        en: 'Failed to delete interaction',
        pt: 'Falha ao deletar interaction',
    },
    'Success to delete interaction': {
        en: 'Success to delete interaction',
        pt: 'Sucesso ao deletar interação',
    },
    'An error occurred while deleting references': {
        en: 'An error occurred while deleting references',
        pt: 'Ocorreu um erro ao deletar as referências',
    },
    'Extract data': {
        en: 'Extract data',
        pt: 'Extrair Dados',
    },
    'Extracted data': {
        en: 'Extracted data',
        pt: 'Dados extraídos',
    },
    'View extracted data': {
        en: 'View extracted data',
        pt: 'Ver dados extraídos',
    },
    'Beneficiary name': {
        en: 'Beneficiary name',
        pt: 'Nome do beneficiário',
    },
    'Card number': {
        en: 'Card number',
        pt: 'Número da carteirinha',
    },
    'Plan operator': {
        en: 'Plan operator',
        pt: 'Operadora',
    },
    'Plan name': {
        en: 'Plan name',
        pt: 'Nome do plano',
    },
    Coverage: {
        en: 'Coverage',
        pt: 'Abrangência',
    },
    Accommodation: {
        en: 'Accommodation',
        pt: 'Acomodação',
    },
    Contracting: {
        en: 'Contracting',
        pt: 'Contratação',
    },
    Validity: {
        en: 'Validity',
        pt: 'Validade',
    },
    'Issue date': {
        en: 'Issue date',
        pt: 'Data de emissão',
    },
    'Beneficiary code': {
        en: 'Beneficiary code',
        pt: 'Código do beneficiário',
    },
    'Unable to extract beneficiary card data': {
        en: 'We processed the image, but did not find card data to extract.',
        pt: 'Processamos a imagem, mas não encontramos dados da carteirinha para extrair.',
    },
    'Unable to extract medical request data': {
        en: 'We processed the image, but did not find medical request data to extract.',
        pt: 'Processamos a imagem, mas não encontramos dados do pedido médico para extrair.',
    },
    'Unable to extract generic document data': {
        en: 'We processed the image, but did not find structured data to extract.',
        pt: 'Processamos a imagem, mas não encontramos dados estruturados para extrair.',
    },
    'Unable to extract data right now. Try again later.': {
        en: 'Unable to extract data right now. Try again later.',
        pt: 'Não foi possível extrair os dados no momento. Tente novamente mais tarde.',
    },
    'Generic document': {
        en: 'Generic document',
        pt: 'Documento genérico',
    },
    'Extract data from generic documents': {
        en: 'Extract data from generic documents',
        pt: 'Extrair dados de documentos genéricos',
    },
    'Holder name': {
        en: 'Holder name',
        pt: 'Nome do titular',
    },
    'Document title': {
        en: 'Document title',
        pt: 'Título do documento',
    },
    Issuer: {
        en: 'Issuer',
        pt: 'Emissor',
    },
    'Doctor name': {
        en: 'Doctor name',
        pt: 'Nome do médico',
    },
    'Doctor CRM': {
        en: 'Doctor CRM',
        pt: 'CRM do médico',
    },
    'Doctor CRM UF': {
        en: 'Doctor CRM UF',
        pt: 'CRM UF',
    },
    'Patient name': {
        en: 'Patient name',
        pt: 'Nome do paciente',
    },
    'Exam name': {
        en: 'Exam name',
        pt: 'Nome do exame',
    },
    'Alternate names': {
        en: 'Alternate names',
        pt: 'Nomes alternativos',
    },
    Exams: {
        en: 'Exams',
        pt: 'Exames',
    },
    'No extraction data available': {
        en: 'Extraction in progress. Please wait.',
        pt: 'Extração em andamento. Aguarde.',
    },
    'Extractions available': {
        en: 'extractions available',
        pt: 'extrações disponíveis',
    },
    'No structured data found': {
        en: 'No structured data found. See raw text below.',
        pt: 'Nenhum dado estruturado encontrado. Veja o texto bruto abaixo.',
    },
    'Extracted at': {
        en: 'Extracted at',
        pt: 'Extraído em',
    },
    'Raw text': {
        en: 'Raw text',
        pt: 'Texto bruto',
    },
    'Copy all data': {
        en: 'Copy all data',
        pt: 'Copiar todos os dados',
    },
    'Data copied': {
        en: 'Data copied',
        pt: 'Dados copiados',
    },
    'Unable to copy data': {
        en: 'Unable to copy data',
        pt: 'Não foi possível copiar os dados',
    },
    'Extraction type': {
        en: 'Extraction type',
        pt: 'Tipo de Extração',
    },
    'Select the document type': {
        en: 'Select the document type',
        pt: 'Selecione o tipo de documento',
    },
    'Health plan card': {
        en: 'Health plan card',
        pt: 'Carteirinha de Convênio',
    },
    'Medical request': {
        en: 'Medical request',
        pt: 'Pedido médico',
    },
    'Extract data from health plan cards': {
        en: 'Extract data from health plan cards',
        pt: 'Extrair dados de carteirinhas de planos de saúde',
    },
    'Extract data from medical requests': {
        en: 'Extract data from medical requests',
        pt: 'Extrair dados de pedidos médicos',
    },
    Unknown: {
        en: 'Unknown',
        pt: 'Desconhecido',
    },
    'The file does not appear to be a beneficiary card': {
        en: 'We processed the image, but did not find card data to extract.',
        pt: 'Processamos a imagem, mas não encontramos dados da carteirinha para extrair.',
    },
    'No extracted data': {
        en: 'No extracted data',
        pt: 'Nenhum dado extraído',
    },
    'Extracted text': {
        en: 'Extracted text',
        pt: 'Texto extraído',
    },
    'Beneficiary card': {
        en: 'Beneficiary card',
        pt: 'Carteirinha do beneficiário',
    },
    'Appointment cancellation': {
        en: 'Apointment Cancellation',
        pt: 'Cancelamento de agendas',
    },
    'Enable appointment cancellation': {
        en: 'Enable appointment cancellation',
        pt: 'Ativar cancelamento de agendas',
    },
    Flows: {
        en: 'Flows',
        pt: 'Fluxos',
    },
    'Official WhatsApp template': {
        en: 'Official WhatsApp templates',
        pt: 'Templates oficiais do WhatsApp',
    },
    'Contacts v2': {
        en: 'Contacts v2',
        pt: 'Contatos v2',
    },
    Cancellation: {
        en: 'Cancellation',
        pt: 'Cancelamento',
    },
    'Open public report': {
        en: 'Open public report',
        pt: 'Abrir relatório público',
    },
    patient: {
        en: 'Patient identification',
        pt: 'Identificação do Paciente',
    },
    preparation: {
        en: 'Appointment preparation',
        pt: 'Preparo da Consulta',
    },
    summary: {
        en: 'Appointment summary',
        pt: 'Resumo do Agendamento',
    },
    exams: {
        en: 'Exams',
        pt: 'Exames',
    },
    postBookingGuidance: {
        en: 'Post-booking guidance',
        pt: 'Orientações Pós-Agendamento',
    },
    unit: {
        en: 'Unit',
        pt: 'Unidade',
    },
    'Descartar alterações não salvas?': {
        en: 'Discard unsaved changes?',
        pt: 'Descartar alterações não salvas?',
    },
    'Você tem alterações não salvas que serão perdidas.': {
        en: 'You have unsaved changes that will be lost.',
        pt: 'Você tem alterações não salvas que serão perdidas.',
    },
    Descartar: {
        en: 'Discard',
        pt: 'Descartar',
    },
    'Continuar editando': {
        en: 'Keep editing',
        pt: 'Continuar editando',
    },
    alteração: {
        en: 'change',
        pt: 'alteração',
    },
    alterações: {
        en: 'changes',
        pt: 'alterações',
    },
    'Esta etapa já está na sequência': {
        en: 'This step is already in the sequence',
        pt: 'Esta etapa já está na sequência',
    },
    Attention: {
        en: 'Attention',
        pt: 'Atenção',
    },
    'Not applicable': {
        en: 'Not applicable',
        pt: 'Não aplicável',
    },
    'No teams found': {
        en: 'No teams found',
        pt: 'Nenhum time encontrado',
    },
    'Running...': {
        en: 'Running...',
        pt: 'Executando...',
    },
    'Bulk actions': {
        en: 'Bulk actions',
        pt: 'Ações em lote',
    },
    'Take conversations from queue': {
        en: 'Take conversations from queue',
        pt: 'Pegar atendimentos da fila',
    },
    'Select a REMI rule': {
        en: 'Select a REMI rule',
        pt: 'Selecione uma regra de REMI',
    },
    'Activate REMI': {
        en: 'Activate REMI',
        pt: 'Ativar REMI',
    },
    'Send message': {
        en: 'Send message',
        pt: 'Enviar mensagem',
    },
    'No actions available for the selected items': {
        en: 'No actions available for the selected items',
        pt: 'Nenhuma ação disponível para os itens selecionados',
    },
    'Select conversations': {
        en: 'Select conversations',
        pt: 'Selecionar atendimentos',
    },
    'Cancel selection': {
        en: 'Cancel selection',
        pt: 'Cancelar seleção',
    },
    'Clear selection': {
        en: 'Clear selection',
        pt: 'Limpar seleção',
    },
    'All my teams': {
        en: 'All my teams',
        pt: 'Todos os meus times',
    },
    'How many conversations do you want to take from the queue?': {
        en: 'How many conversations do you want to take from the queue?',
        pt: 'Quantos atendimentos você quer pegar da fila?',
    },
    'Which team do you want to take conversations from?': {
        en: 'Which team do you want to take conversations from?',
        pt: 'De qual time você quer pegar atendimentos?',
    },
    'No conversations were available in the queue at this time': {
        en: 'No conversations were available in the queue at this time',
        pt: 'Nenhum atendimento estava disponível na fila neste momento',
    },
    '{assumedCount} conversation(s) assumed.': {
        en: '{assumedCount} conversation(s) assumed.',
        pt: '{assumedCount} atendimento(s) assumido(s).',
    },
    '{assumedCount} conversation(s) assumed. {unavailableCount} were no longer available.': {
        en: '{assumedCount} conversation(s) assumed. {unavailableCount} were no longer available.',
        pt: '{assumedCount} atendimento(s) assumido(s). {unavailableCount} não estavam mais disponíveis.',
    },
    '{count} selected': {
        en: '{count} selected',
        pt: '{count} selecionado(s)',
    },
    'Close panel': {
        en: 'Close panel',
        pt: 'Fechar',
    },
    'Actions executed on the selected conversations.': {
        en: 'Actions executed on the selected conversations.',
        pt: 'Ações executadas nos atendimentos selecionados.',
    },
    'Select all in this tab': {
        en: 'Select all in this tab',
        pt: 'Selecionar todos desta aba',
    },
    'Selection limited to the first {limit} conversations loaded.': {
        en: 'Selection limited to the first {limit} conversations loaded.',
        pt: 'Seleção limitada aos primeiros {limit} atendimentos carregados.',
    },
    'Type the message that will be sent to all selected conversations': {
        en: 'Type the message that will be sent to all selected conversations',
        pt: 'Digite a mensagem que será enviada para todos os atendimentos selecionados',
    },
    'This message may fail to deliver on channels/conversations outside the free messaging window (e.g. WhatsApp after 24h).':
        {
            en: 'This message may fail to deliver on channels/conversations outside the free messaging window (e.g. WhatsApp after 24h).',
            pt: 'Esta mensagem pode não ser entregue em canais/atendimentos fora da janela de mensagem livre (ex.: WhatsApp após 24h).',
        },
    'This conversation was already closed or picked up by someone else. The list will be updated.': {
        en: 'This conversation was already closed or picked up by someone else. The list will be updated.',
        pt: 'Este atendimento já foi encerrado ou assumido por outra pessoa. A lista será atualizada.',
    },
    'The action could not be executed': {
        en: 'The action could not be executed',
        pt: 'A ação não pôde ser executada',
    },
    'The conversation has already been closed': {
        en: 'The conversation has already been closed',
        pt: 'O atendimento já foi encerrado',
    },
    'Only open conversations can be suspended': {
        en: 'Only open conversations can be suspended',
        pt: 'Apenas atendimentos abertos podem ser suspensos',
    },
    'You are not part of this conversation': {
        en: 'You are not part of this conversation',
        pt: 'Você não participa deste atendimento',
    },
    'You are no longer active in this conversation': {
        en: 'You are no longer active in this conversation',
        pt: 'Você não está mais ativo neste atendimento',
    },
    'You have already left this conversation': {
        en: 'You have already left this conversation',
        pt: 'Você já saiu deste atendimento',
    },
    'Team not found': {
        en: 'Team not found',
        pt: 'Time não encontrado',
    },
    'This team cannot receive transfers': {
        en: 'This team cannot receive transfers',
        pt: 'Este time não pode receber transferências',
    },
    'This team is inactive': {
        en: 'This team is inactive',
        pt: 'Este time está inativo',
    },
    'You are not allowed to transfer conversations': {
        en: 'You are not allowed to transfer conversations',
        pt: 'Você não tem permissão para transferir atendimentos',
    },
    'You are not part of the conversation team': {
        en: 'You are not part of the conversation team',
        pt: 'Você não faz parte do time do atendimento',
    },
    'You do not have permission to access this conversation': {
        en: 'You do not have permission to access this conversation',
        pt: 'Você não tem permissão para acessar este atendimento',
    },
    'Conversation belongs to another workspace': {
        en: 'Conversation belongs to another workspace',
        pt: 'O atendimento pertence a outro workspace',
    },
    'Could not activate REMI for this conversation': {
        en: 'Could not activate REMI for this conversation',
        pt: 'Não foi possível ativar o REMI para este atendimento',
    },
    'Request failed. Try again': {
        en: 'Request failed. Try again',
        pt: 'Falha na requisição. Tente novamente',
    },
    'Execution order': {
        en: 'Execution order',
        pt: 'Ordem de execução',
    },
    'Not available together with "{action}"': {
        en: 'Not available together with "{action}"',
        pt: 'Não disponível junto com "{action}"',
    },
    Execute: {
        en: 'Execute',
        pt: 'Executar',
    },
    'WhatsApp session expired. An official template is required to send messages': {
        en: 'WhatsApp session expired. An official template is required to send messages',
        pt: 'A sessão do WhatsApp está expirada. É obrigatório o uso de template oficial para enviar mensagens',
    },
    'You can select at most {limit} conversations at once.': {
        en: 'You can select at most {limit} conversations at once.',
        pt: 'Você pode selecionar no máximo {limit} atendimentos por vez.',
    },
    'Choose actions': {
        en: 'Choose actions',
        pt: 'Escolher ações',
    },
    'How it will happen': {
        en: 'How it will happen',
        pt: 'Como vai acontecer',
    },
    'Review and execute': {
        en: 'Review and execute',
        pt: 'Revisar e executar',
    },
    'You become responsible for the conversations that are not yours yet.': {
        en: 'You become responsible for the conversations that are not yours yet.',
        pt: 'Você passa a ser o responsável pelos atendimentos que ainda não são seus.',
    },
    'The message below is sent in each conversation:': {
        en: 'The message below is sent in each conversation:',
        pt: 'A mensagem abaixo é enviada em cada atendimento:',
    },
    'The REMI rule "{name}" takes over the re-engagement.': {
        en: 'The REMI rule "{name}" takes over the re-engagement.',
        pt: 'A regra de REMI "{name}" assume o reengajamento.',
    },
    'The conversations stay suspended for {duration}.': {
        en: 'The conversations stay suspended for {duration}.',
        pt: 'Os atendimentos ficam suspensos por {duration}.',
    },
    'The conversations are transferred to the team "{team}".': {
        en: 'The conversations are transferred to the team "{team}".',
        pt: 'Os atendimentos são transferidos para o time "{team}".',
    },
    'The conversations are closed.': {
        en: 'The conversations are closed.',
        pt: 'Os atendimentos são finalizados.',
    },
    'You leave the conversations (they remain open).': {
        en: 'You leave the conversations (they remain open).',
        pt: 'Você sai dos atendimentos (eles continuam abertos).',
    },
    'The actions above run in this exact order, one at a time, for every selected conversation. If an action fails for a specific conversation, it does not stop the others — in the next step you will review everything before executing, and afterward you will see the detailed result for each conversation and action.':
        {
            en: 'The actions above run in this exact order, one at a time, for every selected conversation. If an action fails for a specific conversation, it does not stop the others — in the next step you will review everything before executing, and afterward you will see the detailed result for each conversation and action.',
            pt: 'As ações acima executam exatamente nesta ordem, uma de cada vez, em todos os atendimentos selecionados. Se uma ação falhar em um atendimento específico, isso não interrompe as demais — na próxima etapa você revisa tudo antes de executar, e depois verá o resultado detalhado de cada atendimento e ação.',
        },
    '{count} conversation(s) selected': {
        en: '{count} conversation(s) selected',
        pt: '{count} atendimento(s) selecionado(s)',
    },
    'Select two different entity types to compare prices.': {
        en: 'Select two different entity types to compare prices.',
        pt: 'Selecione dois tipos de entidade diferentes para comparar preços.',
    },
    'Create annotation': {
        en: 'Create annotation',
        pt: 'Criar anotação',
    },
    'The annotation below is recorded in each conversation (not sent to the contact):': {
        en: 'The annotation below is recorded in each conversation (not sent to the contact):',
        pt: 'A anotação abaixo é registrada em cada atendimento (não é enviada ao contato):',
    },
    'Select one or more actions to run on the selected conversations.': {
        en: 'Select one or more actions to run on the selected conversations.',
        pt: 'Selecione uma ou mais ações a serem executadas nos atendimentos selecionados.',
    },
    'Not sent to contact': {
        en: 'Not sent to contact',
        pt: 'Não é enviado para o contato',
    },
    'Message to contact': {
        en: 'Message to contact',
        pt: 'Mensagem para o contato',
    },
    'Type "/" to insert a template without variables': {
        en: 'Type "/" to insert a template without variables',
        pt: 'Digite "/" para inserir um template sem variáveis',
    },
    'Note: templates are only offered here if allowed for the teams and, when official, approved for the channels of all selected conversations, so some templates may not appear. If a specific conversation still fails to receive it, the result for that item will show the reason.':
        {
            en: 'Note: templates are only offered here if allowed for the teams and, when official, approved for the channels of all selected conversations, so some templates may not appear. If a specific conversation still fails to receive it, the result for that item will show the reason.',
            pt: 'Observação: aqui só são oferecidos templates liberados para os times e, quando oficiais, aprovados nos canais de todos os atendimentos selecionados, então alguns templates podem não aparecer. Se algum atendimento específico ainda assim não receber, o resultado daquele item mostrará o motivo.',
        },
    'Template not found for this conversation channel': {
        en: 'Template not found for this conversation channel',
        pt: 'Template não encontrado para o canal deste atendimento',
    },
    'This template is not approved for this conversation channel': {
        en: 'This template is not approved for this conversation channel',
        pt: 'Este template não está aprovado para o canal deste atendimento',
    },
    'An official template is required to send messages in this conversation': {
        en: 'An official template is required to send messages in this conversation',
        pt: 'É necessário um template oficial para enviar mensagens neste atendimento',
    },
    'Not assigned to a team yet: assume and transfer it first to select for bulk actions': {
        en: 'Not assigned to a team yet: assume and transfer it first to select for bulk actions',
        pt: 'Ainda não atribuído a um time: assuma e transfira primeiro para selecionar em ações em lote',
    },
    'Closed conversations cannot be selected here': {
        en: 'Closed conversations cannot be selected here',
        pt: 'Atendimentos encerrados não podem ser selecionados aqui',
    },
    'Internal chat': {
        en: 'Internal chat',
        pt: 'Chat interno',
    },
    'Auto-assign': {
        en: 'Auto-assign',
        pt: 'Atribuir automaticamente',
    },
    'Start new conversation': {
        en: 'Start new conversation',
        pt: 'Iniciar nova conversa',
    },
    'No conversations yet': {
        en: 'No conversations yet',
        pt: 'Nenhuma conversa ainda',
    },
    Attachment: {
        en: 'Attachment',
        pt: 'Anexo',
    },
    'Load previous messages': {
        en: 'Load previous messages',
        pt: 'Carregar mensagens anteriores',
    },
    'Write a message...': {
        en: 'Write a message...',
        pt: 'Escreva uma mensagem...',
    },
    'Select a conversation to start': {
        en: 'Select a conversation to start',
        pt: 'Selecione uma conversa para começar',
    },
    'Deleted in homologation': {
        pt: 'Deletado em homologação',
        en: 'Deleted in homologation',
    },
    'Deleted in homologation. Publish to production to remove it for good.': {
        pt: 'Deletado em homologação. Publique em produção para remover de vez.',
        en: 'Deleted in homologation. Publish to production to remove it for good.',
    },
    'Why are you publishing?': {
        pt: 'Por que você está publicando?',
        en: 'Why are you publishing?',
    },
    'Ticket ID or a short summary of what is going up': {
        pt: 'Resumo curto do que está subindo',
        en: 'Short summary of what is going up',
    },
    'Minimum of': {
        pt: 'Mínimo de',
        en: 'Minimum of',
    },
    'Could not load what will be published. Try again.': {
        pt: 'Não foi possível carregar o que será publicado. Tente novamente.',
        en: 'Could not load what will be published. Try again.',
    },
    'flow(s) pending publication in homologation.': {
        pt: 'fluxo(s) pendente(s) de publicação em homologação.',
        en: 'flow(s) pending publication in homologation.',
    },
    'Publish this flow to homologation first.': {
        pt: 'Publique este fluxo em homologação primeiro.',
        en: 'Publish this flow to homologation first.',
    },
    'There is nothing pending to publish.': {
        pt: 'Não há nada pendente para publicar.',
        en: 'There is nothing pending to publish.',
    },
    'This flow will be published:': {
        pt: 'Este fluxo será publicado:',
        en: 'This flow will be published:',
    },
    'flow(s) will be published:': {
        pt: 'fluxo(s) serão publicados:',
        en: 'flow(s) will be published:',
    },
    'All changes will be included.': {
        pt: 'Todas as alterações serão incluídas.',
        en: 'All changes will be included.',
    },
    'No description': {
        pt: 'Sem descrição',
        en: 'No description',
    },
    Modified: {
        pt: 'Alterado',
        en: 'Modified',
    },
    'Published by the flow assistant': {
        pt: 'Publicado pelo assistente de fluxo',
        en: 'Published by the flow assistant',
    },
    'Published to homologation by': {
        pt: 'Publicado em homologação por',
        en: 'Published to homologation by',
    },
    'Published to production by': {
        pt: 'Publicado em produção por',
        en: 'Published to production by',
    },
    'Deleted by': {
        pt: 'Deletado por',
        en: 'Deleted by',
    },
    'Unknown user': {
        pt: 'Usuário desconhecido',
        en: 'Unknown user',
    },
    'Version history': {
        pt: 'Histórico de versões',
        en: 'Version history',
    },
    'Published by': {
        pt: 'Publicado por',
        en: 'Published by',
    },
    'Restore version': {
        pt: 'Restaurar versão',
        en: 'Restore version',
    },
    Restore: {
        pt: 'Restaurar',
        en: 'Restore',
    },
    Restoration: {
        pt: 'Restauração',
        en: 'Restoration',
    },
    'Publication history': {
        pt: 'Histórico de publicações',
        en: 'Publication history',
    },
    'All environments': {
        pt: 'Todos os ambientes',
        en: 'All environments',
    },
    'Failed to load publication history': {
        pt: 'Falha ao carregar o histórico de publicações',
        en: 'Failed to load publication history',
    },
    Deletion: {
        pt: 'Exclusão',
        en: 'Deletion',
    },
    'The flow will be restored and published to homologation.': {
        pt: 'O fluxo será restaurado e publicado em homologação.',
        en: 'The flow will be restored and published to homologation.',
    },
    'The flow will be restored and published to homologation and production.': {
        pt: 'O fluxo será restaurado e publicado em homologação e produção.',
        en: 'The flow will be restored and published to homologation and production.',
    },
    'Restored and published to homologation, but production is blocked by pending changes.': {
        pt: 'Restaurado e publicado em homologação, mas a produção está bloqueada por pendências.',
        en: 'Restored and published to homologation, but production is blocked by pending changes.',
    },
    'Version restored successfully': {
        pt: 'Versão restaurada com sucesso',
        en: 'Version restored successfully',
    },
    'Failed to load versions': {
        pt: 'Falha ao carregar as versões',
        en: 'Failed to load versions',
    },
    Homologation: {
        pt: 'Homologação',
        en: 'Homologation',
    },
    Production: {
        pt: 'Produção',
        en: 'Production',
    },
    Version: {
        pt: 'Versão',
        en: 'Version',
    },
    Total: {
        pt: 'Total',
        en: 'Total',
    },
    'Sending in': {
        pt: 'enviando em',
        en: 'sending in',
    },
    'Sending…': {
        pt: 'Enviando…',
        en: 'Sending…',
    },
    'Being edited': {
        pt: 'Em edição',
        en: 'Being edited',
    },
    'Not sent': {
        pt: 'Não enviada',
        en: 'Not sent',
    },
    'conversation closed': {
        pt: 'conversa encerrada',
        en: 'conversation closed',
    },
    'agent removed from the conversation': {
        pt: 'atendente removido da conversa',
        en: 'agent removed from the conversation',
    },
    'service window expired': {
        pt: 'janela de atendimento expirada',
        en: 'service window expired',
    },
    'error while sending': {
        pt: 'erro ao enviar',
        en: 'error while sending',
    },
    'Copy text': {
        pt: 'Copiar texto',
        en: 'Copy text',
    },
    'Text copied': {
        pt: 'Texto copiado',
        en: 'Text copied',
    },
    'Erase message': {
        pt: 'Apagar',
        en: 'Delete',
    },
    'Editing message': {
        pt: 'Editando mensagem',
        en: 'Editing message',
    },
    'Cancel editing': {
        pt: 'Cancelar edição',
        en: 'Cancel editing',
    },
    'Only the author can change this message': {
        pt: 'Só o autor pode alterar esta mensagem.',
        en: 'Only the author can change this message.',
    },
    'The message is already being sent and can no longer be changed': {
        pt: 'A mensagem já está sendo enviada e não pode mais ser alterada.',
        en: 'The message is already being sent and can no longer be changed.',
    },
    'The edit has ended. Your text is still in the message box': {
        pt: 'A edição terminou. Seu texto continua na caixa de mensagem.',
        en: 'The edit has ended. Your text is still in the message box.',
    },
    'Type a message before saving': {
        pt: 'Digite uma mensagem antes de salvar.',
        en: 'Type a message before saving.',
    },
    'Could not change the message. Try again': {
        pt: 'Não foi possível alterar a mensagem. Tente novamente.',
        en: 'Could not change the message. Try again.',
    },
    'Message options': {
        pt: 'Opções da mensagem',
        en: 'Message options',
    },
    'there is still time to add text': {
        pt: 'ainda dá para adicionar texto',
        en: 'there is still time to add text',
    },
    'Undo and edit': {
        pt: 'Desfazer e editar',
        en: 'Undo and edit',
    },
    'Review the message before sending': {
        pt: 'Revise a mensagem antes de enviar',
        en: 'Review the message before sending',
    },
    'Your previous message is on hold. Nothing will be sent while you decide.': {
        pt: 'Sua mensagem anterior está suspensa. Nada será enviado enquanto você decide.',
        en: 'Your previous message is on hold. Nothing will be sent while you decide.',
    },
    'Why am I seeing this?': {
        pt: 'Por que está vendo isso?',
        en: 'Why am I seeing this?',
    },
    Before: {
        pt: 'Antes',
        en: 'Before',
    },
    'Original texts · not sent': {
        pt: 'Textos originais · não enviados',
        en: 'Original texts · not sent',
    },
    'First message': {
        pt: 'Primeira mensagem',
        en: 'First message',
    },
    'Will be sent': {
        pt: 'Será enviado',
        en: 'Will be sent',
    },
    'A single message': {
        pt: 'Uma única mensagem',
        en: 'A single message',
    },
    'Message that will be sent': {
        pt: 'Mensagem que será enviada',
        en: 'Message that will be sent',
    },
    'Confirm message': {
        pt: 'Confirmar mensagem',
        en: 'Confirm message',
    },
    'The 8s countdown restarts after joining, so you can still add to it.': {
        pt: 'O contador de 8s reinicia após juntar, para você ainda poder complementar.',
        en: 'The 8s countdown restarts after joining, so you can still add to it.',
    },
    'Online scheduling': {
        pt: 'Agendamento online',
        en: 'Online scheduling',
    },
    'Attached documents': {
        pt: 'Documentos anexados',
        en: 'Attached documents',
    },
};
